import React, { Component, useState, useEffect, } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  Collapse,
  FormGroup,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Popover,
  PopoverHeader,
  PopoverBody,
  ListGroup,
  ListGroupItem,
  Button, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, UncontrolledTooltip,
  Badge,
  NavItem, NavLink, Nav, Navbar, NavbarToggler, UncontrolledPopover
} from "reactstrap";
import {
  Link
} from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import ReactTable from "react-table";
import Select from "react-select";
import SplitCells from '../../components/Notebook/SplitCells';
import { Scrollbars } from 'react-custom-scrollbars';
import ClusterService from '../../services/api/Cluster';
import moment from 'moment'
import { FilePond } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import StorageService from '../../services/api/Storage';
import ConnectorService from '../../services/api/Connector';
import ModelSpaceService from '../../services/api/Modelspace';
import axios from 'axios'
import page404 from "assets/img/404.png";
import awsbucket from "assets/img/awsbucket.png";
import undefinedfile from "assets/img/undefined.PNG";
import unknownfile from "assets/img/undefinedfile.PNG";
import { JsonToTable } from "react-json-to-table";

import {
  NOTEBOOK_WS_CONNETING_TIMER, NOTEBOOK_WS_NOT_RECEIVE, modelSpaceMount,
  default_StorageName, default_LabelStorageName, STORAGE_DEFAULT_MOUNT_PATH, STORAGE_EXTERNAL_MOUNT_PATH, VERSIONTIMEOUT
} from '../../settings/shared/constants';
import { provisioners, HandsonTableKey } from '../../settings/shared/constants'

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import path from 'path';
import CommonService from '../../services/api/Common'
import TinyURL from "tinyurl";
import FileJobsService from '../../services/api/FileJobs';
import { uuidv4, addNewCodeAfter, moveupCell, movedownCell, removeCell, addNewMarkDownAfter, clearCellOutputByIndex, addEmptyCodeCell } from 'components/Notebook/operations/notebook';
import { saveFile } from 'components/Notebook/operations/file_handler';
import { establishWSConnection } from 'components/Notebook/operations/execution_handler';
import { findIcon, imageFileExtension, connectorsTypeLogo, provisionerTypeLogo } from "../../settings/shared/commonMethod"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Editor from 'react-simple-code-editor';

import Prism from 'prismjs';
import "prismjs/themes/prism.css";
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-python.min.js';
import 'prismjs/components/prism-python';
import { highlight, languages } from 'prismjs';
import 'assets/css/bc.scss'
import { CheckIsValidDomain, CSVToJSONs } from "../../settings/shared/commonMethod";
import Switch from "react-bootstrap-switch";
import ReactPaginate from 'react-paginate';
import RunService from '../../services/api/Run';
import StorageConfigService from '../../services/api/StorageConfig';
import { Tabs as ModalTabs } from 'react-web-tabs';
import { Tab as ModalTab } from 'react-web-tabs';
import { TabPanel as ModalTabPanel } from 'react-web-tabs';
import { TabList as ModalTabList } from 'react-web-tabs';
import Progress from 'react-progressbar';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import MountBucket from "components/MountStorage/MountBucket";
import KeyboardShortcuts from 'components/Modelspace/KeyboardShortcuts';
import Versioning from 'components/Versioning/Versioning'
import { HotTable } from '@handsontable/react';
import { registerAllModules } from 'handsontable/registry';
import { HyperFormula } from 'hyperformula';
import PdfViewer from 'components/PdfViewer/PdfViewer';
import * as XLSX from "xlsx";

// register Handsontable's modules
registerAllModules();

const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }
}

const delimiteroptions = [
  { label: "Comma Seperated Value (,)", value: "," },
  { label: "Pipe Seperated Value (|)", value: "|" }
];
// const ipynb2html = window.ipynb2html;
const trimFolderName = folderName => {
  folderName = folderName.slice(0, -1);
  return folderName.split('/').pop()
};
const trimFileName = fileName => {
  return fileName.split('/').pop()
};
const AddStorageItems = props => {
  let items = [];

  const {
    isSideSplited,
    splitscreen,
    folders,
    files,
    loadmoreFlag,
    showFilesModal,
    nextPageToken,
    loadflagStorage,
    viewSelected,
    sourceStorageId,
    sourceRootFolder,
    configArray
  } = props;

  const [isShowContext, setShowContext] = useState(false)

  const [showRenameModal, setshowRenameModal] = useState(false)

  const [renameToBeCreate, setrenameToBeCreate] = useState("")

  const showContext = () => setShowContext(true)
  const hideContext = () => setShowContext(false)

  const [isGetExtract, setExtractAction] = useState(false)

  const showExtract = () => setExtractAction(true)
  const hideExtract = () => setExtractAction(false)

  const [contextMargin, setContextMargin] = useState(null)
  const setContextMenuMargin = (margin) => setContextMargin(margin)

  const [selectedFiles, setSelectedFiles] = useState([])
  const [selectedFolders, setSelectedFolders] = useState([])

  const [isFileAction, setFileAction] = useState(false)
  const enableDisableViewDownload = () => {
    if (selectedFolders.length === 0 && selectedFiles.length === 1) {
      setFileAction(true)
    } else {
      setFileAction(false)
    }
  }
  const [isAllFolders, setAllFolders] = useState(false)
  const showpopupFolders = () => setAllFolders(true)
  const onFolderClick = (event, folderName) => {
    let fname = folderName;
    const target = event.currentTarget
    if (target.dataset.id === folderName) {
      target.className = "py-2 storage-item folderitem row active";
    }
    event.stopPropagation()
    event.preventDefault()
    props.fetchStorageItems(fname, deselectAll)
  }

  const openStorageView = (name, event) => {
    event.preventDefault()
    let newUrl;
    let currentUrl = window.location.href;
    newUrl = currentUrl.split("?path=");
    let reg = "/modelspace";
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    let redirectUrl = newUrl[0].replace(reg, "/storageView?storage=" + sName + "&root=" + root + "&file=" + name);
    window.open(redirectUrl, "_blank");
  }
  const downloadFile = (name, event) => {
    event.preventDefault()
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    localStorage.setItem("filePathStorage", name);
    let myPath = localStorage.getItem("filePathStorage");
    StorageService.downloadObjectUrl(myPath, sName, root)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  const copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>);
  }

  const toggleRenameModal = () => {
    if (showRenameModal) {
      setshowRenameModal(false)
    } else {
      setshowRenameModal(true)
    }
    hideContext()
    deselectAll()
  }

  const handleRenameChange = (event) => {
    setrenameToBeCreate(event.target.value);
  }

  const renameUpdate = (event) => {
    event.preventDefault();
    if (renameToBeCreate === "" || renameToBeCreate === undefined) {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please enter name</b></i>);
    } else {
      toggleRenameModal();
      props.renameFile(renameToBeCreate);
    }
  }


  const popPathName = (path) => {
    var replacedPath = path.replace(/\/$/, '');
    var rename = replacedPath.split('/').pop();
    return rename;
  }

  /*  rename file/folder  */
  const onRenameClick = (event, fileName, isDir) => {
    event.preventDefault()
    let name = fileName;
    props.selectMoveFile(name, "Move", isDir)
    let renamewats = popPathName(name)
    setrenameToBeCreate(renamewats);
    toggleRenameModal();
    hideContext()
    deselectAll()
  }



  const GetLink = (name, event) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let newUrl;
    let currentUrl = window.location.href;
    newUrl = currentUrl.split("?path=");
    let reg = "/modelspace";
    let sName = sourceStorageId === null ? "" : sourceStorageId;
    let root = sourceRootFolder === null ? "" : sourceRootFolder;
    let redirectUrl = newUrl[0].replace(reg, "/storageView?storage=" + sName + "&root=" + root + "&file=" + name);
    TinyURL.shorten(redirectUrl).then((res) => {
      var tempInput = document.createElement("input");
      tempInput.value = res;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      copyAlert()
    })
  }

  const GetExtract = (name, event) => {
    event.preventDefault()
    let isDirectory = !isFileAction
    let destifolder = props.currFolder;
    if (destifolder == null) {
      destifolder = "/"
    }
    let extractdata = {
      "destinationPath": destifolder,
      "paths": [
        {
          "isDir": isDirectory,
          "sourcePath": name

        }
      ],
      "sourcePath": [
        name
      ],
      "storageType": "GOOGLE"
    }
    FileJobsService.ExtractFile(extractdata)
      .then((response) => {
        props.fetchProgress(response.jobState, response.message)
        setTimeout(() => {
          props.fetchStorageItems(props.currFolder, null, isSideSplited)
        }, 3000);


      });
  }

  const onRowClick = (event, itemType, itemName) => {
    event.preventDefault()
    const target = event.currentTarget
    target.dataset.select = true
    if (itemType !== "folder") {
      props.previewFile(itemName, itemType, sourceStorageId, sourceRootFolder)
    }
  }
  const deselectAll = () => {
    let classNameOfSelectedItem;
    let classNameToBeAdd;
    if (viewSelected === 1) {
      classNameOfSelectedItem = 'storage-item-select'
      classNameToBeAdd = 'py-2 storage-item row folderitem'
    } else {
      classNameOfSelectedItem = 'card-item-select'
      classNameToBeAdd = 'card-item card'
    }
    const elems = [].slice.call(document.getElementsByClassName(classNameOfSelectedItem))
    for (const elem of elems) {
      elem.dataset.select = false
      elem.className = classNameToBeAdd
    }
    setSelectedFolders([])
    setSelectedFiles([])
  }
  const addItemToSelected = (itemType, itemName) => {
    if (itemType === 'file') {
      const _selectedFiles = selectedFiles
      if (_selectedFiles.indexOf(itemName) === -1) {
        _selectedFiles.push(itemName)
        setSelectedFiles(_selectedFiles)
      }
    } else if (itemType === 'folder') {
      const _selectedFolders = selectedFolders
      if (_selectedFolders.indexOf(itemName) === -1) {
        _selectedFolders.push(itemName)
        setSelectedFolders(_selectedFolders)
      }
    }
  }

  const [isShowMenu, setShowMenu] = useState(false)
  const [isShowMenuName, setShowMenuName] = useState()

  const showMenu = (itemName) => {
    setShowMenu(true)
  }

  const hideMenu = () => setShowMenu(false)

  const handleMouseHover = (event, itemType, itemName) => {
    if (itemName !== "emptyfolder") {
      const target = event.currentTarget;
      if (target.dataset.id === itemName) {
        target.className = "py-2 storage-item folderitem row active";
        showMenu(itemName)
        setShowMenuName(itemName)
      }
      else {
        target.className = "py-2 storage-item folderitem row";
        hideMenu()
      }
      const getextnzip = trimFileName(itemName).substr(trimFileName(itemName).lastIndexOf('.') + 1);
      if ((getextnzip === "zip") || (getextnzip === "tar") || (getextnzip === "rar") || (getextnzip === "gz")) {
        showExtract()
      }
      else {
        hideExtract()
      }
    }
    event.preventDefault()
    setSelectedFiles([])
    setSelectedFolders([])
    addItemToSelected(itemType, itemName)
    enableDisableViewDownload()

  }
  const handleMouseLeave = (event) => {
    event.preventDefault()
    hideMenu()
  }
  /* View File   */
  const onViewClick = (event, fileName) => {
    event.preventDefault()
    openStorageView(fileName, event)
    hideContext()
    deselectAll()
  }
  /* Download File   */
  const onDownloadClick = (event, fileName) => {
    event.preventDefault()
    downloadFile(fileName, event)
    hideContext()
    deselectAll()

  }
  /* get Shareable link  */
  const onShareClick = (event, fileName) => {
    event.preventDefault()
    GetLink(fileName, event)
    hideContext()
    deselectAll()

  }
  /* Extract Folder */
  const onExtractClick = (event, fileName) => {
    event.preventDefault()
    GetExtract(fileName, event)
    hideContext()
    deselectAll()

  }
  /* Move file/folder  */
  const onMoveClick = (event, fileName, isDir) => {
    event.preventDefault()
    let name = fileName;
    let movewats = name
    let ShowFold = "true"
    showpopupFolders()
    props.toggleShowFiles(props.currFolder, ShowFold, movewats, "Move", isDir)
    hideContext()
    deselectAll()

  }
  /*  Paste file/folder  */
  const onPasteClick = (event, fileName) => {
    let name = fileName
    let isDirectory = !isFileAction
    let pastedetails = name
    props.pasteFolder(isSideSplited, pastedetails, isDirectory)
    hideContext()
    deselectAll()

  }
  /*  Copy file/folder  */
  const onCopyClick = (event, fileName, isDir) => {
    event.preventDefault()
    let name = fileName
    let copywats = name
    let ShowFold = "true"
    showpopupFolders()
    props.toggleShowFiles(props.currFolder, ShowFold, copywats, "Copy", isDir)
    props.selectCopyFile(copywats, "Copy", isDir)
    hideContext()
    deselectAll()

  }

  /* copy file path */
  const onCopyPathClick = (event, path) => {
    event.preventDefault()
    if (configArray !== undefined && configArray !== null && configArray.length > 0) {
      let filterArray = configArray.filter(item => item.id === sourceStorageId);
      let prefixPath = "";
      if (filterArray.length > 0) {
        let sName = filterArray[0].name;
        let platfromDefault = filterArray[0].platformDefault;
        if (platfromDefault) {
          prefixPath = STORAGE_DEFAULT_MOUNT_PATH;
        } else {
          prefixPath = STORAGE_EXTERNAL_MOUNT_PATH + sName + "/" + sourceRootFolder + "/";
        }
        if (path !== undefined) {
          var filepath = document.createElement('textarea')
          filepath.innerText = prefixPath + path
          document.body.appendChild(filepath)
          filepath.select()
          document.execCommand('copy')
          filepath.remove()
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied</b></i>);
        }
      }
    }
  }

  /*  Delete/Trash file/folder  */
  const onDeleteClick = (event, fileName, deleteevent) => {
    event.preventDefault()
    let name = fileName;
    let isDirectory = !isFileAction
    const title = isFileAction ? 'Delete File' : 'Delete Folder'
    const message = (
      isFileAction
        ? 'Are you sure to delete this file -' + trimFileName(name) + '?'
        : 'Are you sure to delete this folder -' + trimFolderName(name) + '?'
    )
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        {
          label: 'Yes',
          onClick: e => {
            let destifolder = "";
            let sourcefolder = name;
            let movetotrashdata = {
              "destinationPath": destifolder,
              "paths": [
                {
                  "isDir": isDirectory,
                  "sourcePath": sourcefolder

                }
              ],
              "sourceStorage": {
                "rootFolder": sourceRootFolder,
                "storageId": sourceStorageId
              }
            }
            if (sourceStorageId === null) {
              delete movetotrashdata["sourceStorage"]
            }
            /*  Move to Trash */
            if (deleteevent === "Trash") {
              FileJobsService.TrashFolder(movetotrashdata)
                .then((response) => {
                  props.fetchProgress(response.jobState, response.message)
                  props.fetchStorageItems(props.currFolder, null)
                });
            }
            /*  Delete From Trash */
            if (deleteevent === "Delete") {
              let sourcefolder = name;
              let deletedata = {
                "destinationPath": destifolder,
                "paths": [
                  {
                    "isDir": isDirectory,
                    "sourcePath": sourcefolder

                  }
                ],
                "sourceStorage": {
                  "rootFolder": sourceRootFolder,
                  "storageId": sourceStorageId
                }
              }
              if (sourceStorageId === null) {
                delete deletedata["sourceStorage"]
              }
              FileJobsService.DeleteFolder(deletedata)
                .then((response) => {
                  props.fetchProgress(response.jobState, response.message)
                  props.fetchStorageItems(props.currFolder, null)
                });
            }
          }
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    })
    hideContext()
    deselectAll()

  }
  /* Restore file/folder  */
  const onRestoreClick = (event, fileName) => {
    event.preventDefault()
    let name = fileName
    let isDirectory = !isFileAction
    const title = isFileAction ? 'Restore File' : 'Restore Folder'
    const message = (
      isFileAction
        ? 'Are you sure to restore this file -' + trimFileName(name) + '?'
        : 'Are you sure to restore this folder -' + trimFolderName(name) + '?'
    )
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        {
          label: 'Yes',
          onClick: e => {
            let destifolder = "";
            let sourcefolder = name;
            let restoredata = {
              "destinationPath": destifolder,
              "paths": [
                {
                  "isDir": isDirectory,
                  "sourcePath": sourcefolder

                }
              ],
              "sourceStorage": {
                "rootFolder": sourceRootFolder,
                "storageId": sourceStorageId
              }
            }
            if (sourceStorageId === null) {
              delete restoredata["sourceStorage"]
            }
            FileJobsService.RestoreFile(restoredata)
              .then((response) => {
                props.fetchProgress(response.jobState, response.message, isSideSplited)
                props.fetchStorageItems(props.currFolder, null, isSideSplited)
              })

          }
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    })
    hideContext()
    deselectAll()

  }
  const mouseDownEvent = (event) => {
    if (event.target.dataset.type !== 'context' && isShowContext) {
      hideContext()
      deselectAll()

    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", mouseDownEvent)
    Prism.highlightAll();

    return () => {
      document.removeEventListener("mousedown", mouseDownEvent)
    }
  }, [isShowContext])
  for (const folder of folders) {
    const folderName = trimFolderName(folder)
    items.push(
      <div key={uuidv4()}>
        <Row
          tag="a"
          className="py-2 storage-item folderitem"
          data-id={folderName}
          onMouseEnter={e => { handleMouseHover(e, 'folder', folderName) }}
          onMouseLeave={handleMouseLeave}
          title={folderName}
        >
          <Col md="10" xs="10" onContextMenu={e => e.preventDefault()}>
            <div className="overflowStyle">
              <span
                className="folder"
                data-type="folder"
                data-id={folder}
                data-name={folder}
                onClick={e => { onRowClick(e, 'folder', folder); onFolderClick(e, folder); }}
              >
                <i className="fas fa-folder mr-3"></i>{folderName}
              </span>
            </div>
          </Col>
          {isShowMenuName === folderName &&
            <Col md="2" xs="2" className="storagetxt" id={folderName}>
              <div className="">
                <UncontrolledDropdown direction="down">
                  <DropdownToggle tag="span" className="pointerclass"
                    onClick={e => e.preventDefault()} >
                    <i className="fas fa-ellipsis-v font12" />
                  </DropdownToggle>
                  <DropdownMenu persist right className="dropdown-menu-arrow" flip={false} modifiers={{
                    flip: {
                      behavior: "flip",
                      enabled: true
                    }, preventOverflow: { boundariesElement: 'window' }
                  }}>
                    {props.itstrash && <div>
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, folder, 'Delete') }} className="storagedropdown pointerclass">
                        <span>  <i className="fas fa-trash-alt mr-3" />Delete</span>
                      </DropdownItem>
                      <DropdownItem href="" onClick={e => { onRestoreClick(e, folder) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-restore mr-3" />Restore</span>
                      </DropdownItem>
                    </div>
                    }
                    {!props.itstrash && <div>
                      {!showFilesModal && <><DropdownItem href="" onClick={e => { onMoveClick(e, folder, true) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-file-export mr-3" />Move</span>
                      </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyClick(e, folder, true) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-copy mr-3" />Copy</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onRenameClick(e, folder, true) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-edit mr-3" />Rename</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyPathClick(e, folder, true) }} className="storagedropdown pointerclass">
                          <span> <i className="fas fa-copy mr-3" />Copy Path</span>
                        </DropdownItem></>}
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, folder, 'Trash') }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-alt mr-3" />Move to trash</span>
                      </DropdownItem>
                    </div>
                    }
                    <DropdownItem divider />
                    {isGetExtract && <div>
                      <DropdownItem href="" onClick={e => { onExtractClick(e, folder) }} className="storagedropdown pointerclass" disabled={!isFileAction}>
                        <span>  <i className="fas fa-box-open mr-3" />Extract</span>
                      </DropdownItem>
                    </div>
                    }
                    <DropdownItem href="" className="storagedropdown pointerclass Permissioncolor" disabled>
                      <span>  <i className="fas fa-info-circle mr-3" />Permission</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Col>
          }
        </Row>

      </div>
    )
  }

  for (const file of files) {
    const fileName = trimFileName(file.name)
    items.push(
      <div key={uuidv4()} >
        <Row
          key={uuidv4()}
          tag="a"
          className={isShowMenuName === fileName ? "py-2 storage-item folderitem active" : "py-2 storage-item folderitem"}
          data-id={fileName}
          onMouseEnter={e => { handleMouseHover(e, 'file', fileName) }}
          onMouseLeave={handleMouseLeave}
          title={fileName}
        >
          <Col md="10" xs="10" className="storagetxt" onContextMenu={e => e.preventDefault()}>
            <div className="overflowStyle">
              <span id={fileName}
                data-id={file.name}
                className="storage-file"
                onClick={e => {
                  e.stopPropagation()
                  onRowClick(e, 'file', file.name)
                }}          >
                &nbsp; <img src={findIcon(imageFileExtension(file.content_type))} alt="" ></img> &nbsp;
              {fileName}
              </span>
            </div>
          </Col>
          {isShowMenuName === fileName &&
            <Col md="2" xs="2" className="storagetxt" >
              <div className="">
                <UncontrolledDropdown direction="down">
                  <DropdownToggle tag="span"
                    onClick={e => e.preventDefault()}
                    style={{ cursor: 'pointer' }}>
                    <i className="fas fa-ellipsis-v font12" />
                  </DropdownToggle>
                  <DropdownMenu persist right className="dropdown-menu-arrow" flip={false} modifiers={{
                    flip: {
                      behavior: "flip",
                      enabled: true
                    }, preventOverflow: { boundariesElement: 'window' }
                  }}>
                    <DropdownItem href="" onClick={e => { onViewClick(e, file.name) }} className="storagedropdown pointerclass">
                      <span> <i className="fas fa-binoculars mr-3" />View </span>
                    </DropdownItem>
                    <DropdownItem href="" onClick={e => { onDownloadClick(e, file.name) }} className="storagedropdown pointerclass" >
                      <span> <i className="fas fa-download mr-3" />Download </span>
                    </DropdownItem>
                    <DropdownItem href="" onClick={e => { onShareClick(e, file.name) }} className="storagedropdown pointerclass" >
                      <span>  <i className="fas fa-link mr-3"></i>Get Sharable Link</span>
                    </DropdownItem>
                    <DropdownItem divider />
                    {props.itstrash && <div>
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, file.name, 'Delete') }} className="storagedropdown pointerclass">
                        <span>  <i className="fas fa-trash-alt mr-3" />Delete</span>
                      </DropdownItem>
                      <DropdownItem href="" onClick={e => { onRestoreClick(e, file.name) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-restore mr-3" />Restore</span>
                      </DropdownItem>
                    </div>
                    }
                    {!props.itstrash && <div>
                      {!showFilesModal && <><DropdownItem href="" onClick={e => { onMoveClick(e, file.name, false) }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-file-export mr-3" />Move</span>
                      </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyClick(e, file.name, false) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-copy mr-3" />Copy</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onRenameClick(e, file.name, false) }} className="storagedropdown pointerclass" >
                          <span>  <i className="fas fa-edit mr-3"></i>Rename</span>
                        </DropdownItem>
                        <DropdownItem href="" onClick={e => { onCopyPathClick(e, file.name, false) }} className="storagedropdown pointerclass">
                          <span>    <i className="fas fa-copy mr-3" />Copy Path</span>
                        </DropdownItem></>}
                      <DropdownItem href="" onClick={e => { onDeleteClick(e, file.name, 'Trash') }} className="storagedropdown pointerclass">
                        <span>   <i className="fas fa-trash-alt mr-3" />Move to trash</span>
                      </DropdownItem>
                    </div>
                    }
                    {isGetExtract && <div>
                      <DropdownItem href="" onClick={e => { onExtractClick(e, file.name) }} className="storagedropdown pointerclass" >
                        <span>  <i className="fas fa-box-open mr-3" />Extract</span>
                      </DropdownItem>
                    </div>
                    }
                    <DropdownItem divider />
                    <DropdownItem href="" className="storagedropdown disabled" style={{ backgroundColor: 'rgb(238, 238, 238)' }} disabled>
                      <span>  <i className="fas fa-info-circle mr-3" />Permission</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Col>
          }
        </Row>
      </div>
    )
  }
  if (nextPageToken !== null || nextPageToken === null) {
    items.push(
      <>
        <Row
          tag="a"
          className="rowStylecss"
          key={uuidv4()}
        >
          <span className="folder">. </span>
          <Col md="7" xs="7" className="">

          </Col>
          <Col md="2" xs="2" className="storagetxt"></Col>
          <Col md="3" xs="3" className="storagetxt"></Col>
        </Row>
        {loadflagStorage && <Row>
          <Col className="textcenter">
            <ButtonGroup className="chatLoading verticalAligntxt" >
              <Badge color="info"> Loading... </Badge>
            </ButtonGroup>
          </Col>
        </Row>}
        <Row>
          <Col className="textcenter">
            {nextPageToken !== null && loadmoreFlag && <ButtonGroup className="chatLoading verticalAligntxt" >
              <Badge color="info"> Loading... </Badge>
            </ButtonGroup>}
          </Col>
        </Row>
        {nextPageToken === null && <Row>
          <Col className="textcenter">
            <span className="pageend">-- Page End --</span>
          </Col>
        </Row>}
      </>
    )
  }
  let itemsView;
  itemsView = items

  // return items
  return (
    <div>

      { isShowContext &&
        <Row>
          <Col
            md="auto"
            id="context-menu"
            className="storage-context"
            style={contextMargin}
          >
            <ListGroup flush>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a" data-type='context'
                onClick={onViewClick}
              >
                <i className="fas fa-binoculars mr-3" />View
            </ListGroupItem>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a" data-type='context'
                onClick={onDownloadClick}
              >
                <i className="fas fa-download mr-3" />Download
            </ListGroupItem>
              <ListGroupItem
                disabled={!isFileAction}
                tag="a"
                data-type='context'
                onClick={onShareClick}>
                <i className="fas fa-link mr-3"></i>Get Sharable Link
            </ListGroupItem>
            </ListGroup>

            <hr />
            <ListGroup flush>

              {props.itstrash &&
                <ListGroup flush>
                  <ListGroupItem
                    tag="a" data-type='context'
                    onClick={e => { onDeleteClick(e, 'Delete') }}
                  >
                    <i className="fas fa-trash-alt mr-3" />Delete
            </ListGroupItem>
                  <ListGroupItem
                    tag="a" data-type='context'
                    onClick={e => { onRestoreClick(e) }}
                  >
                    <i className="fas fa-trash-restore mr-3" />Restore
           </ListGroupItem>
                </ListGroup>

              }

              {!props.itstrash &&
                <ListGroup flush>
                  <ListGroupItem disabled tag="a" data-type='context'>
                    <i className="fas fa-copy mr-3" />Duplicate
          </ListGroupItem>
                  <ListGroupItem tag="a" data-type='context' onClick={e => { onMoveClick(e) }}>
                    <i className="fas fa-file-export mr-3" />Move
          </ListGroupItem>
                  <ListGroupItem tag="a" data-type='context' onClick={e => { onCopyClick(e) }}>
                    <i className="fas fa-copy mr-3" />Copy
          </ListGroupItem>
                  <ListGroupItem
                    tag="a" data-type='context' onClick={e => { onDeleteClick(e, 'Trash') }}>
                    <i className="fas fa-trash-alt mr-3" />Move to trash
            </ListGroupItem>
                  {isGetExtract &&
                    <ListGroupItem
                      disabled={!isFileAction}
                      tag="a" data-type='context'
                      onClick={onExtractClick}
                    >
                      <i className="fas fa-box-open mr-3" />Extract
            </ListGroupItem>
                  }


                </ListGroup>
              }
              <ListGroupItem
                disabled={!splitscreen || isFileAction}
                tag="a" data-type='context'
                onClick={e => { onPasteClick(e) }}>
                <i className="fas fa-paste mr-3" />Paste
            </ListGroupItem>


              <ListGroupItem disabled tag="a" data-type='context'>
                <i className="fas fa-file mr-3" />Rename
            </ListGroupItem>
              <ListGroupItem className="listpermission" data-type='context'>
                <i className="fas fa-info-circle mr-3" />Permission
            </ListGroupItem>

            </ListGroup>
          </Col>
        </Row>
      }
      {itemsView}
      <Modal
        centered
        className="rename-modal"
        isOpen={showRenameModal}
        toggle={toggleRenameModal}
        backdrop="static"
        returnFocusAfterClose={false}>
        <ModalHeader toggle={toggleRenameModal}>Rename</ModalHeader>
        <ModalBody>
          <Input
            placeholder="Folder Name"
            name="folderToBeCreate"
            className="inputRename"
            value={renameToBeCreate}
            onChange={handleRenameChange}
          />

          <Row>
            <Col sm="12" className="renamepopHint">
              <span className="notepopHint">Note: </span><span>Update reference of 'Renamed' folder/file in Project</span>
            </Col>
          </Row>
          <Row>
            <Col xl="12">
              <FormGroup>
                <Button
                  className="df-btn-primary btn-block"
                  size="sm"
                  type="submit"
                  onClick={e => renameUpdate(e)}>
                  Ok
                </Button>
              </FormGroup>
            </Col>
          </Row>

        </ModalBody>
      </Modal>
    </div>

  )
}


class NewModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clusterName: "",
      clusterdetailsoptions: [],
      markdownvalue: '',
      cellsData: [],
      clusterK8sDTOS: [],
      columns: [],
      percent: '70',
      startcluster: false,
      nextPageToken: null,
      startindex: 0,
      socketLoadFlag: false,
      modalParameter: false,
      open: false,
      Addopen: false,
      deleteopen: false,
      openIntegration: false,
      node: '',
      setSelectedNode: '',
      files: [],
      folders: [],
      currFolder: null,
      storageNavigations: [],
      fileSearch: "",
      filterfiles: [],
      filterfolder: [],
      fileType: "",
      onlyfilename: "",
      popoverOpenFolderCreate: false,
      popoverOpenFolderCreateSplit: false,
      folderToBeCreate: null,
      fileToBeCreate: "",
      showNotebookModal: false,
      folderUploadFiles: null,
      progressmsg: "",
      dispayload: "none",
      selectedIndex: 0,
      openFiles: [],
      setTabIndex: 0,
      delimiter: ",",
      runTime: "",
      runTimeOptions: [],
      openConnectors: false,
      websocketState: undefined,
      connectordetails: [],
      errorSubmitted: false,
      connectiontimeout: 0,
      enableWriteAccess: true,
      name: "",
      password: "",
      role: "",
      server: "",
      connectiontype: "",
      user: "",
      warehouse: "",
      btnActions: "Create Connection",
      setModelError: "",
      totalPages: 0,
      activePage: 1,
      totalRecords: 0,
      activeIndex: 0,
      websocketStatus: "Closed",
      connectionId: "",
      code: "",
      runTimeName: "",
      newFile: false,
      reloadbook: false,
      homecontent: [],
      showUploadModal: false,
      getuntitledfile: false,
      filePath: [],
      wsFlag: false,
      wsTimer: undefined,
      onlyipynbfile: '',
      progress: 0,
      numPages: null,
      pdfpageNumber: 1,
      updateFlag: false,
      recentnotebooks: [],
      recentfiles: [],
      renameChanged: "",
      showbutton: "",
      popoverFileConnectedInfo: false,
      allClusters: [],
      connectorList: [],
      bucketName: "",
      accessKey: "",
      secretKey: "",
      database: "",
      port: "",
      host: "",
      dataLake_accountKey: "",
      dataLake_blobName: "",
      dataLake_sasKey: "",
      dataLakeSchema: "",
      dataLake_url: "",
      connectordescription: "",
      loadmoreFlag: false,
      openChooseStorage: false,
      navActionFlag: true,
      configArray: [],
      enableSubBuckets: false,
      subBucketsList: [],
      sourceStorageName: null,
      sourceStorageId: null,
      sourceRootFolder: null,
      destinationStorageId: null,
      destinationStorageName: null,
      destinationRootFolder: null,
      loadflagStorage: false,
      openedCollapses: [""],
      showFilesModal: false,
      modeTransfer: "",
      dataAction: {},
      showConfirmationCopyMove: false,
      showCopyMoveActionModal: false,
      renameNewValue: "",
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      localFileId: "",
      recentFlag: false,
      showNotebookTools: false,
      modelspaceConnectedList: [],
      deleteOpen: false,
      selectedStorage: "",
      disabledAction: false,
      InterruptToastFlag: false,
      codeChangeFlag: false,
      codeChangeShowModal: false,
      codeChangeFileName: "",
      codeChangeIndex: 0,
      presentFilePath: '',
      presentStorageName: '',
      presentrootFolder: '',
      showVersion: false,
      showSaveModal: false,
      savecomments: '',
      showSavebutton: false,
      modaldata: [],
      listversion: [],
      presentType: '',
      disableicon: false,
      jobState: '',
      count: 0,
      wholeGraphData: [],
      sheetName: [],
      keyValue: [],
      xlsxurl: '',
    };
    this.hotformula = {
      formulas: {
        engine: HyperFormula,
      }
    }
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateState = this.updateState.bind(this);
    this.saveCommentschange = this.saveCommentschange.bind(this);

    this.state.columns = [
      {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show: false
      },
      {
        Header: 'Cluster Name',
        accessor: 'ClusterName',
        maxWidth: 200,
        sortable: true,
      },
      {
        Header: 'Description',
        accessor: 'Description',
        maxWidth: 200,

      },
      {
        Header: 'Status',
        accessor: 'Status',
        maxWidth: 100,
      },
      {
        Header: 'Monthly Usage',
        accessor: 'MonthlyUsage',
        maxWidth: 120,
      },
      {
        Header: 'Cost',
        accessor: 'Cost',
        maxWidth: 100,
      },
      {
        Header: 'Created By',
        accessor: 'Created',
        maxWidth: 100,
      }, {
        Header: 'Last Modified',
        accessor: 'Lastmodified',
        maxWidth: 150,
      },
      {
        Header: 'Actions',
        accessor: 'Actions',
        maxWidth: 135,

      }
    ];

    this.folderUploadRef = React.createRef()
    this.filePond = React.createRef()
  }

  componentDidMount() {
    document.title = "DecisionForce - Model Space"
    this.GetAllClusters();
    Prism.highlightAll();
    this.getRunTimeOptions();
    this.GetAllConnectors();
    this.getAllStorageConfig();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    if (localStorage.getItem("savedNoteBook") !== null) {
      if (JSON.parse(localStorage.getItem("savedNoteBook")).length !== 0) {
        this.setState({
          openFiles: JSON.parse(localStorage.getItem("savedNoteBook")),
          setTabIndex: parseInt(localStorage.getItem("lastopenTab"))
        }, () => {
          if (this.state.openFiles.length !== 0) {
            if (this.state.openFiles[this.state.setTabIndex] !== undefined
              && this.state.openFiles[this.state.setTabIndex].hasOwnProperty('fileId')
              && this.state.openFiles[this.state.setTabIndex].name !== "Home") {
              this.setState({
                localFileId: this.state.openFiles[this.state.setTabIndex].fileId
              })
              try {
                this.updateNotebookContent(this.state.openFiles[this.state.setTabIndex].name,
                  this.state.setTabIndex,
                  this.state.openFiles[this.state.setTabIndex].type,
                  this.state.openFiles[this.state.setTabIndex].stId === null ? "" : this.state.openFiles[this.state.setTabIndex].stId,
                  this.state.openFiles[this.state.setTabIndex].rFolder); // default session notebook load

              } catch (err) {
                this.updateNotebookContent(this.state.openFiles[0].name, 0, this.state.openFiles[0].type, this.state.openFiles[0].stId === null ? "" : this.state.openFiles[0].stId, this.state.openFiles[0].rFolder); // default session notebook load
              }
              this.saveNotebookLocalStroage();
            }
            else if (this.state.openFiles[this.state.setTabIndex].name === "Home") {
              setTimeout(() => {
                this.loadHomeData("Home")
                this.tabFocus()
              }, 1000);
            }
          }
        })
        this.getRecentNotebooksList();
      } else {
        this.setState({
          openFiles: [],
          setTabIndex: 0
        })
        this.getRecentNotebooksList();
      }
    } else {
      this.getRecentNotebooksList();
    }
    this.setState({
      btnActions: "Create Connection",
    });
    this.state.connectorList.push(
      {
        name: "Environment Variable",
        type: "EnvironmentVariable"
      },
      {
        name: "Snowflake",
        type: "Snowflake"
      }, {
      name: "MongoDB",
      type: "MongoDB"
    },
      {
        name: "AmazonS3",
        type: "AmazonS3"
      },
      {
        name: "DataLake",
        type: "DataLake"
      })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
    if (this.state.swidth < 720) {
      this.setState({
        navActionFlag: false
      })
    } else {
      this.setState({
        navActionFlag: true
      })
    }
  }

  renameFile = (rename) => {
    this.setState({
      renameChanged: rename
    }, () => {
      try {
        let renamedata = {
          "isDir": this.state.isitDir,
          "newName": this.state.renameChanged,
          "sourcePath": this.state.sourcemove,
          "sourceStorage": {
            "rootFolder": this.state.sourceRootFolder,
            "storageId": this.state.sourceStorageId
          }
        }
        if (this.state.sourceStorageId === null) {
          delete renamedata["sourceStorage"]
        }
        FileJobsService.RenameFile(renamedata)
          .then((response) => {
            this.fetchProgress(response.jobState, response.message)
            setTimeout(() => {
              this.fetchStorageItems(this.state.currFolder, null, false)
            }, VERSIONTIMEOUT);
          });
      } catch (err) {
      }
    })
  }

  /**
   * 
   * @param {destination path} destination 
   * @param {folder or file} dirornot 
   * @param {source path} sourceMove 
   * @returns 
   */
  ConstructJobOperationData = (destination, dirornot, sourceMove) => {
    let data = {
      "destinationPath": destination,
      "destinationStorage": {
        "rootFolder": this.state.destinationRootFolder !== null ? this.state.destinationRootFolder : null,
        "storageId": this.state.destinationStorageId
      },
      "paths": [
        {
          "isDir": dirornot,
          "sourcePath": sourceMove

        }
      ],
      "sourceStorage": {
        "rootFolder": this.state.sourceRootFolder,
        "storageId": this.state.sourceStorageId
      }
    }
    if (this.state.sourceStorageId === null) {
      delete data["sourceStorage"]
    }
    if (this.state.destinationStorageId === null) {
      delete data["destinationStorage"]
    }
    return data;
  }

  copyFolder = (split, pastefiles) => {
    let dirornot = this.state.isitDir
    let currFolder = this.state.currFolder ? this.state.currFolder : ''
    if (pastefiles !== undefined) {
      currFolder = pastefiles;
    }
    if (currFolder == null) {
      currFolder = "/"
    }
    this.setState({ destinationcopy: currFolder })
    let destifolder = currFolder;
    if (destifolder == null) {
      destifolder = "/"
    }
    let copydata = this.ConstructJobOperationData(destifolder, dirornot, this.state.sourcecopy);
    let soruceFile = this.state.sourcecopy.substring(0, this.state.sourcecopy.lastIndexOf("/"));
    if (destifolder === "") {
      destifolder = "/";
    }
    if (destifolder === soruceFile + "/" && !this.state.isitDir && (this.state.sourceStorageId === this.state.destinationStorageId)) {  // if copy same directory
      this.setState({
        dataAction: copydata,
        modeTransfer: "Copy"
      }, () => {
        this.RenameAction();
        this.toggleShowFiles();
        this.toggleConfirmationCopyMove();  // open confirmation popup of copy
      })
    } else {
      if (dirornot) {
        let modifiedSourcepath = this.removelastElement(copydata)
        if (modifiedSourcepath + "/" === destifolder) {
          this.setState({
            dataAction: copydata,
            modeTransfer: "Copy"
          }, () => {
            this.RenameAction();
            this.toggleShowFiles();
            this.toggleConfirmationCopyMove();  // open confirmation popup of copy  
          })
        } else {
          this.copyAction(copydata);
        }
      } else {
        this.copyAction(copydata);
      }
    }
  }

  copyAction = (copydata) => {
    FileJobsService.CopyFile(copydata)
      .then((response) => {
        this.fetchProgress(response.jobState, response.message)
        setTimeout(() => {
          this.fetchStorageItems(this.state.currFolder, null, false)
        }, VERSIONTIMEOUT);

      });
    this.setState({ showFilesModal: false, sourceStorageId: this.state.destinationStorageId, sourceRootFolder: this.state.destinationRootFolder })
  }

  moveFolder = (split, pastefiles) => {
    let dirornot = this.state.isitDir
    let currFolder = this.state.currFolder ? this.state.currFolder : ''
    if (pastefiles !== undefined) {
      currFolder = pastefiles;
    }
    if (currFolder == null) {
      currFolder = "/"
    }
    this.setState({ destinationmove: currFolder })
    let destifolder = currFolder;
    if (destifolder == null) {
      destifolder = "/"
    }
    let movedata = this.ConstructJobOperationData(destifolder, dirornot, this.state.sourcemove);

    let soruceFile = this.state.sourcemove.substring(0, this.state.sourcemove.lastIndexOf("/"));
    if (destifolder === "") {
      destifolder = "/";
    }
    if (destifolder === soruceFile + "/" && (this.state.sourceStorageId === this.state.destinationStorageId)) {
      this.setState({
        dataAction: movedata,
        modeTransfer: "Move"
      }, () => {
        this.RenameAction();
        this.toggleShowFiles();
        this.toggleConfirmationCopyMove();  // open confirmation popup of copy
      })
    } else {
      if (dirornot) {
        let modifiedSourcepath = this.removelastElement(movedata)
        if (modifiedSourcepath + "/" === destifolder) {
          this.setState({
            dataAction: movedata,
            modeTransfer: "Move"
          }, () => {
            this.RenameAction();
            this.toggleShowFiles();
            this.toggleConfirmationCopyMove();  // open confirmation popup of copy  
          })
        } else {
          this.moveAction(movedata);
        }
      } else {
        this.moveAction(movedata);
      }

    }
  }

  moveAction = (movedata) => {
    FileJobsService.MoveFile(movedata)
      .then((response) => {
        this.fetchProgress(response.jobState, response.message)
        setTimeout(() => {
          this.fetchStorageItems(this.state.currFolder, null, false)
        }, VERSIONTIMEOUT);
      });
    this.setState({ showFilesModal: false, sourceStorageId: this.state.destinationStorageId, sourceRootFolder: this.state.destinationRootFolder })

  }

  removelastElement = (copyD) => {
    let val = copyD.paths[0].sourcePath;
    var arr = val.split("/");
    var removeCount = 2;
    arr.splice(arr.length - removeCount, removeCount);
    return (arr.join('/'));
  }


  RenameAction = () => {
    if (this.state.dataAction.paths !== undefined) {
      if (this.state.dataAction.paths.length === 1) {
        if (!this.state.dataAction.paths[0].isDir) {
          this.setState({
            renameNewValue: this.state.dataAction.paths[0].sourcePath.replace(/^.*[\\\/]/, '')
          }, () => {
          })
        } else {
          var splitbySlash = this.state.dataAction.paths[0].sourcePath.split("/");
          this.setState({
            renameNewValue: splitbySlash[splitbySlash.length - 2]
          }, () => {
          })
        }
      }
    }
  }

  renameCopyMoveUpdate = (e) => {
    let copymovedataNew = this.state.dataAction;
    if (copymovedataNew.paths.length === 1) {
      if (!copymovedataNew.paths[0].isDir) {
        copymovedataNew.paths[0].newName = this.state.renameNewValue;
      } else {
        copymovedataNew.paths[0].newName = this.state.renameNewValue;
      }
    }
    this.toggleConfirmationCopyMove();

    if (this.state.modeTransfer === "Copy") {
      this.copyAction(copymovedataNew)

    } else if (this.state.modeTransfer === "Move") {
      this.moveAction(copymovedataNew)
    }
  }

  // render file on tabclick
  updateNotebookContent = (path, index, fileType, storageName, rootFolder) => {
    if (path !== "Home") {
      StorageService.downloadObjectUrl(path, storageName, rootFolder)
        .then((res) => {
          axios.get(res.download_url)
            .then(response => {
              if (fileType === "ipynb") {
                try {
                  let notebook = response.data
                  if (index !== undefined) {
                  this.state.openFiles[index].content = notebook.cells;
                  this.state.openFiles[index].metadata = notebook.metadata;
                  }
                  this.setState({ updateFlag: true })
                  if (this.state.openFiles[index].wsConnectionId !== undefined) {
                    this.checkWebsocketConnection(this.state.openFiles[index].path);
                  }
                  this.handlePreviousTabHistory(path, this.state.openFiles[index].content, fileType, storageName, rootFolder)
                  if (notebook.cells.length !== 0) {
                    let count = 1;
                    for (var i = 0; i < notebook.cells.length; i++) {
                      if (notebook.cells[i].cell_type === "code") {
                        notebook.cells[i].metadata.codeindex = count++;
                      }
                    }
                  }
                } catch (err) { }
              }
              else if (fileType === "jpeg" || fileType === "jpg" ||
                fileType === "png") {
                {/** Already opened files auto focus to file */ }
                this.state.openFiles[index].content = res.download_url;
                this.handlePreviousTabHistory(path, res.download_url, fileType, storageName, rootFolder)
              }
              else if (fileType === "pdf") {
                {/** Already opened files auto focus to file */ }
                this.state.openFiles[index].content = res.download_url;
                this.handlePreviousTabHistory(path, res.download_url, fileType, storageName, rootFolder)
              }
              else if (fileType === "xlsx" || fileType === "xls") {
                this.setState({ sheetName: [], tabloading: true })
                var url = res.download_url;
                this.setState({ xlsxurl: url })
                var req = new XMLHttpRequest();
                req.open("GET", url, true);
                var result = [];
                req.responseType = "arraybuffer";
                req.onload = (e) => {
                  var data = new Uint8Array(req.response);
                  var wb = XLSX.read(data, { type: "array" });
                  const sheet = wb.Sheets;
                  this.setState({ keyValue: sheet })
                  let filtervalues = Object.values(this.state.keyValue);
                  for (const [key, value] of Object.entries(sheet)) {
                    const ws = wb.Sheets[key];
                    let list = this.state.sheetName.push(key);
                    const html = XLSX.utils.sheet_to_csv(filtervalues[0]);
                    result = CSVToJSONs(html, ',');
                    this.setState({
                      hotSettings: result,
                      loading: false,
                      tabloading: false,
                      activeExcel: this.state.sheetName[0]
                    })
                  }
                };
                req.send();
                this.state.openFiles[index].content = this.state.hotSettings;
                this.handlePreviousTabHistory(path, res.download_url, fileType, storageName, rootFolder)
              }
              else if (fileType === "py") {
                this.state.openFiles[index].content = response.data.toString();
                {/** Already opened files auto focus to file */ }
                this.handlePreviousTabHistory(path, response.data.toString(), fileType, storageName, rootFolder)
              }
              else if (fileType === "csv") {
                this.setState({
                  activePage: 1,
                  loading:"block"
                }, () => {
                  let result = [];
                  if (response.data !== null && response.data.length > 0) {
                     result = CSVToJSONs(response.data, this.state.delimiter);
                    this.setState({
                      wholeGraphData: result,
                      tabloading: false,
                      loading:"none"
                    })
                  }
                  else {
                    this.setState({
                      wholeGraphData: [], // Empty the csv content value
                      tabloading: false

                    });
                  }
                  this.handlePreviousTabHistory(path, result, fileType, storageName, rootFolder)
                  this.tabFocus();
                  this.saveNotebookLocalStroage();  // save notebook update in local Storage
                })
              }
              else if ((fileType === "zip") || (fileType === "tar") || (fileType === "rar") || (fileType === "gz") || (fileType === "exe")) {
                this.state.openFiles[index].content = unknownfile;
                {/** Already opened files auto focus to file */ }
                this.handlePreviousTabHistory(path, unknownfile, fileType, storageName, rootFolder)
              }
              else {
                this.state.openFiles[index].content = response.data.toString();
                this.state.openFiles[index].type = "others";
                this.handlePreviousTabHistory(path, response.data.toString(), fileType, storageName, rootFolder)
              }
              this.saveNotebookLocalStroage();  // save notebook update in local Storage
            })
        })
    }
    else {
      setTimeout(() => {
        this.loadHomeData("Home")
        this.tabFocus()
      }, 1000);
    }
  }
  getTabData = (tabid) => {
    var result = [];
    let filteredTabData = Object.fromEntries(Object.entries(this.state.keyValue).filter(([key]) => key.includes(tabid)));
    let filtervalues = Object.values(filteredTabData);
    for (const [key, value] of Object.entries(filtervalues[0])) {
      const html = XLSX.utils.sheet_to_csv(filtervalues[0]);
      result = CSVToJSONs(html, ',');
      this.setState({
        hotSettings: result,
        loading: false,
        activeExcel: tabid
      })
    }
  }

  DisconnectWSIdle = (id) => {
    setTimeout(function () {
      if (this.state.openFiles.length !== 0) {
        try {
          let currentIndex = this.state.openFiles.findIndex(item => item.wsConnectionId === id)
          if (this.state.openFiles[currentIndex].type === 'ipynb') {
            let status = this.state.openFiles[currentIndex].wsStatus;
            if (status !== undefined) {
              if (status === "Connecting") {
                this.closeWebsocket(currentIndex)
              }
            }
          }
        } catch (err) {

        }


      }
    }.bind(this), NOTEBOOK_WS_CONNETING_TIMER)
  }

  handleChangeSelectDelimiter = (event, index) => {
    this.setState({
      delimiter: event.value
    });
    try {
      this.previewFile(this.state.openFiles[index].name, this.state.openFiles[index].name)
    }
    catch (err) {
    }
  }

  getRunTimeOptions = () => {
    ModelSpaceService.getAllRunTimes().then((response) => {
      var options = [];
      if (response.length !== 0) {
        response.map((item, index) => {
          options.push({
            label: item.displayName,
            value: item.name,
          })
        })
        this.setState({
          runTimeOptions: options
        })
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }

  handleChangeStorage = (e, configArray) => {
    var index = configArray.findIndex(item => item.id === e.target.value)
    if (configArray[index].storageConfig !== null) {
      var getLength = configArray[index].storageConfig.bucketStorages.length
      this.setState({
        enableSubBuckets: true,
        subBucketsList: configArray[index].storageConfig.bucketStorages
      }, () => {
        if (getLength >= 1) { // call onchange event
          this.state.loadflagStorage = true;
          this.state.sourceStorageId = configArray[index].id;
          this.state.sourceStorageName = configArray[index].name;
          this.state.sourceRootFolder = configArray[index].storageConfig.bucketStorages[0].bucketName
          this.state.provisionerType = configArray[index].provisionerType;
          this.fetchStorageItems("", null, false);
        } else {
          this.state.sourceStorageId = configArray[index].id;
          this.state.sourceStorageName = configArray[index].name;
          this.state.provisionerType = configArray[index].provisionerType;
        }
      })
    } else {
      this.setState({
        enableSubBuckets: false,
        subBucketsList: []
      })
      //  Load default list
      this.state.loadflagStorage = true;
      this.state.sourceStorageId = configArray[index].id;
      this.state.sourceStorageName = configArray[index].name;
      this.state.sourceRootFolder = null
      this.state.provisionerType = "GOOGLE";
      this.fetchStorageItems("", null, false);
    }
  }

  handleChangeBucket = (e) => {
    this.state.sourceRootFolder = e.target.value
    this.fetchStorageItems("", null, false);
  }

  getPlatformDefaultConfig = (data) => {
    let platformDefault = data.filter(item => item.platformDefault);
    if (platformDefault.length > 0) {
      return platformDefault[0];
    }
  }

  getAllStorageConfig = () => {
    StorageConfigService.getAllStorageConfig()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let configData = [];
          this.state.configArray = [];
          configData = response.storageDTOPage.content
          this.configArrayModified(configData);
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      }
      );
  }

  configArrayModified = (data) => {
    let platformDefault = this.getPlatformDefaultConfig(data);
    this.setState({
      configArray: data,
      activeConfigPath: default_StorageName,
    }, () => {
      if (platformDefault !== null && platformDefault !== undefined) {
        this.state.sourceStorageId = platformDefault.id
        this.state.loadflagStorage = true;
        this.state.sourceStorageName = platformDefault.name;
        this.state.sourceRootFolder = null
        this.state.provisionerType = platformDefault.provisionerType
        this.fetchStorageItems("", null, false);
      }
    })
  }

  AddConnectorConfig = (ConnectorName) => {
    this.clearformData();   // Reset Form data    
    if (ConnectorName === "Snowflake") {
      this.setState({
        connectiontype: "Snowflake"
      })
      this.onOpenAddModal('Snowflake')
    } else if (ConnectorName === "AmazonS3") {
      this.setState({
        connectiontype: "AmazonS3"
      })
      this.onOpenAddModal('AmazonS3')
    } else if (ConnectorName === "MongoDB") {
      this.setState({
        connectiontype: "MongoDB"
      })
      this.onOpenAddModal('MongoDB')
    } else if (ConnectorName === "DataLake") {
      this.setState({
        connectiontype: "DataLake"
      })
      this.onOpenAddModal('DataLake')
    } else if (ConnectorName === "Environment Variable") {
      this.onOpenAddModal('EnvironmentVariables')
    }
  }

  DeleteModelSpaceByIdConfirm = (id, index, data, runtime) => {
    this.setState({ deleteOpen: true, popoverFileConnectedInfo: false });
    confirmAlert({
      title: "Terminate Runtime!",
      message: 'Are you sure want to terminate Runtime - ' + this.getDisplayRuntimeNamebyruntime(runtime) + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.DeleteModelSpaceById(id, index, data)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }
  // Recent notebook delete confirmation
  deleteRecentNotebookByIdConfirm = (id, file) => {
    confirmAlert({
      title: "Remove Notebook!",
      message: <div><span>
        Are you sure want to remove in this list - <b><i>{file} ?</i></b>
      </span>
      </div>,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.DeleteRecentNotebookById(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }
  //  Stop modelspace run time
  TerminateModelSpaceConfirmation = (id, index, data) => {
    this.setState({ deleteOpen: true, popoverFileConnectedInfo: false });
    confirmAlert({
      title: "Terminate Runtime!",
      message: 'Are you sure want to terminate Runtime - ' + this.state.openFiles[index].runTime + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.TerminateModelSpace(id, index, data)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  TerminateModelSpace = (id, index, data) => {
    if (id !== undefined || id !== null) {
      // need to close websocket connection while delete
      ModelSpaceService.stopModelspacebyId(id).then((response) => {
        if (response.status === 'SUCCESS') {
          try {
            let ws = this.state.openFiles[index].wsState;
            let currentStorageName = this.state.openFiles[index].stId;
            let currentrootFolder = this.state.openFiles[index].rFolder
            ws.close();
            let status = undefined;
            let websocketState = {};
            let wsId = undefined;
            if (data !== undefined && data !== null) {
              let filePath = data.path;
              let fileType = data.type;
              let content = data.content;
              let metadata = data.metadata;
              let notebookContent = {
                cells: content,
                metadata: metadata
              }
              saveFile(filePath, fileType, notebookContent, currentStorageName, currentrootFolder)
            }
            this.updateWsState(index, websocketState, wsId, status);
          } catch (err) {
          }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      });
    }
  }

  /**
 * 
 * @param {file id } id 
 */

  DeleteRecentNotebookById = (id) => {
    if (id !== undefined || id !== null) {
      ModelSpaceService.deleteRecentNotebookById(id).then((response) => {
        if (response.status === "SUCCESS") {
          this.getRecentNotebooksList();
        } else {
          toast.error(response.errorMessage);
        }
      }).catch((error) => { });
    }
  }

  /**
   * 
   * @param {websocket connection id} id 
   * @param {current index of openfiles} index 
   * @param {data for particular notebook} data 
   */

  DeleteModelSpaceById = (id, index, data) => {
    if (id !== undefined || id !== null) {
      // need to close websocket connection while delete
      ModelSpaceService.deleteModelSpaceById(id).then((response) => {
        if (response.status === 'SUCCESS') {
          try {
            let fileMeta = this.state.openFiles[index];
            if (fileMeta !== null && fileMeta !== undefined) {
              let currentStorageName = fileMeta.stId;
              let currentrootFolder = fileMeta.rFolder
              let status = undefined;
              let websocketState = {};
              let wsId = undefined;
              if (data !== undefined && data !== null) {
                let filePath = data.path;
                let fileType = data.type;
                let content = data.content;
                let metadata = data.metadata;
                let notebookContent = {
                  cells: content,
                  metadata: metadata
                }
                saveFile(filePath, fileType, notebookContent, currentStorageName, currentrootFolder)
              }
              this.updateWsState(index, websocketState, wsId, status);
            }
          } catch (err) {
          }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      });
    }
  }

  StartTerminateState(e, flag, index) {
    this.setState({
      actionstate: !flag,
      startindex: e.currentTarget.id
    })
    this.GetAllClusters();
  }
  // Start Cluster
  StartCluster = (id, e) => {
    let cid = e.currentTarget.id
    ClusterService.clusterStart(id).then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          startcluster: false,
          startindex: cid
        })
        this.GetAllClusters();
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }

  // Stop Cluster
  StopCluster = (id, e) => {
    let cid = e.currentTarget.id
    ClusterService.clusterStop(id).then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          startcluster: true,
          startindex: cid
        })

      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }
  // Clone Cluster
  CloneCluster = (cloneid) => {
    ClusterService.clusterClone(cloneid).then((response) => {
      if (response.status === 'SUCCESS') {
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }
  // Get live status update for current cluster
  GetLiveStatus = (statusId, name) => {
    ClusterService.clusterLiveStatus(statusId).then((response) => {
      if (response.status === 'SUCCESS') {
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }
  // Restart Cluster
  RestartCluster = (restartId) => {
    ClusterService.clusterRestart(restartId).then((response) => {
      if (response.status === 'SUCCESS') {
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }

  GetAllClusters = () => {
    if (!this.state.socketLoadFlag) {
    }
    ClusterService.getAllClusters()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.k8sDTOPage.content !== null) {
            let modalclusterdetails = response.k8sDTOPage.content;
            this.renderData(modalclusterdetails);
            this.setState({
              clusterK8sDTOS: modalclusterdetails,
              tabloading: false,
              socketLoadFlag: false
            });
          }
        } else {
          this.setState({ socketLoadFlag: false, tabloading: false });
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      })

  }

  collapsesToggle = collapse => {
    let openedCollapses = this.state.openedCollapses;

    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: []
      });
    } else {
      this.setState({
        openedCollapses: [collapse]
      });
    }

  };

  onBucketNameClick_Popup = (item, bucketData,) => {
    if (bucketData === default_StorageName) {
      this.state.destinationStorageId = item.id
      this.state.destinationStorageName = item.name;
      this.state.destinationRootFolder = null;
      this.state.provisionerType = item.provisionerType
      this.state.selectedStorage = null;
      this.fetchStorageItems("", null, false);
    } else if (typeof bucketData === 'object') {
      this.state.destinationStorageId = item.id
      this.state.destinationStorageName = item.name;
      this.state.destinationRootFolder = bucketData.bucketName
      this.state.provisionerType = item.provisionerType;
      this.fetchStorageItems("", null, false);
      this.state.selectedStorage = bucketData.bucketName;
    } else {
      // Collapse configuration with empty bucket
      console.log("")
    }
  }

  // restart kernel for connented path
  restartKernel = () => {
    if (this.state.openFiles.length !== 0) {
      let currentTabItems = this.state.openFiles[this.state.activeIndex];
      let websocket = currentTabItems.wsState;
      if (websocket !== undefined) {
        this.setState({
          disabledAction: true
        }) // it's for disable run all and stop and connected info
        let kernelRestart_json = { 'connectionId': currentTabItems.wsConnectionId, 'userId': localStorage.getItem("Uid"), 'action': 'RESTART', 'filePath': currentTabItems.path }
        websocket.send(JSON.stringify(kernelRestart_json))
      }
    }
  }

  renderData(modalclusterdetails) {
    let datas = [];
    modalclusterdetails.map((item, index) => {
      datas.push({
        Id: item.id,
        ClusterName: <div className="namedisplay"> <span title={item.name} className="overflowStyle"><a href={() => false} className="text-primary" onClick={e => this.viewCluster(item.id)} ><b>{item.name}</b></a></span></div>,
        Description: <div className="namedisplay"><span title={item.description} className="overflowStyle">{item.description} </span></div>,
        Status: <div>
          {(item.clusterStatus === "PENDING" || item.clusterStatus === "CREATING" || item.clusterStatus === "DELETING" || item.clusterStatus === "STARTING" || item.clusterStatus === "RESTARTING") &&
            <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{item.clusterStatus}</Badge>
          }
          {item.clusterStatus === "RUNNING" &&
            <Badge color="" className="badge-dot"><i className="bg-success" />{item.clusterStatus}</Badge>
          }
          {(item.clusterStatus === "STOPPING" || item.clusterStatus === "STOPPED") &&
            <Badge color="" className="badge-dot">{item.clusterStatus === "STOPPED" ? <i className="bg-darkgray" /> : <i className="bg-darkgray blink" />}{item.clusterStatus}</Badge>
          }

          {item.clusterStatus === "FAILED" && <div>
            <span className="actionicon" id={'uncon' + index}>
              <UncontrolledTooltip placement="top" target={'uncon' + index} delay={0}>
                {item.message}
              </UncontrolledTooltip>
              <i className="fas fa-exclamation-triangle" style={{ cursor: "pointer", color: "#ffcc00" }}></i><Badge color="" style={{ marginLeft: 10 }} className="badge-dot">{item.clusterStatus}</Badge>
            </span>
          </div>}

          {item.clusterStatus === "ERROR" &&
            <Badge color="" className="badge-dot"><i className="bg-red" />{item.clusterStatus}</Badge>
          }
        </div>,
        MonthlyUsage: 0,
        Cost: 0,
        Created: item.createdBy,
        Lastmodified: <div>{item.updatedDate !== null ? moment.utc(item.updatedDate).local().format('MMM DD, YYYY') : ""} <br></br>{item.updatedDate !== null ? moment.utc(item.updatedDate).local().format('hh:mm A') : ""}</div>,
        Actions: <Row>
          <span className="actionicon" id={'liveStatus' + index} onClick={e => {
            e.preventDefault()
            this.GetLiveStatus(item.id, item.name)
          }}><i className="fab fa-creative-commons-sampling mr-2" style={{ color: '#97c61b', cursor: 'pointer', fontSize: 18 }}><span style={{ paddingLeft: 7 }}>|</span></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <UncontrolledTooltip placement="top" target={'liveStatus' + index} delay={0}>
            Live Status
              </UncontrolledTooltip>
          <div className="row" style={(item.clusterStatus === "CREATING" || item.clusterStatus === "STARTING" || item.clusterStatus === "STOPPING" || item.clusterStatus === "DELETING" || item.clusterStatus === "RESTARTING") ? { pointerEvents: "none", opacity: 0.4 } : {}}>
            {(item.clusterStatus === "RUNNING")
              ?
              <div>
                <span className="actionicon" id={'action' + index} onClick={e => { this.StopCluster_Confirmation(item.id, e, item.name) }}><i className="fas fa-stop-circle mr-2 " style={{ color: 'red' }}></i> &nbsp;</span>
                <UncontrolledTooltip placement="bottom" target={'action' + index} delay={0}>
                  Stop
                </UncontrolledTooltip>
              </div>
              :
              <div style={item.clusterStatus === "ERROR" ? { pointerEvents: "none", opacity: 0.4 } : {}}>
                <span className="actionicon" id={'action' + index} onClick={e => { this.StartCluster(item.id, e) }}><i className="fas fa-play-circle mr-2" style={{ color: 'green' }}></i> &nbsp;</span>
                <UncontrolledTooltip placement="bottom" target={'action' + index} delay={0}>
                  Start
              </UncontrolledTooltip>
              </div>
            }
            <span style={item.clusterStatus === "RUNNING" ? {} : { pointerEvents: "none", opacity: 0.4 }} className="actionicon" id={'restart' + index} onClick={e => {
              e.preventDefault()
              this.RestartClusterConfirmation(item.id, item.name)
            }}><i className="fas fa-undo-alt mr-2" style={{ color: '#808080c7', cursor: 'pointer' }}></i> &nbsp;</span>
            <UncontrolledTooltip placement="bottom" target={'restart' + index} delay={0}>
              Restart
              </UncontrolledTooltip>
            <span className="actionicon" id={'clone' + index} onClick={e => {
              e.preventDefault()
              this.CloneClusterConfirmation(item.id, item.name)
            }}> <i className="far fa-clone text-red mr-2" style={{ color: '#007bff' }} /> &nbsp;</span>
            <UncontrolledTooltip placement="bottom" target={'clone' + index} delay={0}>
              Clone
              </UncontrolledTooltip>
            <span className="actionicon" id={'delete' + index} onClick={e => this.deleteCluster(item.id, item.name)}>
              <i className="fas fa-trash-alt text-red mr-2" style={{ color: '#007bff' }} /> &nbsp;</span>
          </div>
        </Row>
      })
    });

    this.setState({
      modalclusterdetails: datas,
    });

  }
  viewCluster = (id) => {
    this.props.history.push({
      pathname: '/cluster/viewcluster/' + id,
      state: { mode: "viewCluster", viewClusterId: id, }
    })
  }
  // Delete Cluster
  deleteCluster = (id, name) => {
    confirmAlert({
      title: "Delete Cluster",
      message: 'Are you sure to delete this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.confirmDelete(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  // close websocket
  closeWebsocketConfirm = (index) => {
    this.setState({ popoverFileConnectedInfo: false })
    confirmAlert({
      title: "Disconnect Runtime!",
      message: 'Are you sure want to disconnect Runtime - ' + this.state.openFiles[index].runTime + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.closeWebsocket(index)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  closeWebsocket = (index) => {
    if (this.state.openFiles.length !== 0) {
      this.state.openFiles[index].runAllFlag = true;
    }
    try {
      let websocket = this.state.openFiles[index].wsState;
      let status = undefined;
      let websocketState = {};
      let id = this.state.openFiles[index].wsConnectionId;
      if (websocket !== undefined && id !== undefined) {
        this.removeWsOnTabclose(websocket);
        this.updateWsState(index, websocketState, id, status);
      }
    } catch (err) { }
  }

  refreshEnvironment = () => {
    this.GetRunningClusters();
    this.getRunTimeOptions();
  }

  StopCluster_Confirmation = (id, e, name) => {
    confirmAlert({
      title: "Stop Cluster",
      message: 'Are you sure to stop this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.StopCluster(id, e)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  CloneClusterConfirmation = (id, name) => {
    confirmAlert({
      title: "Clone Cluster",
      message: 'Are you sure to clone this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.CloneCluster(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  RestartClusterConfirmation = (id, name) => {
    confirmAlert({
      title: "Restart Cluster",
      message: 'Are you sure to restart this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.RestartCluster(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  confirmDelete(id) {
    ClusterService.deleteClusterById(id).then((response) => {
      if (response.status === 'SUCCESS') {
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }

  onDismiss = () => { };
  onOpenModal = () => {
    this.setState({
      open: true,
    })
  }
  onOpenAddModal = (from) => {
    let modaldata = from;
    this.setState({
      modaldatafrom: modaldata
    })
    if (modaldata === "EnvironmentVariables") {
      this.setState({
        frommodal: modaldata,
        Addopen: true,
      })
    }
    if (modaldata === "SharedData") {
      this.setState({
        frommodal: modaldata,
        Addopen: true,
      })
    }
    if (modaldata === "GoogleDrive") {
      this.setState({
        frommodal: modaldata,
        Addopen: true,
      })
    }

    this.setState({
      Addopen: true,
    })
  }
  onCloseModal = () => {
    this.setState({ open: false, Addopen: false, openChooseStorage: false });
  };

  constructFilePath = (storageId, rootFolder, path) => {
    let storages = this.state.configArray.filter(item => item.id === storageId);
    if (storages.length > 0) {
      let storage = storages[0];
      if (storage.platformDefault) {
        return path;
      }
      return storage.name + '/' + rootFolder + '/' + path;
    }
    return path;
  }

  getNotebookCellsData = (filePath, notebook, storageId, rootFolder) => {
    let isSaveRequired = false;
    if (Array.isArray(notebook.cells)) {
      if (notebook.cells.length !== 0) {
        let count = 1;
        for (var i = 0; i < notebook.cells.length; i++) {
          if (!notebook.cells[i].metadata.hasOwnProperty("decisionforce_cell_id")) {
            let metatab = { "decisionforce_cell_id": uuidv4() }
            notebook.cells[i].metadata = metatab
            isSaveRequired = true;
          }
          if (notebook.cells[i].cell_type === "code") {
            notebook.cells[i].metadata.codeindex = count++;
          }
        }

        let fileData = {
          path: filePath,
          name: filePath,
          metadata: notebook.metadata,
          content: notebook.cells,
          type: this.state.fileType,
          stId: storageId,
          rFolder: rootFolder
        }
        if (isSaveRequired) {
          this.saveCell(filePath, fileData); //Save file with DF meta cell id
        }

        var indexNum = this.state.openFiles.findIndex(obj => obj.name === filePath);
        if ((indexNum < 0)) {
          this.setState({
            openFiles: [...this.state.openFiles, fileData],
            sameindex: false,
            newFile: false,
            reloadbook: false,
          })
        } else {
          this.setState({
            setTabIndex: indexNum,
            sameindex: true,
            sameindexid: indexNum,
            activeIndex: indexNum,
            newFile: false,
            reloadbook: false,
          })
        }
        this.tabFocus();
      }
      this.tabFocus();
    }
    return this.state.openFiles;
  }

  updateConnectedInfoDetails = (id) => {
    try {
      let currentIndex = this.state.openFiles.findIndex(item => item.wsConnectionId === id)
      ModelSpaceService.getModelspaceDetails(id).then((response) => {
        if (response.modelSpaceDTOS.length !== 0) {
          this.state.openFiles[currentIndex].clusterName = this.getClusterNamebyId(response.modelSpaceDTOS[0].clusterId);
          this.state.openFiles[currentIndex].runTime = this.getDisplayRuntimeNamebyruntime(response.modelSpaceDTOS[0].runtime);
        }
      }).catch((error) => { });
    } catch (err) { }
  }

  getClusterNamebyId = (id) => {
    if (id !== null && id !== undefined) {
      let cNameData = this.state.clusterK8sDTOS.filter(item => item.id === id)
      return cNameData.length > 0 ? cNameData[0].name : null;
    }
  }

  getDisplayRuntimeNamebyruntime = (rtime) => {
    if (rtime !== null && rtime !== undefined) {
      let rTimeData = this.state.runTimeOptions.filter(item => item.value === rtime)
      if (rTimeData.length > 0) {
        if (rTimeData[0].hasOwnProperty("label")) {
          return rTimeData[0].label;
        } else {
          return rtime;
        }
      } else {
        return rtime;
      }
    }
  }

  reconnectWebsocket = (index, modelSpaceObject) => {
    if (modelSpaceObject !== null && modelSpaceObject !== undefined) {
      this.GetClusterStatus(index, modelSpaceObject);
    }
  }

  GetClusterStatus = (index, res) => {
    ClusterService.clusterLiveStatus(res.clusterId).then((response) => {
      if (response.status === 'SUCCESS') {
        if (response.k8sDTOS.length > 0) {
          var status = response.k8sDTOS[0].clusterStatus;
          if (status === "RUNNING") {  // if it's running reconnect the websocket
            this.reConnectNotebook(index, res);
          } else {  // if it's not running start the cluster and show the status in modelspace
            this.ClusterNotrunningConfirmation(res.clusterId)
          }
        }
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }

  // Here get the list of the connected environment already
  loadAlreadyConnectedList = (fileId) => {
    this.setState({ deleteOpen: false });
    this.refreshEnvironment()
    if (fileId !== undefined && fileId !== null && fileId !== "") {
      ModelSpaceService.getConnectedModelspaceListById(fileId).then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.modelSpaceDTOPage !== null) {
            if (response.modelSpaceDTOPage.content.length !== 0) {
              this.setState({
                modelspaceConnectedList: response.modelSpaceDTOPage.content
              })
            } else {
              this.setState({
                modelspaceConnectedList: []
              })
            }
          }
        }
      });
    }
  }

  reConnectNotebook = (index, res) => {
    let modelSpaceData = {
      clusterId: res.clusterId,
      storageFileId: res.storageFileId,
      runtime: res.runtime,
    }
    ModelSpaceService.createModelSpace(modelSpaceData).then((response) => {
      if (response.status === 'SUCCESS') {
        let wcId = response.modelSpaceDTOS.length !== 0 ? response.modelSpaceDTOS[0].id : "";
        let websocket = establishWSConnection(wcId)
        websocket.onmessage = this.onMessage;
        websocket.onerrror = this.onWebsoketError;
        websocket.onclose = this.onWebsoketClose;
        Promise.all([this.updateWsState(index, websocket, wcId, "Connecting"),
          this.updateConnectedInfoDetails(wcId),
          this.DisconnectWSIdle(wcId),
          this.onCloseModalConnectors()]).then(values => {
        })
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }

  restartWebsocket = (path) => {
    if (path !== undefined) {
      this.checkWebsocketConnection(path);
    }
  }

  checkWebsocketConnection = (path) => {
    let currentIndex = this.state.openFiles.findIndex(item => item.path === path);
    this.setState({
      activeIndex: currentIndex
    });
    try {
      let id = this.state.openFiles[currentIndex].wsConnectionId;
      if (id !== undefined) {
        let websocket = establishWSConnection(id);
        websocket.onmessage = this.onMessage;
        websocket.onerrror = this.onWebsoketError;
        websocket.onclose = this.onWebsoketClose;
        Promise.all([this.updateWsState(currentIndex, websocket, id, "Connecting"),
          this.updateConnectedInfoDetails(id),
          this.DisconnectWSIdle(id)]).then(values => {
        })
      }
    } catch (err) {
    }
  }

  createFileInit = (fileName, path) => {
    this.setState({ tabloading: true })
    if (fileName.trim() === "") {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please Enter file name</b></i>);

    } else {
      let createdNewFile = fileName + '.ipynb';
      let newpath = path + createdNewFile;
      let checkIndex = this.state.files.findIndex(item => item.name.split("/").pop() === createdNewFile)
      if (checkIndex < 0) {
        this.setState({ tabloading: true })
        this.GetNotebookUntitled(createdNewFile, newpath, path)
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">File already exists, Please create new file name</b></i>);
        this.setState({ tabloading: false })
      }
    }

  }

  /**
   * 
   * @param {*} fileName 
   * @param {Current path} path 
   */
  GetNotebookUntitled = (fileName, newpath, path) => {
    this.setState({ tabloading: true })
    if (this.state.codeChangeFlag) {
      this.codeChangeConfirmation(this.state.setTabIndex);
    } else {
      if (fileName !== "") {
        this.toggleUploadNotebook();
        var notebook = addEmptyCodeCell();
        let isSaveRequired = false;
        if (notebook.cells.length !== 0) {
          let count = 1;
          for (var i = 0; i < notebook.cells.length; i++) {
            if (!notebook.cells[i].metadata.hasOwnProperty("decisionforce_cell_id")) {
              let metatab = { "decisionforce_cell_id": uuidv4() }
              notebook.cells[i].metadata = metatab
              isSaveRequired = true;
            }
            if (notebook.cells[i].cell_type === "code") {
              notebook.cells[i].metadata.codeindex = count++;
            }
          }
          let fileData = {
            path: (path === null || path === undefined) ? fileName : path + fileName,
            name: (path === null || path === undefined) ? fileName : path + fileName,
            metadata: notebook.metadata,
            content: notebook.cells,
            type: "ipynb",
            stId: this.state.sourceStorageId,
            rFolder: this.state.sourceRootFolder
          }

          isSaveRequired = true;
          if (isSaveRequired) {
            this.setState({ tabloading: true })
            this.saveCell(path, fileData); //Save file with DF meta cell id
          }
          var indexNum = this.state.openFiles.findIndex(obj => obj.name === fileData.name && obj.stId === this.state.sourceStorageId);
          if (indexNum < 0) {
            let setindex = this.state.openFiles.length + 1
            this.state.newFile = true
            this.setState({
              openFiles: [...this.state.openFiles, fileData],
              sameindex: false,
              newFile: true,
              reloadbook: false,
              setTabIndex: setindex,
              fileToBeCreate: "Untitled.ipynb",
              tabloading: true
            }, () => {
              this.SaveRecentNotebook(newpath, this.state.sourceRootFolder, this.state.sourceStorageId);   // create storage file id with
            })
          } else {
            this.setState({
              setTabIndex: indexNum,
              sameindex: true,
              newFile: false,
              reloadbook: false,
              sameindexid: indexNum,
              fileToBeCreate: "Untitled.ipynb",
              tabloading: false
            })
          }
          this.tabFocus();

        }

      }
      else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Please Enter Notebook Name</b></i>);
      }
    }
  }
  showHome = () => {
    if (this.state.codeChangeFlag) {
      if (this.state.setTabIndex !== undefined) {
        this.codeChangeConfirmation(this.state.setTabIndex);
      }
    } else {
      let filename = "Home"
      this.state.fileType = "Home"
      this.loadHomeData(filename)
    }
  }

  handlePreviousTabHistory = (currentFileName, contentData, fileType, storageId, rootFolder) => {
    if (storageId !== undefined) {
      let fileData = {
        name: currentFileName,
        content: contentData,
        type: fileType,
        stId: storageId,
        rFolder: rootFolder
      }
      this.state.showVersion = false;

      var indexNum = this.state.openFiles.findIndex(obj => obj.name === currentFileName);
      if (indexNum < 0) {
        this.setState({
          openFiles: [...this.state.openFiles, fileData],
          sameindex: false,
          newFile: false,
          reloadbook: false,
        }, () => {
          if (fileType !== "ipynb") {
            this.saveNotebookLocalStroage(); // save open Notebook
          }         
        })
      } else {
        if (this.state.reloadbook === true) {
          this.state.openFiles[indexNum].content = contentData;
        }
        if (fileType === "csv") {
          this.state.openFiles[indexNum].content = contentData;
        }
        this.setState({
          setTabIndex: indexNum,
          sameindex: true,
          sameindexid: indexNum,
          activeIndex: indexNum,
          newFile: false,
          reloadbook: false,
        })
      }
      this.tabFocus();
    } else {
      this.tabFocus();
      this.state.showVersion = false;
    }
  }

  handleChangeSelectCluster = (event) => {
    this.setState({
      clusterName: event.value
    });
  }

  handleChangeRunTime = (event) => {
    this.setState({
      runTime: event.value,
      runTimeName: event.label
    });
  }

  GetRunningClusters = () => {
    ClusterService.getAllClusters()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.k8sDTOPage.content !== null) {
            let clusterdetails = response.k8sDTOPage.content.filter(item => item.clusterStatus === "RUNNING")
            const runningclusterdetails = clusterdetails.map((item, index) => {
              return (
                { label: <Badge color="" className="badge-dot"><i className="bg-success" />{item.name}</Badge>, value: item.id }
              )
            })
            let pushCreateCluster = {
              label: <a href={() => false} onClick={e => this.onOpenModal()} > Create a Cluster </a>, value: "Create a Cluster"
            };
            runningclusterdetails.push(pushCreateCluster);
            this.setState({ tabloading: false, clusterdetailsoptions: runningclusterdetails, allClusters: response.k8sDTOS })
          }
        } else {
          this.setState({ tabloading: false });
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      })
  }

  onOpenModalIntegration = () => {
    this.setState({
      openIntegration: true,
    })
  }

  onOpenModalStorage = () => {
    this.setState({
      openChooseStorage: true,
    })
  }

  onCloseModalIntegration = () => {
    this.setState({
      openIntegration: false
    })
  }

  onCloseModalConnectors = () => {
    this.setState({
      openConnectors: false
    })
  }

  onOpenModalConnectors = () => {
    this.GetRunningClusters();
    this.getRunTimeOptions();
    this.setState({
      openConnectors: true,
      clusterName: "",
      runTime: ""
    })
  }
  DeleteConnectorModal = (id, name) => {
    this.setState({
      deleteopen: true,
      deletename: name,
      deleteid: id
    })
  }

  /**
  * 
  * @param {current index of the ipynb file} index 
  */

  PostModelSpace = (index) => {
    let modelSpaceData = {
      clusterId: this.state.clusterName,
      storageFileId: this.state.localFileId,
      runtime: this.state.runTime,

    }
    if (modelSpaceData.clusterId === "") {
      this.setState({
        setModelError: "Please select a cluster."
      })
    }
    else if (modelSpaceData.clusterId === "Create a Cluster") {
      this.setState({
        setModelError: "Please select a valid cluster."
      })
    }
    else if (modelSpaceData.runtime === "") {
      this.setState({
        setModelError: "Please select a runTime."
      })
    } else {
      this.setState({
        setModelError: ""
      })
      this.onCloseModalConnectors();
      ModelSpaceService.createModelSpace(modelSpaceData).then((response) => {
        if (response.status === 'SUCCESS') {
          let wcId = response.modelSpaceDTOS.length !== 0 ? response.modelSpaceDTOS[0].id : "";
          let websocket = establishWSConnection(wcId)
          websocket.onmessage = this.onMessage;
          websocket.onerrror = this.onWebsoketError;
          websocket.onclose = this.onWebsoketClose;
          Promise.all([this.updateWsState(index, websocket, wcId, "Connecting"),
            this.updateConnectedInfoDetails(wcId),
            this.DisconnectWSIdle(wcId)]).then(values => {
          })
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      });
    }
  }

  /**
   * 
   * @param {index of the file} index 
   * @param {websocket url} websocket 
   * @param {connection id} wcId 
   * @param {websocket connection status} status 
   */

  updateWsState = (index, websocket, wcId, status) => {
    if (this.state.openFiles[this.state.activeIndex] !== undefined) {
      if (this.state.openFiles[this.state.activeIndex].type === 'ipynb') {
        this.state.openFiles[index].wsState = websocket;
        this.state.openFiles[index].wsConnectionId = wcId;
        this.state.openFiles[index].wsStatus = status;

        for (var i = 0; i < this.state.openFiles.length; i++) {
          this.setState({
            filePath: this.state.openFiles[i]
          });
        }
        this.saveNotebookLocalStroage();  // save notebook value 
      }
    }
  }

  DisconnectWSIfNoHeartBeat = (id) => {
    setTimeout(function () {
      if (this.state.openFiles.length !== 0) {
        try {
          let currentIndex = this.state.openFiles.findIndex(item => item.wsConnectionId === id)
          if (this.state.openFiles[currentIndex].type === 'ipynb') {
            let sTime = moment.utc(this.state.openFiles[currentIndex].wsCurrentTimeById).local().format('YYYY-MM-DD HH:mm:ss')
            let cTime = moment.utc(new Date()).local().format('YYYY-MM-DD HH:mm:ss')  // local time
            let startTime = new Date(sTime);
            let currentTime = new Date(cTime);
            var diff_seconds = (currentTime.getTime() - startTime.getTime()) / 1000;
            if (diff_seconds > 2 * 60) {
              this.closeWebsocket(currentIndex)
            }
          } else {
          }
        } catch (err) {

        }


      }
    }.bind(this), NOTEBOOK_WS_NOT_RECEIVE)
  }

  updateWsStateByConnectionId = (wId, status, time) => {
    if (this.state.openFiles.length !== 0) {
      let currentIndex = this.state.openFiles.findIndex(item => item.wsConnectionId === wId)
      try {
        if (this.state.openFiles[currentIndex].type === 'ipynb') {
          this.state.openFiles[currentIndex].wsStatus = status;
          this.state.openFiles[currentIndex].wsPreviousTimebyId = this.state.openFiles[currentIndex].wsCurrentTimeById;
          this.state.openFiles[currentIndex].wsCurrentTimeById = time;
          for (var i = 0; i < this.state.openFiles.length; i++) {
            this.setState({
              filePath: this.state.openFiles[i]
            });
          }
          this.saveNotebookLocalStroage();  // save notebook value 
        }
      } catch (err) {
      }
    }
  }

  /**
   * 
   * @param {*} event 
   */
  onMessage = (event) => {
    let data = JSON.parse(event.data);
    if (data) {
      if (data.action === "RESTART") {
        // hide play btn and connected info
        if (data.status === "success") {
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Kernel Restart Successfully!</b></i>);
        }
        if (data.status === "failed") {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Kernel Restart Failed</b></i>);

        }
        this.setState({
          disabledAction: false
        })
      } else if (data.action === "INTERRUPT") {
        // hide play btn and connected info
        if (data.status === "success" && this.state.InterruptToastFlag === false) {
          this.setState({
            InterruptToastFlag: true
          })
          toast.info(<i className="fas fa-info-circle">&nbsp; <b className="toast-txt">Runall Execution Stopped</b></i>);
        }
        if (data.status === "failed" && this.state.InterruptToastFlag === false) {
          this.setState({
            InterruptToastFlag: true
          })
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Failed to Stop Execution</b></i>);

        }
      } else {
        let currentData = this.state.openFiles.filter(item => item.wsConnectionId === data.id);
        if (currentData !== undefined) {
          if (data["keep-alive"] === true && currentData.length > 0 && currentData[0].wsConnectionId === data.id) {
            // Keep alive state date data
            // this.DisconnectWSIfNoHeartBeat(data.id);
            let status = "Connected"
            this.updateWsStateByConnectionId(data.id, status, data.time)
          } else {
            this.refs.splitCell.handleOutputData(data);
          }
        }
      }
    }
  }

  /**
  * 
  * @param {*} event 
  */
  onWebsoketError = (event) => {
    if (this.state.activeIndex !== undefined) {
      let status = undefined;
      let websocketState = {};
      let wsId = undefined;
    }
  }

  /**
* 
* @param {*} event 
*/
  onWebsoketClose = (event) => {
    if (this.state.activeIndex !== undefined) {
      let status = undefined;
      let websocketState = {};
      let wsId = undefined;
    }
  }

  // Delete Connector
  DeleteConnector = (id) => {
    ConnectorService.removeConnector(id).then((response) => {
      if (response.status === 'SUCCESS') {
        toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Connector Deleted Successfully!</b></i>);
        this.GetAllConnectors();
        this.CloseDeleteConnectorModal()
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
      }
    });
  }
  CloseDeleteConnectorModal = () => {
    this.setState({
      deleteopen: false,
    })
  }
  _fetchStorageItems = (prefix, pageToken, files, folders) => {
    this.setState({
      loading: "block"
    });
    let storageName = this.state.showFilesModal === true ? this.state.destinationStorageId : this.state.sourceStorageId;
    let rootFolder = this.state.showFilesModal === true ? this.state.destinationRootFolder : this.state.sourceRootFolder;
    StorageService.listObjects(prefix, storageName, rootFolder, pageToken)
      .then((response) => {
        files = [...files, ...response.result]
        folders = [...folders, ...response.prefixes]

        if (response.next_page_token) {
          this.state.nextPageToken = response.next_page_token
        } else {
          this.state.nextPageToken = null
        }
        this.setState({ folders: folders, filterfolder: folders, loading: "none", tabloading: false, loadflagStorage: false })
        this.setState({ files: files, filterfiles: files, loading: "none", tabloading: false, loadflagStorage: false })
        this.setState({ currFolder: prefix })
        this.constructNavigation()
      })
  }

  fetchStorageItems = (prefix, deselectAll, isSideSplited) => {
    if (deselectAll) {
      deselectAll()
    }
    this.setState({
      files: [],
      folders: [],
      nextPageToken: null,
      FilterFilesData: [],
      FilterFolderData: [],
    })
    this._fetchStorageItems(prefix, null, [], [], isSideSplited)
  }

  fetchProgress = (jobState, progressmsg, isSideSplited) => {
    let emptymsg = ""
    this.setState({ statemsg: progressmsg, dispayload: "block" })
    setTimeout(() => {
      this.setState({ statemsg: emptymsg, dispayload: "none" })
      this.fetchStorageItems(this.state.currFolder, null, false)
    }, 4000);

  }

  onNavigationClick = (event) => {
    event.preventDefault()
    this.fetchStorageItems(event.target.dataset.name)
  }
  constructNavigation = () => {
    let currFolder = this.state.currFolder
    let homeNav =
      <div className="breadcrumb-wrap" key={uuidv4()} active>
        <a href={() => false} data-name=''><i className="fas fa-folder mr-3"></i>/</a>
      </div>
    if (currFolder) {
      homeNav =
        <div className="breadcrumb-wrap" key={uuidv4()} >
          <a href={() => false} data-name='' onClick={this.onNavigationClick}><i className="fas fa-folder mr-3"></i> </a>
        </div>
    }
    let navigations = [
      homeNav
    ]
    if (currFolder) {
      let prefixes = currFolder.split('/').slice(0, -1)
      let lastPrefix = prefixes.length > 0 ? prefixes.pop() : null
      let name = ''
      for (const prefix of prefixes) {
        name = name + prefix + '/'
        navigations.push(

          <div className="breadcrumb-wrap" key={uuidv4()}>
            <span className="sep"><i className="fa fa-caret-right"></i></span> <span className="breadcrumb overflowStyleTree" title={prefix}><a href={() => false} data-name={name} onClick={this.onNavigationClick}>{prefix}</a></span>
          </div>
        )
      }
      if (lastPrefix) {
        navigations.push(
          <div className="breadcrumb-wrap active" key={uuidv4()}>
            <span className="sep"><i className="fa fa-caret-right"></i></span> <span className="breadcrumb overflowStyleTree" title={lastPrefix}>{lastPrefix}</span>
          </div>

        )
      }
    }
    this.setState({ storageNavigations: navigations })
  }

  onSearchFiles = (value) => {
    if (value === "") {
      this.setState({
        files: this.state.filterfiles,
        folders: this.state.filterfolder,
        fileSearch: value
      })
    } else {
      const filteredfiles = this.state.filterfiles.filter(item => item.name.toString().toLowerCase().includes(value.toLowerCase()));
      const filteredFolder = this.state.filterfolder.filter(item => item.toString().toLowerCase().includes(value.toLowerCase()));
      this.setState({
        files: filteredfiles,
        folders: filteredFolder,
        fileSearch: value
      })
    }
  }
  previewFile = (name, type, storageId, rootFolder) => {
    if (!this.state.showNotebookModal) {
      let myPath = name
      let onlyfilename = trimFileName(name)
      let ext = myPath.substring(myPath.lastIndexOf(".") + 1)
      this.setState({
        fileName: myPath,
        fileType: ext,
        onlyfilename: onlyfilename,
        loading: "block",
      })

      if (type !== "folder") {
        StorageService.downloadObjectUrl(myPath, storageId, rootFolder)
          .then((response) => {
            this.renderText(myPath, response.download_url, storageId, rootFolder);
            this.setState({ loading: "none", DownloadUrl: response.download_url });
          }).catch((error) => {
            if (type === "folder") {
              this.state.fileType = 'png'
              this.state.myContent = undefinedfile
              this.state.fileName = name
              this.state.onlyfilename = onlyfilename
              this.setState({ loading: "none", tabloading: false });
            }
            else {
              this.state.fileType = 'png'
              this.state.myContent = page404
              this.state.fileName = 'File Not Found!!!'
              this.setState({ loading: "none", tabloading: false });
            }
            if (this.state.onlyfilename === '') {
              this.state.onlyfilename = 'Home'
            }
          })
      } else {
        this.state.myContent = undefinedfile;
        this.state.fileName = name
        this.state.onlyfilename = onlyfilename
        this.setState({ loading: "none", fileType: "png", tabloading: false });
      }
    }
  }

  /**
 * Save cell after current index
 * @param {Array} notebook cells array
 * TODO: Enable versioning feature for notebook
 */
  saveCell = (file, data, index, from) => {
    this.setState({
      actionTrigger: true,
      tabloading: true
    })
    let currentStorageName;
    let currentrootFolder;
    if (index === undefined) {
      currentStorageName = this.state.sourceStorageId;
      currentrootFolder = this.state.sourceRootFolder
    } else {
      currentStorageName = this.state.openFiles[index].stId;
      currentrootFolder = this.state.openFiles[index].rFolder
    }
    this.setState({
      presentStorageName: currentStorageName,
      presentrootFolder: currentrootFolder
    })

    if (from === "onclickevent") {
      this.toggleSaveModal(data);
    }
    else if (data !== undefined) {
      let filePath = data.path;
      let fileType = data.type;
      let content = data.content;
      let metadata = data.metadata;
      let notebookContent;
      notebookContent = {
        cells: content,
        metadata: metadata,
        "nbformat": 4,
        "nbformat_minor": 0
      }
      saveFile(filePath, fileType, notebookContent, currentStorageName, currentrootFolder)

      setTimeout(() => {
        this.setState({
          codeChangeFlag: false,
          codeChangeFileName: "",
          codeChangeShowModal: false,
          actionTrigger: false,
          tabloading: false
        })
        this.fetchStorageItems(this.state.currFolder, null, true);
        this.checkOriginalVersion(filePath, currentStorageName, currentrootFolder);

      }, VERSIONTIMEOUT);
    } else {
      this.setState({
        actionTrigger: false
      })
    }
  }

  savePythonFile = (file, data, index) => {
    if (index !== undefined && file.length > 0) {
      let currentStorageName = this.state.openFiles[index].stId;
      let currentrootFolder = this.state.openFiles[index].rFolder
      let filePath = file[0].name;
      let fileType = file[0].type;
      let filecontent = file[0].content;
      if (data !== undefined) {
        this.setState({
          presentStorageName: currentStorageName,
          presentrootFolder: currentrootFolder
        })
        saveFile(filePath, fileType, filecontent, currentStorageName, currentrootFolder)
        this.setState({ showSaveModal: false, showVersion: false })
        this.fetchStorageItems(this.state.currFolder, null)
      }
    }
  }
  /**
   * Websocket connection to the Run-time
   */
  socketConnection = () => {
    let websocketConnection = establishWSConnection('')
    this.setState({ websocketState: websocketConnection })
  }
  addCodeNumber = (cells, path) => {
    if (cells.length !== 0) {
      let count = 1;
      for (var i = 0; i < cells.length; i++) {
        if (cells[i].cell_type === "code") {
          cells[i].metadata.codeindex = count++;
        }
      }
    }
  }

  /**
   * Add new cell after current index
   * @param {Array} notebook cells array
   */
  addNewCellafterIndex = (cells) => {
    addNewCodeAfter(cells, this.state.selectedIndex);
    this.updateFilePath();
    this.refs.splitCell.SelectParticularIdCode(cells[this.state.selectedIndex + 1].source, cells[this.state.selectedIndex + 1].metadata.decisionforce_cell_id, this.state.selectedIndex + 1, false)
    this.addCodeNumber(cells)
  }

  /**
   * Add new cell after current index
   * @param {Array} notebook cells array
   */
  addNewMarkdownafterIndex = (cells) => {
    addNewMarkDownAfter(cells, this.state.selectedIndex);
    this.updateFilePath();
    this.refs.splitCell.SelectParticularIdMarkdown(cells[this.state.selectedIndex + 1].source, cells[this.state.selectedIndex + 1].metadata.decisionforce_cell_id, this.state.selectedIndex + 1, false)
    this.addCodeNumber(cells)
  }

  /**
   * Add new cell after current index
   * @param {Array} notebook cells array
   * @param {Number} current index of the cell
   */
  addNewMarkdownCellafterIndex = (cells) => {
    addNewMarkDownAfter(cells, this.state.selectedIndex);
    this.updateFilePath();
    this.addCodeNumber(cells)
  }

  /**
   * move the cell to top
   * @param {Number} current index
   * @param {Number} cell target index decrement 1 with current index
   */
  moveUpcellData = (cells) => {
    let secondIndex = this.state.selectedIndex - 1;
    if (Math.sign(secondIndex) !== -1) {
      moveupCell(cells, this.state.selectedIndex, secondIndex);
      this.setState({
        selectedIndex: secondIndex
      })
      this.updateFilePath();
      this.addCodeNumber(cells)
    }
  }

  _getSelectedIndex = (index) => {
    this.setState({
      selectedIndex: index
    })
  }
  _getCodeChangeIndex = (flag) => {
    this.setState({
      codeChangeFlag: flag
    })
  }
  _stateValuesUpdate = () => {
    this.setState({
      codeChangeFlag: false,
      codeChangeShowModal: false,
      codeChangeFileName: "",
    })
  }

  /**
   * move the cell to down
   * @param {Number} current index
   * @param {Number} cell target index increment 1 with current index
   */
  moveDowncellData = (cells) => {
    let secondIndex = this.state.selectedIndex + 1;
    movedownCell(cells, this.state.selectedIndex, secondIndex);
    this.setState({
      selectedIndex: secondIndex
    })
    this.updateFilePath();
    this.addCodeNumber(cells)
  }

  /**
   * Clear output for all cells
   * @param {Array of cells} cells 
   */
  clearCellOutput = (cells) => {
    this.setState({
      actionTrigger: true
    })
    let fileProperty = this.state.openFiles[this.state.activeIndex];
    if (cells !== undefined && cells.length !== 0) {
      for (var index = 0; index < cells.length; index++) {
        let updatedCells = clearCellOutputByIndex(cells, fileProperty, index);
        if (updatedCells !== undefined) {
          this.updateFilePath();
          this.addCodeNumber(cells)
        }
        if (index === cells.length - 1) {
          this.setState({
            actionTrigger: false
          })
        }
      }
    } else {
      this.setState({
        actionTrigger: false
      })
    }
  }

  /**
   * remove the cell based on index
   * @param {cellsData} current index
  */
  removeCellData = (cells, index) => {
    this.updateFilePath();
    this.addCodeNumber(cells)
    removeCell(cells, index)
    this.onSaveContent()
  }

  removeCellConfirmation = (cells) => {
    let selectindex = this.state.selectedIndex;
    confirmAlert({
      title: "Confirm to Delete",
      message: 'Are you sure want to delete this cell',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.removeCellData(cells, selectindex)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  /**
   * remove the cell based on index
   * @param {cellsdata} current
  */
  runAll = (notebookContent, wcId) => {
    let websocket_connection = notebookContent.wsState;
    let websocket_status = notebookContent.wsStatus;
    if (websocket_connection !== undefined && websocket_status === "Connected") {
      let currentIndex = this.state.openFiles.findIndex(item => item.wsConnectionId === wcId)
      if (notebookContent.wsConnectionId === wcId) {
        this.state.openFiles[currentIndex].runAllFlag = false;
        this.state.openFiles[currentIndex].InterruptFlag = false;
        this.state.InterruptToastFlag = false;
      }
      let cells = notebookContent.content;
      if (Array.isArray(cells)) {
        for (let i = 0; i < cells.length; i++) {
          cells[i].outputs = [];
        }
      }
      this.updateFilePath();
      this.refs.splitCell.onCellRender_RunAll(websocket_connection, notebookContent, 0);
    } else {
      toast.info(<i className="fas fa-info-circle">&nbsp; <b className="toast-txt">Runtime Environment Not Connected</b></i>);
    }

  }


  stopCell = (notebookData, wcId) => {
    this.setState({
      actionTrigger: false
    })
    try {
      // notebookData.metadata.runAllBtn = true;
      let currentIndex = this.state.openFiles.findIndex(item => item.wsConnectionId === wcId)
      if (notebookData.wsConnectionId === wcId) {
        this.state.openFiles[currentIndex].runAllFlag = true;
      }
      this.refs.splitCell.stopCell(undefined);
      this.updateFilePath();
    } catch (err) {
    }
  }

  /**
   * remove the title from tabs based on index
   * @param {Array} open files array
   * @param {Number} current index
  */
  removeIndexBefore = (titles, index, type) => {
    if (this.state.codeChangeFlag) {
      this.codeChangeConfirmation(index);
    } else {
      if (type === "ipynb") {
        if (titles.length !== 0) {
          var ws = titles[index].wsState;
          var stat = titles[index].wsStatus;
          if (ws !== undefined || JSON.stringify(ws) !== "{}") {
            if (stat !== undefined) {  // remove ws while status is connected or connecting
              this.removeWsOnTabclose(ws);
            }
            this.removeIndex(titles, index);
          }
        }
      } else {
        this.removeIndex(titles, index);
      }
    }
  }

  removeIndex = (titles, index) => {
    this.state.showVersion = false;

    removeCell(titles, index);
    this.setState({
      openFiles: titles,
    }, () => {
      var cIndex = index - 1;
      if (cIndex < 0) { //if index is negative number set tab index as 0
        this.setState({
          setTabIndex: 0
        }, () => {
          this.saveNotebookLocalStroage();
        })
      } else {
        this.setState({
          setTabIndex: index - 1
        }, () => {
          this.saveNotebookLocalStroage();
        })
      }
    })
    /** if the open files array length is empty set tab index as 0 */
    if (titles.length === 0) {
      this.setState({
        setTabIndex: 0,
        openFiles: []
      }, () => {
        this.getRecentNotebooksList();
        this.saveNotebookLocalStroage(); // save open Notebook
      })
    }
  }

  updateFilePath = () => {
    if (this.state.openFiles.length !== 0) {
      for (var i = 0; i < this.state.openFiles.length; i++) {
        this.setState({
          filePath: this.state.openFiles[i]
        });
      }
    }
  }

  removeWsOnTabclose = (ws) => {
    if (ws !== undefined) {
      try {
        ws.close();
      } catch (err) {

      }

    }
  }

  renderText = (filePath, url, storageId, rootFolder) => {
    this.state.showVersion = false;
    this.setState({oldTab:false})
    if (this.state.codeChangeFlag) {
      this.codeChangeConfirmation(this.state.setTabIndex)
    } else {
      this.setState({
        loading: "block",
        tabloading: true,
        modelspaceConnectedList: []
      })
      if (this.state.fileType === "jpeg" || this.state.fileType === "jpg" || this.state.fileType === "png") {
        {/** Already opened files auto focus to file */ }
        this.handlePreviousTabHistory(filePath, url, this.state.fileType, storageId, rootFolder)
        this.setState({
          myContent: url,
          loading: "none",
          tabloading: false
        })
        this.tabFocus();
      } else if (this.state.fileType === "pdf") {
        this.setState({
          myContent: url,
          loading: "none",
          tabloading: false
        })
        this.handlePreviousTabHistory(filePath, url, this.state.fileType, storageId, rootFolder)

      } else if (this.state.fileType === "xlsx" || this.state.fileType === "xls") {
        this.setState({ sheetName: [], tabloading: true })
        var url = url;
        var req = new XMLHttpRequest();
        req.open("GET", url, true);
        var result = [];
        req.responseType = "arraybuffer";
        req.onload = (e) => {
          var data = new Uint8Array(req.response);
          var wb = XLSX.read(data, { type: "array" });
          const sheet = wb.Sheets;
          this.setState({ keyValue: sheet })
          let filtervalues = Object.values(this.state.keyValue);
          for (const [key, value] of Object.entries(sheet)) {
            const ws = wb.Sheets[key];
            let list = this.state.sheetName.push(key);
            const html = XLSX.utils.sheet_to_csv(filtervalues[0]);
            result = CSVToJSONs(html, ',');
            this.setState({
              hotSettings: result,
              tabloading: false,
              readonlyTable: false,
              activeExcel: this.state.sheetName[0]
            })
            this.handlePreviousTabHistory(filePath, url, this.state.fileType, storageId, rootFolder)
          }
        };
        req.send();
      } else if (this.state.fileType === "Home") {
        this.loadHomeData(filePath);
        this.tabFocus();

      } else {
        axios.get(url)
          .then(response => {
            if (this.state.fileType === "ipynb") {
              let notebook = response.data;
              if (Array.isArray(notebook.cells)) {
                this.setState({
                  selectedIndex: 0,
                  loading: "none",
                  tabloading: false
                }, () => {
                  // Get notebook cell with id 
                  Promise.all([this.getNotebookCellsData(filePath, notebook, storageId, rootFolder)]).then(values => {
                    if (this.state.recentFlag === true) {
                      this.createUpdateRecentNotebook();
                    } else {
                      this.SaveRecentNotebook(filePath, rootFolder, storageId);   // create storage file id with
                    }
                    // check if there is original version created
                    this.checkOriginalVersion(filePath, storageId, rootFolder);

                  })
                })
              } else {
                toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Invalid Notebook</b></i>);
                this.setState({ loading: "none", tabloading: false })
              }
            } else if (this.state.fileType === "csv") {
              this.setState({
                activePage: 1,
                loading:"block"
              }, () => {
                let result = [];
                if (response.data !== null && response.data.length > 0) {
                   result = CSVToJSONs(response.data, this.state.delimiter);
                  this.setState({
                    wholeGraphData: result,
                    tabloading: false,
                    loading:"none"

                  })
                }
                else {
                  this.setState({
                    wholeGraphData: [],
                    tabloading: false
                    // Empty the csv content value
                  });
                }
                 this.handlePreviousTabHistory(filePath, result, this.state.fileType, storageId, rootFolder)
                 this.tabFocus();
              })
            } else if ((this.state.fileType === "zip") || (this.state.fileType === "tar") || (this.state.fileType === "rar") || (this.state.fileType === "gz") || (this.state.fileType === "exe")) {
              {/** Already opened files auto focus to file */ }
              this.handlePreviousTabHistory(filePath, unknownfile, this.state.fileType, storageId, rootFolder)
              this.setState({
                fileType: "png",
                myContent: unknownfile,
                loading: "none",
                tabloading: false
              })
            }
            else if (this.state.fileType === "py") {
              this.setState({
                tabloading: false
              })
              this.handlepyfile(filePath, response.data.toString(), storageId, rootFolder)
            }
            else {
              this.handlePreviousTabHistory(filePath, response.data.toString(), this.state.fileType, storageId, rootFolder)
              this.setState({
                myContent: response.data.toString(),
                loading: "none",
                tabloading: false,
                fileType: "others",
                sameindex: false,
                newFile: false,
                reloadbook: false,
              })
              if (this.state.openFiles.length !== 0) {
                try {
                  this.updateNotebookContent(this.state.openFiles[this.state.setTabIndex].name, this.state.setTabIndex, this.state.openFiles[this.state.setTabIndex].type, this.state.openFiles[this.state.setTabIndex].stId, this.state.openFiles[this.state.setTabIndex].rFolder); // default session notebook load
                } catch (err) {
                  this.updateNotebookContent(this.state.openFiles[0].name, 0, this.state.openFiles[0].type, this.state.openFiles[0].stId, this.state.openFiles[0].rFolder); // default session notebook load
                }
                this.saveNotebookLocalStroage();
              }

            }
            /**auto focus tab for choose files */
            this.tabFocus();
          });
      }
    }

  }
  checkOriginalVersion = (filePath, storageId, rootFolder) => {
    this.setState({ tabloading: true })
    let prefix = filePath + '/';
    let pageToken = null;
    StorageService.listVersionObjects(prefix, null, storageId, rootFolder, pageToken)
      .then((response) => {
        this.setState({ listversioning: response.result });
        if (response.result.length === 0) {
          this.SaveOriginalVersion(filePath, storageId, rootFolder);
          this.setState({ disableicon: true })
        }
        else {
          this.setState({ disableicon: false, tabloading: false })
        }
      }).catch((error) => {
      })
  }

  SaveOriginalVersion = (filePath, storageId, rootFolder) => {
    this.setState({ tabloading: true })
    let originaldata = {
      "filePath": filePath,
    }
    let sourceStorage = {}
    if (storageId !== null && storageId !== undefined && storageId !== "") {
      sourceStorage.storageId = storageId
    }
    if (rootFolder !== null && rootFolder !== undefined && rootFolder !== "") {
      sourceStorage.rootFolder = rootFolder
    }
    if (Object.keys(sourceStorage).length > 0) {
      originaldata.rootFolder = sourceStorage
      originaldata.sourceStorage = sourceStorage
    }

    FileJobsService.ViewOriginalVersion(originaldata)
      .then((response) => {
        let sJobId = response.jobId;
        setTimeout(() => this.getStorageJobId(sJobId, this.state.count), VERSIONTIMEOUT);
      });
  }

  getStorageJobId = (storageJobId, count) => {
    FileJobsService.GetStorageJobId(storageJobId)
      .then((response) => {
        if (response.jobStateList !== null && response.jobStateList !== []) {
          if (response.jobStateList.length > 0) {
            let jobState = response.jobStateList[0].jobState;
            this.setState({ jobState: jobState })
            this.setJobState(jobState, storageJobId, count)
          }
        }
      });
  }
  setJobState = (jobState, storageJobId, count) => {
    if (jobState === "FINISHED") {
      this.setState({ disableicon: false, tabloading: false })
    }
    else if (jobState === "ERROR") {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Error in Creating Original Version</b></i>);
      this.setState({ disableicon: false, tabloading: false })
    }
    else if (jobState === "PROCESSING") {
      this.setState({ count: count + 1 })
      if (this.state.count <= 5) {
        setTimeout(() => this.getStorageJobId(storageJobId, this.state.count), VERSIONTIMEOUT);
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Error in Creating Original Version</b></i>);
        this.setState({ disableicon: false, tabloading: false })
      }
    }
    else if (jobState === "FAILED") {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Error in Creating Original Version</b></i>);
      this.setState({ disableicon: false, tabloading: false })
    }
  }
  renderVersion = (filePath, url, storageId, rootFolder) => {
    axios.get(url)
      .then(response => {
        let notebook = response.data
        this.setState({
          loading: "block",
          tabloading: true
        }, () => {
          if (Array.isArray(notebook.cells)) {
            if (notebook.cells.length !== 0) {
              let count = 1;
              for (var i = 0; i < notebook.cells.length; i++) {
                if (!notebook.cells[i].metadata.hasOwnProperty("decisionforce_cell_id")) {
                  let metatab = { "decisionforce_cell_id": uuidv4() }
                  notebook.cells[i].metadata = metatab
                }
                if (notebook.cells[i].cell_type === "code") {
                  notebook.cells[i].metadata.codeindex = count++;
                }
              }
              let fileData = {
                path: filePath,
                name: filePath,
                metadata: notebook.metadata,
                content: notebook.cells,
                type: this.state.fileType,
                stId: storageId,
                rFolder: rootFolder
              }
              var indexNum = this.state.openFiles.findIndex(obj => obj.name === filePath);
              this.state.openFiles[indexNum] = fileData;
              this.setState({
                loading: "none",
                tabloading: false
              })
            }
          }
          return this.state.openFiles;
        })
      })
  }

  SaveRecentNotebook = (filePath, rootFolder, storageName) => {  // For create storage file ID
    this.setState({ tabloading: true })
    let recentDataNote = {
      filePath: filePath,
      rootFolder: rootFolder,
      storageId: storageName,
    }
    ModelSpaceService.createStorageFileID(recentDataNote)
      .then((response) => {
        if (response.status === 'SUCCESS') {  //  get storge file id for create recent notebook creation
          this.setState({
            localFileId: response.storageFileDTO.id,
            tabloading: false
          }, () => this.createUpdateRecentNotebook())
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);

        }
      })
  }

  tabFocus = () => {
    if(this.state.oldTab === false) {
        let tabLength = this.state.openFiles.length - 1
        this.setState({ setTabIndex: tabLength, activeIndex: tabLength })
      }
    if ((this.state.oldTab === true)) {
      this.setState({ setTabIndex: this.state.clickindex, activeIndex: this.state.clickindex })
    }
    if(this.state.newFile === true){
      let tabLength = this.state.openFiles.length
      this.setState({ setTabIndex: tabLength, activeIndex: tabLength })
    }
    this.setState({ showVersion: false })
    this.state.showVersion = false;
  }
  refreshstorage = (e, st) => {
    this.fetchStorageItems(this.state.currFolder, null)
  }

  createUploadFolders = (currFolder) => {
    let foldersToBeCreate = []
    currFolder = !currFolder ? '' : currFolder
    for (const file of this.state.folderUploadFiles) {
      let folderName = (file._relativePath || file.webkitRelativePath).replace(file.name, "")
      if (folderName.startsWith("/")) {
        folderName.replace("/", "")
      }
      if (foldersToBeCreate.indexOf(folderName) === -1) {
        foldersToBeCreate.push(folderName)
        const actulaFolderPath = path.join(currFolder, folderName)
        StorageService.createPrefix(actulaFolderPath)
          .then(response => { })
      }
    }
  }
  _filePondProcess = (fieldName, file, metadata, load, error, progress, abort, transfer, options, currFolder, isFromSplit) => {
    currFolder = currFolder ? currFolder : ''
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const fileToBeUpload = file
    let fileName = fileToBeUpload._relativePath ? fileToBeUpload._relativePath : (fileToBeUpload.webkitRelativePath ? fileToBeUpload.webkitRelativePath : fileToBeUpload.name)
    if (fileName.startsWith('/')) {
      fileName = fileName.replace('/', '')
    }
    const objectName = path.join(currFolder, fileName)
    StorageService.uploadObjectUrl(objectName, this.state.sourceStorageId, this.state.sourceRootFolder)
      .then((response) => {
        if (response.type === provisioners.google) {
          axios({
            url: response.upload_url,
            baseURL: '',
            data: {},
            headers: {
              'content-type': fileToBeUpload.type,
              'x-goog-resumable': 'start'
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            const resumableLink = resp.headers.location
            CommonService({
              url: resumableLink,
              baseURL: '',
              data: fileToBeUpload,
              headers: {
                'content-type': "multipart/form-data"
              },
              method: 'PUT',
              cancelToken: source.token,
              onUploadProgress: function (e) {
                progress(e.lengthComputable, e.loaded, e.total)
              }
            }).then((resp) => {
              load(fileToBeUpload.name)
            })
          })
        } if (response.type === provisioners.aws) {
          var rest = response.fields;
          var formData = new FormData();
          for (const [key, value] of Object.entries(rest)) {
            formData.append(key, value)
          }
          formData.append("file", fileToBeUpload)
          axios({
            url: response.upload_url,
            data: formData,
            headers: {
              'Content-Type': "multipart/form-data"
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            load(fileToBeUpload.name)
          })
        }

        if (response.type === provisioners.azure) {
          axios({
            url: response.upload_url,
            data: fileToBeUpload,
            headers: {
              'content-type': "multipart/form-data",
              'x-ms-blob-type': 'BlockBlob'
            },
            method: 'PUT',
            cancelToken: source.token
          }).then((resp) => {
            load(fileToBeUpload.name)
          })
        }
      })
    return {
      abort: () => {
        try {
          // This function is entered if the user has tapped the cancel button
          source.cancel()

          // Let FilePond know the request has been cancelled
          abort();
        } catch (ex) {
        }
      }
    }
  }

  filePondProcess = (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
    this._filePondProcess(fieldName, file, metadata, load, error, progress, abort, transfer, options, this.state.currFolder, false)
  }
  toggleFolderCreate = () => {
    this.setState({
      popoverOpenFolderCreate: !this.state.popoverOpenFolderCreate
    });
  }

  toggleRenameCopyMoveAction = () => {
    if (this.state.showCopyMoveActionModal) {
      this.setState({ showCopyMoveActionModal: false })
    } else {
      this.setState({ showCopyMoveActionModal: true })
    }
  }

  toggleNavbartools = () => {
    if (this.state.showNotebookTools) {
      this.setState({ showNotebookTools: false })
    } else {
      this.setState({ showNotebookTools: true })
    }
  }

  toggleforStorage = () => {
    this.setState({
      navActionFlag: !this.state.navActionFlag
    });
  }

  toggleConnectedInfo = () => {
    this.setState({
      popoverFileConnectedInfo: !this.state.popoverFileConnectedInfo
    });
  }

  togglecodeChangeShowModal = () => {
    this.setState({
      codeChangeShowModal: !this.state.codeChangeShowModal
    });
  }

  toggleConfirmationCopyMove = () => {
    if (this.state.showConfirmationCopyMove) {
      this.setState({ showConfirmationCopyMove: false })
    } else {
      this.setState({ showConfirmationCopyMove: true })
    }
  }

  toggleNavbartools = () => {
    if (this.state.showNotebookTools) {
      this.setState({ showNotebookTools: false })
    } else {
      this.setState({ showNotebookTools: true })
    }
  }

  OverrideAction = () => {
    if (this.state.modeTransfer === "Copy") {
      FileJobsService.CopyFile(this.state.dataAction)
        .then((response) => {
          this.fetchProgress(response.jobState, response.message)
          setTimeout(() => {
            this.fetchStorageItems(this.state.currFolder, null, true)
          }, VERSIONTIMEOUT);
          this.resetSamedirectoryDataDTO();

        });
    } else if (this.state.modeTransfer === "Move") {
      FileJobsService.MoveFile(this.state.dataAction)
        .then((response) => {
          this.fetchProgress(response.jobState, response.message)
          setTimeout(() => {
            this.fetchStorageItems(this.state.currFolder, null, false)
          }, VERSIONTIMEOUT);
        });
      this.resetSamedirectoryDataDTO();
    }
  }

  resetSamedirectoryDataDTO = () => {
    this.setState({
      dataAction: "",
      modeTransfer: ""
    })
  }

  closeCreateFolder = (event) => {
    this.setState({ popoverOpenFolderCreate: false })
  }
  handleInputChange = (event) => {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  handleInputChangeFile = (event) => {
    const target = event.target
    const value = target.value.replace(/[^\w\s]/gi, "")
    const name = target.name
    this.setState({
      [name]: value
    })
  }
  toggleUpload = () => {
    if (this.state.showUploadFiles) {
      this.setState({ showUploadFiles: false })
    } else {
      this.setState({ showUploadFiles: true })
    }
  }
  toggleUploadNotebook = () => {
    if (this.state.showNotebookModal) {
      this.setState({ showNotebookModal: false })
    } else {
      this.fetchStorageItems(this.state.currFolder, null, false);
      this.setState({ showNotebookModal: true, fileToBeCreate: "" })
    }
  }
  showFolderUpload = () => {
    this.folderUploadRef.current.click()
  }
  toggleFolderUpload = () => {
    if (this.state.showFolderUploadModal) {
      this.setState({ showFolderUploadModal: false })
    } else {
      this.setState({ showFolderUploadModal: true })
    }
  }
  onCreateFolderClick = (event, isSidePane) => {
    event.preventDefault()
    this.createFolder(this.state.folderToBeCreate, isSidePane)
  }
  createFolder = (folderName, isSidePane) => {
    let currFolder;
    currFolder = this.state.currFolder ? this.state.currFolder : ''
    let prefixName = path.join(currFolder, folderName)
    if (!prefixName.endsWith("/")) {
      prefixName = prefixName + "/"
    }
    StorageService.createPrefix(prefixName)
      .then((response) => {
        this.closeCreateFolder()
        this.setState({ folderToBeCreate: null })
        this.toggleFolderCreate()
        this.fetchStorageItems(prefixName, null, false)
      })
  }
  closeCreateFolder = (event) => {
    this.setState({ popoverOpenFolderCreate: false })
  }
  handleFolderUploadFiles = (e, isFromSplit) => {
    this.setState({ folderUploadFiles: [...e.target.files] }, () => {
      this.toggleFolderUpload()
    })
  }
  selectCopyFile = (fromwats, pastewat, isDirectory) => {
    this.setState({ sourcecopy: fromwats, pastefrom: pastewat, isitDir: isDirectory })
  }
  selectMoveFile = (fromwats, pastewat, isDirectory) => {
    this.setState({ sourcemove: fromwats, pastefrom: pastewat, isitDir: isDirectory })
  }
  toggleShowFiles = (currFolder, ShowFold, fromwats, from, isDirectory) => {
    this.state.showAllFolders = true;
    let cfold = currFolder;
    if (ShowFold === 'true') {
      if (from === 'Move') {
        this.state.showbutton = 'Move'
        this.state.sourcemove = fromwats;
        this.setState({ showAllFolders: true, sourcemove: fromwats, isitDir: isDirectory })
        this.fetchStorageItems(cfold, null, false)
      } else {
        this.state.showbutton = 'Copy'
        this.state.sourcecopy = fromwats;
        this.setState({ showAllFolders: true, sourcecopy: fromwats, isitDir: isDirectory })
        this.fetchStorageItems(cfold, null, false)
      }
    }
    if (this.state.showFilesModal) {
      this.setState({ showFilesModal: false })
    } else {
      this.setState({ showFilesModal: true })
    }
  }
  cancelMove = () => {
    this.setState({ showFilesModal: false });
  }
  GetAllConnectors = () => {
    ConnectorService.getAllConnectorsByList()
      .then((response) => {
        response.connectorDTOS.length !== 0 ? this.setState({ connectordetails: response.connectorDTOS }) : console.log("");
      }
      );
  }
  onCopyConnectorName = (name) => {
    var tempInput = document.createElement("input");
    tempInput.value = name;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied</b></i>);
  }
  /* To get Input Text */
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  handleTypeChange = (e) => {
    this.setState({ connectiontype: e.target.value })
  }
  handlechangeTimeout = e => {
    this.setState({ connectiontimeout: e.target.value });

  };
  cancelClick = () => {
    this.onCloseModal();
  }
  handleSwitch(elem, state) {
    this.setState({ enableWriteAccess: state })
  }
  handleScroll = (e) => {
    e.preventDefault()
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      let prefix = null
      let files = []
      let folders = []
      let pageToken = null
      let isSideSplited = false
      prefix = this.state.currFolder
      files = this.state.files
      folders = this.state.folders
      pageToken = this.state.nextPageToken
      this.setState({
        FilterFilesData: [],
        FilterFolderData: [],
      })
      if (pageToken) {
        this.setState({
          loadmoreFlag: true
        })
        this._fetchStorageItems(prefix, pageToken, files, folders, isSideSplited)
      } else {
        this.setState({
          loadmoreFlag: false
        })
      }
    }
  }
  /**
    @param {clindex} currnt tab click index
    @param {acindex} active index
  */
  onTabclick = (clindex, acindex, oldTab) => {
    this.setState({
      tabloading: true,
      loading:"block",
      oldTab:oldTab,
      clickindex:clindex
    })
    this.state.showVersion = false;
    if (this.state.codeChangeFlag) {
      localStorage.setItem("lastopenTab", acindex);
      this.setState({
        setTabIndex: acindex,
        activeIndex: acindex,
        modelspaceConnectedList: [],
        tabloading: false,
        loading:"none"

      })
      // ask confirmation to save if file edit
      this.codeChangeConfirmation(acindex);
    } else {
      localStorage.setItem("lastopenTab", clindex);
      this.setState({
        setTabIndex: clindex,
        activeIndex: clindex,
        modelspaceConnectedList: [],
        tabloading: false
      }, () => {

        if (this.state.openFiles.length !== 0) {
          try {
              this.setState({
                tabloading: false
              })
              this.updateNotebookContent(this.state.openFiles[clindex].name, clindex,
                this.state.openFiles[clindex].type, this.state.openFiles[clindex].stId, this.state.openFiles[clindex].rFolder)
          } catch (err) {
          }
        }
      })
    }
  }
  setErrorMessage(message) {
    if (message === "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }
  }
  // Submit New Connection Data
  CreateNewConnection = (event) => {
    event.preventDefault();
    if (this.state.connectiontype === "Snowflake") {
      if ((this.state.name === "" || this.state.name === undefined)) {
        this.setErrorMessage("Please Enter Name");
      } else if (this.state.connectiontype === "") {
        this.setErrorMessage("Please Select Type");
      } else if (this.state.server === "") {
        this.setErrorMessage("Please Enter Server");
      } else if (!CheckIsValidDomain(this.state.server)) {
        this.setErrorMessage("Please Enter Valid Server");
      } else if (this.state.warehouse === "") {
        this.setErrorMessage("Please Enter Warehouse");
      } else if (this.state.user === "") {
        this.setErrorMessage("Please Enter User");
      } else if (this.state.password === "") {
        this.setErrorMessage("Please Enter Password");
      } else {
        this.PostConnection();
      }
    }
    if (this.state.connectiontype === "AmazonS3") {
      if ((this.state.name === "" || this.state.name === undefined)) {
        this.setErrorMessage("Please Enter Name");
      }
      else if ((this.state.bucketName === "" || this.state.bucketName === undefined)) {
        this.setErrorMessage("Please Enter Bucket Name");
      }
      else if ((this.state.accessKey === "" || this.state.accessKey === undefined)) {
        this.setErrorMessage("Please Enter Access Key");
      }
      else if ((this.state.secretKey === "" || this.state.secretKey === undefined)) {
        this.setErrorMessage("Please Enter Secret Key");
      } else {
        this.PostConnection();
      }
    }
    if (this.state.connectiontype === "MongoDB") {
      if ((this.state.name === "" || this.state.name === undefined)) {
        this.setErrorMessage("Please Enter Name");
      } else if ((this.state.host === "" || this.state.host === undefined)) {
        this.setErrorMessage("Please Enter Host");
      }
      else if ((this.state.port === "" || this.state.port === undefined)) {
        this.setErrorMessage("Please Enter Port");
      }
      else if ((this.state.user === "" || this.state.user === undefined)) {
        this.setErrorMessage("Please Enter User Name");
      }
      else if ((this.state.password === "" || this.state.password === undefined)) {
        this.setErrorMessage("Please Enter Password");
      }
      else if ((this.state.database === "" || this.state.database === undefined)) {
        this.setErrorMessage("Please Enter Database Name");
      } else {
        this.PostConnection();
      }
    }
    if (this.state.connectiontype === "DataLake") {
      if ((this.state.name === "" || this.state.name === undefined)) {
        this.setErrorMessage("Please Enter Name");
      }
      else if ((this.state.dataLake_blobName === "" || this.state.dataLake_blobName === undefined)) {
        this.setErrorMessage("Please Enter Blob Name");
      }
      else if ((this.state.dataLake_accountKey === "" || this.state.dataLake_accountKey === undefined)) {
        this.setErrorMessage("Please Enter Account Key");
      }
      else if ((this.state.dataLake_sasKey === "" || this.state.dataLake_sasKey === undefined)) {
        this.setErrorMessage("Please Enter Sas Key");
      }
      else if ((this.state.dataLakeSchema === "" || this.state.dataLakeSchema === undefined)) {
        this.setErrorMessage("Please Enter Schema");
      }
      else if ((this.state.dataLake_url === "" || this.state.dataLake_url === undefined)) {
        this.setErrorMessage("Please Enter Url");
      } else {
        this.PostConnection();
      }
    }
  }
  PostConnection = () => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      let connectorData = ""
      if (this.state.connectiontype === "Snowflake") {
        connectorData = {
          connectionTimeout: this.state.connectiontimeout,
          enableWriteAccess: this.state.enableWriteAccess,
          password: this.state.password,
          role: this.state.role,
          server: this.state.server,
          username: this.state.user,
          warehouse: this.state.warehouse,
        }
      }
      if (this.state.connectiontype === "AmazonS3") {
        connectorData = {
          bucketName: this.state.bucketName,
          accessKeyId: this.state.accessKey,
          secretAccessKey: this.state.secretKey
        }
      }
      if (this.state.connectiontype === "MongoDB") {
        connectorData = {
          host: this.state.host,
          port: this.state.port,
          password: this.state.password,
          username: this.state.user,
          database: this.state.database,
        }
      }
      if (this.state.connectiontype === "DataLake") {
        connectorData = {
          accountKey: this.state.dataLake_accountKey,
          sasKey: this.state.dataLake_sasKey,
          blobName: this.state.dataLake_blobName,
          url: this.state.dataLake_url,
          schema: this.state.dataLakeSchema,
        }
      }
      let post = {
        accountId: localStorage.getItem("accountId"),
        active: true,
        description: this.state.connectordescription,
        enable: this.state.enableConnector,
        connectorConfig: connectorData,
        name: this.state.name,
        type: this.state.connectiontype,

      }
      ConnectorService.PostConnector(post)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Connector Created Successfully!</b></i>);
            // focus active Tab
            this.setState({
              Addopen: false
            })
            this.clearformData();   // Reset Form data    
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
          }
        }
        );
    } else {
      console.error('Invalid Form')
    }
  }

  // Reset form data
  clearformData() {
    this.setState({
      name: "",
      connectiontype: "",
      server: '',
      warehouse: '',
      user: '',
      password: '',
      bucketName: "",
      accessKey: "",
      secretKey: "",
      database: "",
      port: "",
      host: "",
      connectiontimeout: 0,
      dataLake_accountKey: "",
      dataLake_blobName: "",
      dataLake_sasKey: "",
      dataLakeSchema: "",
      dataLake_url: "",
      connectordescription: ""

    })
  }

  DeleteConnectorConfirmation = (id, name) => {
    confirmAlert({
      title: "Delete Connector",
      message: 'Are you sure to delete this connector? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.DeleteConnector(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }

  codeChangeConfirmation = (index) => {
    if (this.state.openFiles.length !== 0 && index !== undefined) {
      let name = this.state.openFiles[index].name.split("/").pop();
      this.setState({
        codeChangeIndex: index,
        codeChangeFileName: name
      }, () => {
        this.togglecodeChangeShowModal();
      })
    }
  }

  // On save the content if changed
  onSaveContent = () => {
    if (this.state.openFiles.length !== 0 && this.state.codeChangeIndex !== undefined) {
      let item = this.state.openFiles[this.state.codeChangeIndex];
      let type = this.state.openFiles[this.state.codeChangeIndex].name.split(".").pop();
      this.setState({
        codeChangeFlag: false,
        codeChangeShowModal: false,
        codeChangeFileName: "",
      }, () => {
        if (type === "ipynb") {
          this.saveCell(this.state.openFiles, item, this.state.codeChangeIndex)
        }
      })
    }
  }

  // On discard the content reload the the notebook
  onClickDontSave = () => {
    if (this.state.openFiles.length !== 0 && this.state.codeChangeIndex !== undefined) {
      let type = this.state.openFiles[this.state.codeChangeIndex].name.split(".").pop();
      let item = this.state.openFiles[this.state.codeChangeIndex];
      let stId = this.state.openFiles[this.state.codeChangeIndex].stId;
      let rFolder = this.state.openFiles[this.state.codeChangeIndex].rFolder;
      this.setState({
        codeChangeFlag: false,
        codeChangeShowModal: false,
        codeChangeFileName: "",
      }, () => {
        if (type === "ipynb") {
          this.reloadnotebook(item, stId, rFolder);
        }
      })
    }
  }

  ClusterNotrunningConfirmation = (id) => {
    confirmAlert({
      title: "Cluster Status",
      message: <div> <span >Looks like <b><i>"{this.getClusterNamebyId(id)}"</i></b> is stopped or terminated. </span> <br /> <span className="text-primary pt-2">
        Please start your cluster or contact admin </span></div>,
      buttons: [
        {
          label: 'Okay',
          onClick: () => console.log('')
        }
      ]
    });
  }
  handlePageClick = (pageNumber, index) => {
    let selected = pageNumber.selected + 1;
    this.setState({ activePage: selected });
    let filePath = this.state.openFiles[index].name;
    this.state.openFiles[index].content = []
    this.csvLoadData(selected, filePath, this.state.openFiles[index].stId === null ? default_StorageName : this.state.openFiles[index].stId, this.state.openFiles[index].rFolder);
  };

  csvLoadData = (page, filePath, storageName, rootFolder) => {
    this.setState({
      tabloading: true
    })
    let csvPath = {
      path: filePath,
      delimiter: this.state.delimiter
    }
    RunService.csvDataPagination(csvPath, page, storageName, rootFolder)
      .then((response) => {
        if (response.records.length !== 0) {
          let jsonCsv = [];
          if (response.records.length > 0) {
            for (let records of response.records) {
              var removeSlash = records.replace(/\\/g, "");
              jsonCsv.push(JSON.parse(removeSlash));
            }
          }

          let type = filePath.split(".").pop()
          {/** Already opened files auto focus to file */ }
          this.handlePreviousTabHistory(filePath, jsonCsv, type, storageName, rootFolder)
          this.tabFocus();

          this.setState({
            totalPages: response.totalPages,
            totalRecords: response.totalRecords,
            tabloading: false
          })

        } else {
          this.setState({
            tabloading: false
          })
        }
      }).catch((error) => {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">Invalid CSV File</b></i>);
        this.setState({
          tabloading: false
        })
      });
  }
  loadHomeData = (filePath) => {
    this.getRecentNotebooksList();
    const IEcolumns = [
      {
        Header: <div style={{ fontSize: '15px', color: '#32325d' }} >Recents</div>,
        accessor: 'Name',
        sortable: false,
      },
    ]
    this.setState({
      homecontent:
        <div className="defaulttab">
          <Row className="icon-examples topmargin">
            <Col sm={12} xs={12} xl={8}>
              <Col className="text-center" lg="12" md="12">
                <Card className="card-contributions">
                  <CardBody>
                    <Row>
                      <Col sm={6} xs={12}>
                        <Col xs="12" className="overflowStyle rightborder" >
                          <i className="fas fa-file-import" style={{ verticalAlign: 'middle', color: '#524848', fontSize: '30px' }}></i>
                          <br />
                          <br />

                          <b style={{ color: '#4285F4', cursor: 'pointer' }} onClick={e => {
                            e.preventDefault()
                            this.toggleUploadModal()
                          }}>Import Notebook</b>
                          <br />
                        </Col>
                      </Col>
                      <Col sm={6} xs={12}>
                        <Col xs="12" className="overflowStyle" >
                          <i className="fas fa-book-open" style={{ verticalAlign: 'middle', color: '#524848', fontSize: '30px' }}></i>
                          <br />
                          <br />
                          <span onClick={this.toggleUploadNotebook} style={{ color: '#4285F4', cursor: "pointer" }}><b>Create a Blank Notebook</b></span>
                          <br />

                        </Col>

                      </Col>
                    </Row>
                    <br />
                    <b style={{ color: '#000', fontSize: "12px" }}>Quickly import data or create a Blank Notebook, preview its schema, create a table, and<br /> query it in a notebook</b>

                    <hr></hr>

                    <Row>
                      <Col sm={12} xs={12}>
                        <ReactTable
                          data={this.state.recentfiles}
                          defaultPageSize={6}
                          columns={IEcolumns}
                          showPaginationBottom={false}
                          className="-striped -highlight Usertable"
                        />
                      </Col>
                    </Row>
                    <KeyboardShortcuts />
                  </CardBody>
                </Card>
              </Col>
            </Col>
          </Row>
        </div>
    })
    let fileData = {
      path: "Home",
      name: "Home",
      type: "Home",
      content: this.state.homecontent,
      stId: "Home",
      rFolder: "Home"
    }

    var indexNum = this.state.openFiles.findIndex(obj => obj.name === fileData.name);
    if (indexNum < 0) {
      let setindex = this.state.openFiles.length + 1
      this.state.newFile = true

      this.setState({
        openFiles: [...this.state.openFiles, fileData],
        sameindex: false,
        newFile: true,
        reloadbook: false,
        setTabIndex: setindex
      }, () => {
        this.saveNotebookLocalStroage(); // save open Notebook
      })
    } else {
      this.setState({
        setTabIndex: indexNum,
        sameindex: true,
        newFile: false,
        reloadbook: false,
        sameindexid: indexNum
      })
    }
    this.setState({
      myContent: this.state.homecontent,
      loading: "none",
      tabloading: false
    })
    /**auto focus tab for choose files */
    this.handlePreviousTabHistory(filePath, this.state.homecontent, this.state.fileType)
  }
  handlepyfile = (filePath, filecontent, stId, rFolder) => {
    this.setState({
      fileType: "py",
      myContent: filecontent
    }, () => {
      this.handlePreviousTabHistory(filePath, filecontent, this.state.fileType, stId, rFolder)
    })
  }
  createUpdateRecentNotebook = () => {
    this.state.recentFlag = false;
    if (this.state.localFileId !== "") {
      let post = {
        recent: true,
        storageFileId: this.state.localFileId
      }
      if (this.state.openFiles.length !== 0) {
        this.state.openFiles[this.state.setTabIndex].fileId = this.state.localFileId;
      }
      ModelSpaceService.createUpdateRecentNotebooks(post)
        .then((response) => {
          if (response.status === 'SUCCESS') {  // create recent notebook using storage file id
            this.saveNotebookLocalStroage();  // here save localstroage for open files
          }
        })
    }
  }
  saveNotebookLocalStroage = () => {
    let latestNoteBook = [];
    for (var i = 0; i < this.state.openFiles.length; i++) {
      if (this.state.openFiles[i].type === "ipynb") {
        latestNoteBook.push({
          name: this.state.openFiles[i].name,
          path: this.state.openFiles[i].path,
          type: this.state.openFiles[i].type,
          fileId: this.state.openFiles[i].fileId,
          wsConnectionId: this.state.openFiles[i].wsConnectionId,
          stId: this.state.openFiles[i].stId,
          rFolder: this.state.openFiles[i].rFolder
        })
      } else {
        latestNoteBook.push({
          name: this.state.openFiles[i].name,
          type: this.state.openFiles[i].type,
          fileId: this.state.openFiles[i].fileId,
          stId: this.state.openFiles[i].stId,
          rFolder: this.state.openFiles[i].rFolder
        })
      }
    }
    localStorage.setItem("savedNoteBook", JSON.stringify(latestNoteBook));
    localStorage.setItem("lastopenTab", this.state.setTabIndex);

  }
  // Open files from recent list
  previewFileOnRecent = (fildId, name, type, storageId, rootFolder) => {
    this.setState({
      recentFlag: true,
      localFileId: fildId,
    }, () => {
      this.previewFile(name, type, storageId, rootFolder);
    })
  }
  onChangeEditor = (code, index) => {
    if (index !== undefined) {
      let filePath = this.state.openFiles[index].name;
      this.state.openFiles[index].content = code;
      this.setState({ code: code })
      this.handlepyfile(filePath, code, this.state.openFiles[index].stId, this.state.openFiles[index].rFolder)
    }
  }
  handleKeyDown = (event) => {
    if (event.keyCode === 9) { // tab was pressed
      event.preventDefault();
      let tabopen = event.target.value + 1;
      this.setState({ setTabIndex: tabopen })
      let tablen = this.state.openFiles.length;
      if (tabopen === tablen) {
        let initialtab = tabopen - tablen;
        this.setState({ setTabIndex: initialtab })
      }
    }
  }
  reloadnotebook = (data, stId, rFolder) => {
    let myPath = data.path;
    StorageService.downloadObjectUrl(myPath, stId, rFolder)
      .then((response) => {
        axios.get(response.download_url)
          .then(response => {
            let notebook = response.data
            this.setState({
              cellsData: response.data,
              reloadbook: true,
            }, () => {
              this.handlePreviousTabHistory(myPath, notebook.cells, this.state.fileType, stId, rFolder)
            })
          })
      })
  }
  toggleUploadModal = () => {
    if (this.state.showUploadModal) {
      this.setState({ showUploadModal: false })
    } else {
      this.setState({ showUploadModal: true })

    }
  }
  cancelUploadModal = () => {
    this.setState({ showUploadModal: false });
  }
  handleipynbfile = (event) => {
    this.fetchStorageItems(this.state.currFolder, null)
    this.state.currFolder = this.state.currFolder ? this.state.currFolder : ''
    this.setState({ onlyipynbfile: event.target.files[0] })
    let fname = event.target.files[0].name;
    let ipynbtype = trimFileName(fname).substr(trimFileName(fname).lastIndexOf('.') + 1);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const objectName = path.join(this.state.currFolder, fname)
    StorageService.uploadObjectUrl(objectName, this.state.sourceStorageId, this.state.sourceRootFolder)
      .then((response) => {
        if (response.type === provisioners.google) {
          axios({
            url: response.upload_url,
            baseURL: '',
            data: {},
            headers: {
              'content-type': ipynbtype,
              'x-goog-resumable': 'start'
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            const resumableLink = resp.headers.location
            CommonService({
              url: resumableLink,
              baseURL: '',
              data: this.state.onlyipynbfile,
              headers: {
                'content-type': "multipart/form-data"
              },
              method: 'PUT',
              cancelToken: source.token,
              onUploadProgress: progressEvent => {
                let { progress } = this.state;
                progress = (progressEvent.loaded / progressEvent.total) * 100;
                this.setState({ progress });
              }
            }).then((resp) => {
              this.fetchStorageItems(this.state.currFolder, null)
              this.setState({ showUploadModal: false, progress: 0 })

            })
          })
        } else if (response.type === provisioners.aws) {
          var rest = response.fields;
          var formData = new FormData();
          for (const [key, value] of Object.entries(rest)) {
            formData.append(key, value)
          }
          formData.append("file", this.state.onlyipynbfile)
          axios({
            url: response.upload_url,
            data: formData,
            headers: {
              'content-type': "multipart/form-data"
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            this.fetchStorageItems(this.state.currFolder, null)
            this.setState({ showUploadModal: false, progress: 0 })
          })
        }
        else if (response.type === provisioners.azure) {
          axios({
            url: response.upload_url,
            data: this.state.onlyipynbfile,
            headers: {
              'content-type': "multipart/form-data",
              'x-ms-blob-type': 'BlockBlob'
            },
            method: 'PUT',
            cancelToken: source.token
          }).then((resp) => {
            this.fetchStorageItems(this.state.currFolder, null)
            this.setState({ showUploadModal: false, progress: 0 })
          })
        }
      })
  }
  openPDFFile = (numPages) => {
    this.setState({ numPages: numPages })
  }
  getRecentNotebooksList = () => {
    this.setState({
      recentnotebooks: []
    }, () => {
      // get only five records
      ModelSpaceService.getRecentNotebooks()
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let recentbooks = response.recentNotebookDTOPage.content
            if (recentbooks.length !== 0) {
              for (var i = 0; i < recentbooks.length; i++) {
                // get storage id from recent notebook and files data
                Promise.all([this.getRecentNotebooksListById(recentbooks[i].storageFileId)]).then(values => {
                  if (recentbooks.length - 1) {
                    this.renderRecentsData(this.state.recentnotebooks)
                  }
                })
              }
            }
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
          }
        })
    })

  }
  getRecentNotebooksListById = (id) => {
    return ModelSpaceService.getStorageFileById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.storageFileDTO !== null) {
            let storageFileDetail = response.storageFileDTO;
            let storage = this.state.configArray.filter(item => item.id === storageFileDetail.storageId);
            if (storage.length > 0) {
              let _storage = storage[0]
              storageFileDetail.storageName = _storage.name
              storageFileDetail.platformDefault = _storage.platformDefault
            }
            this.setState({
              recentnotebooks: [...this.state.recentnotebooks, storageFileDetail]
            })
          }
        }
      })
  }
  getStorageDataByFileId = (id) => {
    ModelSpaceService.getStorageFileById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.storageFileDTO !== null) {
            this.setState({
              sourceStorageId: response.storageFileDTO.storageId,
              sourceRootFolder: response.storageFileDTO.rootFolder,
            })
          }
        }
      })
  }
  //Display Recents
  renderRecentsData(recentnotebooks) {
    let datas = [];
    if (recentnotebooks.length !== 0) {
      recentnotebooks.map((item, index) => {
        datas.push({
          Name:
            <Row style={{ textAlign: 'left', cursor: 'pointer' }} onClick={e => this.previewFileOnRecent(item.id, item.filePath, 'file', item.storageId, item.rootFolder)}>
              <Col xs="1">
                <i className="far fa-sticky-note" />
              </Col>

              {item.platformDefault && <Col xs="10" className="p-0">
                <span title={item.filePath} className="overflowStyleNotebook p-0">{item.filePath} </span>
              </Col>}
              {!item.platformDefault && <Col xs="10" className="p-0">
                <span title={item.filePath} className="overflowStyleNotebook p-0">
                  <span className="text-primary p-0">{item.storageName + "/" + item.rootFolder}</span>/
                    {item.filePath} </span>
              </Col>}
              <Col xs="1" onClick={e => {
                e.stopPropagation()
                this.deleteRecentNotebookByIdConfirm(item.id, item.filePath);
              }} >
                <i className="fas fa-times-circle df-text-danger"></i>
              </Col>
            </Row>

        })
      });
      this.setState({
        recentfiles: datas
      });
    }

  }

  callVersion = (versionvalue, currentindex, fileName, storageId, rootFolder) => {
    this.state.presentFilePath = this.state.openFiles[currentindex].name;
    this.state.presentStorageName = this.state.openFiles[currentindex].stId;
    this.state.presentrootFolder = this.state.openFiles[currentindex].rFolder;
    this.state.presentType = this.state.openFiles[currentindex].type;
    if (versionvalue === false) {
      this.setState({
        showVersion: true
      }, () => {
        let senddata = {
          "fileName": this.state.presentFilePath,
          "storageId": this.state.presentStorageName,
          "rootFolder": this.state.presentrootFolder
        }
        this.state.listversion = senddata;
      })
    }
    else {
      this.state.showVersion = false;
    }
  }
  updateState(filename, storageId, rootFolder, version, comments) {
    StorageService.ViewVersionObjects(filename, storageId, rootFolder, version)
      .then((response) => {
        this.setState({ DownloadUrl: response.download_url, codeChangeFlag: false, fileType: "ipynb" });
        this.renderVersion(filename, response.download_url, storageId, rootFolder);
        this.setState({ currentVersion: version, currentComments: comments, tabloading: true })

      }).catch((error) => {
      })
  }
  toggleSaveModal = (data) => {
    this.setState({
      showSaveModal: !this.state.showSaveModal,
      modaldata: data,
      savecomments: '',
      actionTrigger: false,
      tabloading: false

    })
  }
  saveCommentschange = (event) => {
    if (event !== null) {
      this.setState({ savecomments: event.target.value });
      if (this.state.savecomments !== null && this.state.savecomments.length > 3 && this.state.savecomments.length < 100) {
        this.setState({ showSavebutton: true })
      }
      else {
        this.setState({ showSavebutton: false })
      }
    }
  }
  showOriginal = () => {
    this.setState({ showOriginal: true, selectedVersionName: '' })
  }

  renderOriginal = () => {
    if (JSON.parse(localStorage.getItem("savedNoteBook")).length !== 0) {
      this.setState({
        openFiles: JSON.parse(localStorage.getItem("savedNoteBook")),
        setTabIndex: parseInt(localStorage.getItem("lastopenTab"))
      }, () => {
        if (this.state.openFiles.length !== 0) {
          if (this.state.openFiles[this.state.setTabIndex] !== undefined
            && this.state.openFiles[this.state.setTabIndex].hasOwnProperty('fileId')
            && this.state.openFiles[this.state.setTabIndex].name !== "Home") {
            this.setState({
              localFileId: this.state.openFiles[this.state.setTabIndex].fileId
            })
            try {
              this.updateNotebookContent(this.state.openFiles[this.state.setTabIndex].name,
                this.state.setTabIndex,
                this.state.openFiles[this.state.setTabIndex].type,
                this.state.openFiles[this.state.setTabIndex].stId === null ? "" : this.state.openFiles[this.state.setTabIndex].stId,
                this.state.openFiles[this.state.setTabIndex].rFolder); // default session notebook load

            } catch (err) {
              this.updateNotebookContent(this.state.openFiles[0].name, 0, this.state.openFiles[0].type, this.state.openFiles[0].stId === null ? "" : this.state.openFiles[0].stId, this.state.openFiles[0].rFolder); // default session notebook load
            }
            this.saveNotebookLocalStroage();
          }
          else if (this.state.openFiles[this.state.setTabIndex].name === "Home") {
            setTimeout(() => {
              this.loadHomeData("Home")
              this.tabFocus()
            }, 1000);
          }
        }
      })
      this.getRecentNotebooksList();
    }
  }
  SaveFileForVersion = () => {
    this.setState({
      tabloading: true
    })
    let data = this.state.modaldata;
    if (data !== undefined) {
      let filePath = data.path;
      let fileType = data.type;
      let content = data.content;
      let metadata = data.metadata;
      let notebookContent;
      notebookContent = {
        cells: content,
        metadata: metadata,
        "nbformat": 4,
        "nbformat_minor": 0
      }
      saveFile(filePath, fileType, notebookContent, this.state.presentStorageName, this.state.presentrootFolder, this.state.savecomments)
      this.setState({ showSaveModal: false, showVersion: false, tabloading: true })
      setTimeout(() => {
        this.setState({
          codeChangeFlag: false,
          codeChangeFileName: "",
          codeChangeShowModal: false,
          actionTrigger: false,
          showSaveModal: false,
          tabloading: false
        })
        this.fetchStorageItems(this.state.currFolder, null, true)
      }, VERSIONTIMEOUT);
    } else {
      this.setState({
        actionTrigger: false
      })
    }
  }

  render() {
    const IEcolumns = [
      {
        Header: <div style={{ fontSize: '15px', color: '#32325d' }} >Recents</div>,
        accessor: 'Name',
        sortable: false,
      },
    ]

    return (
      <>
        <PanelHeader
          content={
            <div className="header text-center">

            </div>
          }
        />
        <div className="content storagetoggle">
          <Card>
            <CardBody>
              <div className="carcontent">
                <Row>
                  <Col sm={3} xs={12}>
                    <span
                      className={this.state.navActionFlag ? "showStorage" : "hideStorage"}
                      onClick={e => this.toggleforStorage()}>
                      {this.state.navActionFlag ? <><i className="fas fa-long-arrow-alt-left"></i>|<span className="StorageHideShow"></span></> : <>|<i className="fas fa-long-arrow-alt-right"></i><span className="StorageHideShow"></span></>}
                    </span>

                  </Col>
                </Row>
                <Row>
                  {this.state.navActionFlag && <Col sm={3} xs={12} className="treeright">
                    <Row>
                      <Col xs="12">
                        <ButtonGroup className="Ms_homebtnwrap">
                          <Button
                            className="storage-btn"
                            size="sm"
                            color="link"
                            id='Home'
                            onClick={this.showHome}
                          >
                            <i className="fas fa-home fa-lg"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target="Home" delay={0}>
                            Home
                                </UncontrolledTooltip>
                          <Button
                            className="storage-btn"
                            size="sm"
                            color="link"
                            id='Newnotebook'
                            onClick={this.toggleUploadNotebook}
                          >
                            <i className="fas fa-book-open fa-lg"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target="Newnotebook" delay={0}>
                            Create a Blank Notebook
                                </UncontrolledTooltip>
                          <Button
                            className="storage-btn"
                            size="sm"
                            color="link"
                            id='create-folder'
                            onClick={this.toggleFolderCreate}
                          >
                            <i className="fas fa-folder-plus fa-lg"></i>
                          </Button>
                          <UncontrolledPopover
                            placement="bottom"
                            target="create-folder"
                            className="popover-primary"
                            trigger="legacy"
                          >
                            <PopoverHeader>Create Folder
                            </PopoverHeader>
                            <PopoverBody>
                              <InputGroup>
                                <Input
                                  placeholder="Folder Name"
                                  name="folderToBeCreate"
                                  value={this.state.folderToBeCreate}
                                  onChange={this.handleInputChange} />
                                <InputGroupAddon addonType="append">
                                  <Button
                                    color="primary"
                                    className="storage-folder-btn"
                                    onClick={e => this.onCreateFolderClick(e)}
                                  >
                                    Create
                                        </Button>
                                </InputGroupAddon>
                              </InputGroup>
                            </PopoverBody>
                          </UncontrolledPopover>
                          <UncontrolledTooltip placement="top" target="create-folder" delay={0}>
                            Create Folder
                                </UncontrolledTooltip>
                          <UncontrolledDropdown id="upload">
                            <DropdownToggle
                              className="storage-btn btn-link">
                              <i className="fas fa-cloud-upload-alt fa-1x"></i>
                            </DropdownToggle>
                            <DropdownMenu
                              className="dropdown-menu-arrow"
                              right
                            >
                              <DropdownItem
                                onClick={this.toggleUpload}
                              >
                                <span id='Comments'>
                                  <i className="now-ui-icons files_paper mr-3" /> Files
                                        </span>
                              </DropdownItem>
                              <DropdownItem
                                onClick={this.showFolderUpload}
                              >
                                <span id='Comments'>
                                  <i className="fas fa-folder mr-3" /> Folder
                                        </span>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                          <UncontrolledTooltip placement="top" target="upload" delay={0}>
                            Upload
                                </UncontrolledTooltip>
                          <input
                            type="file"
                            webkitdirectory=""
                            multiple=""
                            directory=""
                            ref={this.folderUploadRef} hidden
                            onChange={e => this.handleFolderUploadFiles(e, false)}
                            onClick={e => e.target.value = null}
                          />
                          <Modal
                            centered
                            className="upload-modal"
                            isOpen={this.state.showUploadFiles}
                            toggle={this.toggleUpload}
                            backdrop="static"
                            returnFocusAfterClose={false}
                          >
                            <ModalHeader toggle={this.toggleUpload}>File Uploads</ModalHeader>
                            <ModalBody>
                              <FilePond
                                name="fileupload"
                                allowMultiple={true}
                                server={{
                                  process: this.filePondProcess
                                }}
                                maxParallelUploads={5}
                                onprocessfiles={() => {
                                  this.fetchStorageItems(this.state.currFolder, null)
                                }}
                              >
                              </FilePond>
                            </ModalBody>
                          </Modal>
                          <Modal
                            centered
                            className="upload-modal"
                            isOpen={this.state.showNotebookModal}
                            toggle={this.toggleUploadNotebook}
                            backdrop="static"
                            returnFocusAfterClose={false}
                          >
                            <ModalHeader toggle={this.toggleUploadNotebook}>File Manager</ModalHeader>
                            <ModalBody>
                              <hr className="my-1" />
                              <div className="logo-and-nav-wrap">
                                <div className="site-nav-wrap">
                                  <div className="navss">
                                    {this.state.storageNavigations}
                                  </div>
                                </div>
                              </div>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight - 300} thumbMinSize={30} onScroll={this.handleScroll}>
                                <hr className="my-1" />
                                <AddStorageItems
                                  folders={this.state.folders}
                                  files={this.state.files}
                                  fetchStorageItems={this.fetchStorageItems}
                                  loadmoreFlag={this.state.loadmoreFlag}
                                  showFilesModal={this.state.showFilesModal}
                                  nextPageToken={this.state.nextPageToken}
                                  previewFile={this.previewFile}
                                  loadflagStorage={this.state.loadflagStorage}
                                  currFolder={this.state.currFolder}
                                  pasteFolder={this.pasteFolder}
                                  selectMoveFile={this.selectMoveFile}
                                  selectCopyFile={this.selectCopyFile}
                                  renameFile={this.renameFile}
                                  toggleShowFiles={this.toggleShowFiles}
                                  refreshstorage={this.refreshstorage}
                                  fetchProgress={this.fetchProgress}
                                  sourceStorageId={this.state.sourceStorageId}
                                  sourceRootFolder={this.state.sourceRootFolder}
                                  configArray={this.state.configArray}
                                  progressmsg={this.state.progressmsg}
                                />
                              </Scrollbars>
                              <div className="untitleddiv">
                                <InputGroup>
                                  <Input
                                    placeholder="Untitled"
                                    name="fileToBeCreate"
                                    id="fileToBlank"
                                    className="inputBorderLine"
                                    value={this.state.fileToBeCreate}
                                    onChange={this.handleInputChangeFile} />
                                  <InputGroupAddon addonType="append" className="AliginMargin">
                                    <Button
                                      color="primary"
                                      className="storage-folder-btn"
                                      onClick={e => this.createFileInit(this.state.fileToBeCreate, this.state.currFolder)}
                                    >
                                      Create
                                        </Button>
                                  </InputGroupAddon>
                                </InputGroup>
                              </div>
                            </ModalBody>
                          </Modal>
                          <Modal
                            centered
                            className="upload-modal"
                            isOpen={this.state.showFolderUploadModal}
                            toggle={this.toggleFolderUpload}
                            backdrop="static"
                            returnFocusAfterClose={false}
                            onOpened={() => {
                              this.createUploadFolders(this.state.currFolder)
                              this.filePond.processFiles()
                            }}
                          >
                            <ModalHeader toggle={this.toggleFolderUpload}>Folder Uploads</ModalHeader>
                            <ModalBody>
                              <FilePond ref={ref => this.filePond = ref}
                                name="folderupload"
                                files={this.state.folderUploadFiles}
                                allowMultiple={true}
                                server={{
                                  process: this.filePondProcess
                                }}
                                labelIdle=""
                                maxParallelUploads={5}
                                onprocessfiles={() => {
                                  this.fetchStorageItems(this.state.currFolder, null)
                                }}
                              >
                              </FilePond>
                            </ModalBody>
                          </Modal>
                          <Button
                            className="storage-btn"
                            size="sm"
                            color="link"
                            id='refresh'
                            onClick={e => this.refreshstorage(e, 'false')}
                          >
                            <i className="fas fa-sync-alt fa-lg"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target="refresh" delay={0}>
                            Reload
                                </UncontrolledTooltip>
                        </ButtonGroup>
                        <hr className="my-1" />
                        {this.state.configArray.length > 0 && <div className="storageCard">
                          <span className="labelModal">Select Storage</span>
                          <select className="col-12 dropdownStyle pd-6" name="buckets" id="buckets" onChange={e => this.handleChangeStorage(e, this.state.configArray)}>
                            {this.state.configArray.map((item, index) => (<option key={index} value={item.id}>{item.name === default_StorageName ? default_LabelStorageName : item.name}</option>))}
                          </select>

                          {this.state.enableSubBuckets && <div className="selectspace"><span className="labelModal">Select Bucket</span>
                            <select className="col-12 dropdownStyle pd-6" name="subbuckets" id="subbuckets" onChange={e => this.handleChangeBucket(e)}>
                              {this.state.subBucketsList.map((item, index) => (<option key={index} value={item.bucketName}>{item.bucketName}</option>))}
                            </select></div>}
                        </div>}

                        <form>
                          <InputGroup className="no-border selectspace searchinputborder">
                            <Input placeholder="Filter files by name..." onChange={event => this.onSearchFiles(event.target.value)}
                              value={this.state.fileSearch} className="searchinput"  />

                            <InputGroupAddon addonType="append" className="addoninput">
                              <InputGroupText className="addoninputtext">
                                &nbsp; &nbsp; <i className="now-ui-icons ui-1_zoom-bold" />
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </form>

                        <div className="logo-and-nav-wrap">
                          <div className="site-nav-wrap">
                            <div className="navss">
                              {this.state.storageNavigations}
                            </div>
                          </div>
                        </div>
                        <hr className="my-1" />
                      </Col>
                    </Row>
                    <Row>
                      <Scrollbars autoHeight autoHeightMin={this.state.sheight - 300} thumbMinSize={30} onScroll={this.handleScroll}>
                        <Col>
                          <AddStorageItems
                            folders={this.state.folders}
                            files={this.state.files}
                            fetchStorageItems={this.fetchStorageItems}
                            showFilesModal={this.state.showFilesModal}
                            loadmoreFlag={this.state.loadmoreFlag}
                            nextPageToken={this.state.nextPageToken}
                            previewFile={this.previewFile}
                            loadflagStorage={this.state.loadflagStorage}
                            currFolder={this.state.currFolder}
                            pasteFolder={this.pasteFolder}
                            selectMoveFile={this.selectMoveFile}
                            selectCopyFile={this.selectCopyFile}
                            renameFile={this.renameFile}
                            toggleShowFiles={this.toggleShowFiles}
                            refreshstorage={this.refreshstorage}
                            fetchProgress={this.fetchProgress}
                            sourceStorageId={this.state.sourceStorageId}
                            sourceRootFolder={this.state.sourceRootFolder}
                            configArray={this.state.configArray}
                            progressmsg={this.state.progressmsg}


                          />
                        </Col>
                      </Scrollbars>
                    </Row>
                  </Col>}
                  <Col sm={this.state.navActionFlag ? this.state.showVersion === true ? 7 : 9 : 12} xs={12} >
                    {(this.state.openFiles.length === 0) &&
                      <div className="defaulttab">
                        <Row className="icon-examples topmargin">
                          <Col sm={12} xs={12} xl={8}>
                            <Col className="text-center" lg="12" md="12">
                              <Card className="card-contributions">
                                <CardBody>
                                  <Row>
                                    <Col sm={6} xs={12}>
                                      <Col xs="12" className="overflowStyle rightborder" >
                                        <i className="fas fa-file-import importicon" ></i>
                                        <br />
                                        <br />

                                        <b className="importnotebook" onClick={e => {
                                          e.preventDefault()
                                          this.toggleUploadModal()
                                        }}>Import Notebook</b>
                                        <br />
                                      </Col>
                                    </Col>
                                    <Col sm={6} xs={12}>
                                      <Col xs="12" className="overflowStyle" >
                                        <i className="fas fa-book-open importicon"></i>
                                        <br />
                                        <br />
                                        <span onClick={this.toggleUploadNotebook} className="importnotebook"><b>Create a Blank Notebook</b></span>
                                        <br />

                                      </Col>

                                    </Col>
                                  </Row>
                                  <br />
                                  <b className="quickimport">Quickly import data or create a Blank Notebook, preview its schema, create a table, and<br /> query it in a notebook</b>

                                  <hr></hr>

                                  <Row>
                                    <Col sm={12} xs={12}>
                                      <ReactTable
                                        data={this.state.recentfiles}
                                        defaultPageSize={6}
                                        columns={IEcolumns}
                                        showPaginationBottom={false}
                                        className="-striped -highlight Usertable"
                                      />
                                    </Col>
                                  </Row>
                                  <KeyboardShortcuts />
                                </CardBody>
                              </Card>
                            </Col>
                          </Col>
                        </Row>
                      </div>
                    }

                    <LoadingOverlay
                      active={this.state.tabloading}
                      spinner={<ScaleLoader
                        height={35}
                        width={5}
                        radius={2}
                        margin={2}
                        color={"#123abc"}
                        loading={this.state.tabloading}
                      />}
                    >

                      {this.state.openFiles.length !== 0 && <Tabs selected={0} selectedIndex={this.state.setTabIndex} onSelect={(clickIndex, currentIndex) => this.onTabclick(clickIndex,currentIndex, true)}>
                        <TabList className="ulTab">
                          {this.state.openFiles.map((item, index) => (
                            <Tab className="listTab" key={uuidv4()} onKeyDown={this.handleKeyDown} value={index} >
                              <div className="tabdiv pt-2"
                                title={this.constructFilePath(item.stId, item.rFolder, item.path)}>&nbsp;&nbsp;
                                <img className="imglogo" src={findIcon(imageFileExtension(item.name))} alt="" ></img>&nbsp;&nbsp;
                                <span className="tabdisplay">{item.name.split("/").pop()}</span>
                                <span onClick={e => {
                                  this.removeIndexBefore(this.state.openFiles, index, item.type)
                                }} className="noteToolbar noborder mt-n2 pt-2">&nbsp;&nbsp;
                                  <i className="far fa-times-circle notecloseicon" ></i>&nbsp;&nbsp;
                                </span>
                              </div>
                            </Tab>
                          ))}
                          <span className="new-tab" title="Create a Blank Notebook" onClick={this.toggleUploadNotebook}><i className="fas fa-plus"></i></span>
                        </TabList>

                        {this.state.openFiles.map((item, index) => {

                          if (item.type === "ipynb") {
                            return <TabPanel key={index}>{item.type === "ipynb" &&
                              <Row xs="12" className="mt-n3 ipynbborder" >
                                <Col xs="12">
                                  <Row>
                                    <Col xs="8">
                                      <Navbar className="customNav mb-0 bg-light-tool" expand="md">
                                        <NavbarToggler onClick={this.toggleNavbartools} >
                                          <i className="fas fa-ellipsis-v text-secondary"></i>
                                        </NavbarToggler>
                                        <Collapse isOpen={this.state.showNotebookTools} navbar>
                                          <Nav navbar className="pt-1 toolsRow">

                                            <NavItem
                                              title="Save"
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}
                                              onClick={e => this.saveCell(this.state.openFiles, item, index, 'onclickevent')}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-primary mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-save fa-lg" ></i>
                                              </NavLink>
                                            </NavItem>

                                            <NavItem
                                              title="Insert code cell"
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}
                                              onClick={e => this.addNewCellafterIndex(item.content)}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-green-tool mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-code fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="Insert markdown cell"
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}
                                              onClick={e => this.addNewMarkdownafterIndex(item.content)}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-green-tool mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-plus fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="Delete selected cell"
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}
                                              onClick={e => this.removeCellConfirmation(item.content)}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-red-tool mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-trash fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="Clear All Outputs"
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}
                                              onClick={e => this.clearCellOutput(item.content)}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-primary mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-eraser fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="copy selected cell"
                                              className="disablebtn"
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-primary mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-copy fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="paste cells"
                                              className="disablebtn"
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-primary mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-paste fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="move selected cells up"
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}
                                              onClick={e => this.moveUpcellData(item.content)}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-primary mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-arrow-up fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="move selected cells down"
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}
                                              onClick={e => this.moveDowncellData(item.content)}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-primary mt-n2"
                                                href="#"
                                              >
                                                <i className="fas fa-arrow-down fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="Run all"
                                              className={this.state.actionTrigger || this.state.disabledAction ? "disableMode disablebtn" : ""}
                                              onClick={e => this.runAll(item, item.wsConnectionId)}
                                            >
                                              <NavLink
                                                className="hoverToolIcon text-green-tool mt-n2"
                                                href="#"
                                              >
                                                <i
                                                  className={item.runAllFlag === true || item.runAllFlag === undefined ? "fas fa-play fa-lg" : "fas fa-play fa-lg disablebtn"} ></i>
                                              </NavLink>

                                            </NavItem>

                                            <NavItem
                                              title="Stop"
                                              className={this.state.disabledAction ? "disableMode" : ""}
                                              onClick={e => this.stopCell(item, item.wsConnectionId)}
                                            >
                                              <NavLink
                                                className={item.runAllFlag === false ? "hoverToolIcon text-red-tool mt-n2" : "hoverToolIcon disablebtn text-red-tool mt-n2"}
                                                href="#"
                                              >
                                                <i className="fas fa-stop fa-lg" ></i>
                                              </NavLink>

                                            </NavItem>
                                            <UncontrolledDropdown nav inNavbar
                                              className={(item.runAllFlag === false || this.state.actionTrigger) ? "disablebtn" : ""}>
                                              <DropdownToggle tag="span" nav
                                                onClick={e => e.preventDefault()}
                                                className="actionicon">
                                                <i className="fas fa-ellipsis-v df-text-primary font12"/>
                                              </DropdownToggle>
                                              <DropdownMenu right>
                                                <DropdownItem onClick={e => this.reloadnotebook(item, item.stId, item.rFolder)}>
                                                  <i className="fas fa-sync fa-lg df-text-primary" ></i> File Reload
                                            </DropdownItem>
                                                {item.wsStatus === "Connected" && <DropdownItem onClick={e => this.restartKernel()}>
                                                  <i className="fas fa-redo fa-lg df-text-primary" ></i> Kernel Restart
                                            </DropdownItem>}

                                              </DropdownMenu>
                                            </UncontrolledDropdown>
                                            <Button id="shortcut" type="button" className="bg-transparent hoverToolIcon p-0 m-0 ml-2">
                                              <i title="Shortcuts" className="fas fa-keyboard df-text-primary"></i>
                                            </Button>
                                            <UncontrolledPopover
                                              placement="bottom"
                                              target="shortcut"
                                              trigger="legacy"
                                              className="shortcut-Info"
                                            >
                                              <PopoverBody className="pt-3 pb-3">
                                                <KeyboardShortcuts />
                                              </PopoverBody>
                                            </UncontrolledPopover>
                                          </Nav>
                                        </Collapse>
                                      </Navbar>
                                    </Col>
                                    <Col xs="4" className="bg-light-tool ml-n3">
                                      {/* </Collapse> */}

                                      <Row>
                                        <Col xs="9">
                                          {item.wsStatus === undefined &&
                                            <UncontrolledDropdown size="sm" className="float-right mt-2" >
                                              <DropdownToggle
                                                nav
                                                tag="span"
                                                onClick={e => this.loadAlreadyConnectedList(item.fileId)}
                                              >
                                                <span className="pulseCustom notconnectedbg" ></span>
                                                <span className="websocketfontStyle">Not Connected
                                                &nbsp;<i className="fas fa-caret-down" ></i></span>

                                              </DropdownToggle>
                                              <DropdownMenu
                                                className="dropdown-menu-arrow popoverCard menuwithoverFlow p-3 rounded-lg"
                                                right
                                                style={{ opacity: this.state.deleteOpen === true ? '-99' : '99' }}
                                              >
                                                <Row className="df-runtime-env">
                                                  <Col md="7" className="border-right">
                                                    <Form className="df-create-runtime">
                                                      <Row>
                                                        <Col>
                                                          <h6 className="text-capitalize">Configure Runtime</h6>
                                                        </Col>
                                                        <Col>
                                                          <a
                                                            href={() => false}
                                                            className="df-link float-right"
                                                            id="run-env-refreshConnect"
                                                            onClick={e => this.refreshEnvironment()}>
                                                            <i className="fas fa-sync-alt"></i>
                                                          </a>
                                                          <UncontrolledTooltip placement="top" target="run-env-refreshConnect" delay={0}>
                                                            Refresh
                                                              </UncontrolledTooltip>
                                                        </Col>
                                                      </Row>
                                                      <span className="df-text-danger">{this.state.setModelError}</span>
                                                      <FormGroup>
                                                        <Label>Select Cluster</Label>
                                                        <Select name="ClusterName" maxMenuHeight="12rem"
                                                          values={this.state.clusterdetailsoptions.filter(item => item.value === this.state.clusterName)}
                                                          onChange={this.handleChangeSelectCluster} options={this.state.clusterdetailsoptions} noValidate>
                                                        </Select>
                                                      </FormGroup>
                                                      <br />
                                                      <FormGroup>
                                                        <Label>Select Runtime</Label>
                                                        <Select name="runTimeValue" maxMenuHeight="12rem"
                                                          values={this.state.runTimeOptions.filter(item => item.value === this.state.runTime)}
                                                          onChange={this.handleChangeRunTime} options={this.state.runTimeOptions} noValidate>
                                                        </Select>
                                                      </FormGroup>
                                                      <br />
                                                      <Button className="df-btn-primary" onClick={e => this.PostModelSpace(index)}>Connect</Button>
                                                    </Form>
                                                  </Col>
                                                  <Col
                                                    md="5"
                                                  >
                                                    <h6 className="df-txt-transfor-none">Existing Runtime(s)</h6>
                                                    <Row
                                                      className="p-2 df-modelspace-list"
                                                    >
                                                      {this.state.modelspaceConnectedList.length > 0 ? this.state.modelspaceConnectedList.map((itemList, itemListIndex) => (
                                                        <ListGroup
                                                          id={itemListIndex}
                                                          className="w-100 py-2"
                                                          key={"runtime-" + itemListIndex}
                                                        >
                                                          <ListGroupItem>
                                                            <span><b>Cluster:</b> {this.getClusterNamebyId(itemList.clusterId)}</span><br />
                                                            <span><b>Runtime:</b> {this.getDisplayRuntimeNamebyruntime(itemList.runtime)}</span>
                                                          </ListGroupItem>
                                                          <ListGroupItem className="p-0">
                                                            <ButtonGroup size="sm" className="btn-block">
                                                              <Button className="df-btn-outline-success m-0 border-left-0 border-top-0 border-bottom-0"
                                                                onClick={e => this.reconnectWebsocket(index, itemList)}>
                                                                <i className="fas fa-plug fa-lg"></i>
                                                              </Button>
                                                              <Button className="df-btn-outline-danger m-0 border-right-0 border-top-0 border-bottom-0 border-left-0"
                                                                onClick={e => this.DeleteModelSpaceByIdConfirm(itemList.id, index, item, itemList.runtime)}>
                                                                <i className="fas fa-trash fa-lg"></i>
                                                              </Button>
                                                            </ButtonGroup>
                                                          </ListGroupItem>
                                                        </ListGroup>
                                                      )) : <p className="df-text-muted">Don't have existing configs</p>}
                                                    </Row>
                                                  </Col>
                                                </Row>
                                              </DropdownMenu>
                                            </UncontrolledDropdown>
                                          }


                                          {item.wsStatus === "Connecting" &&
                                            <UncontrolledDropdown className="float-right mt-3 pr-1">
                                              <DropdownToggle
                                                tag="span"
                                                onClick={e => e.preventDefault()}
                                              >
                                                <span className="pulse"></span>
                                                <span className="websocketfontStyle">Connecting
                                &nbsp;<i className="fas fa-caret-down" ></i></span>
                                              </DropdownToggle>
                                              <DropdownMenu
                                                className="dropdown-menu-arrow popoverCard"
                                                right
                                              >
                                                <DropdownItem
                                                  onClick={e => this.restartWebsocket(item.path)}
                                                >
                                                  <span id='Comments'>
                                                    <i className="fas fa-sync-alt mr-3" /> Refresh
                                        </span>
                                                </DropdownItem>
                                                <DropdownItem
                                                  onClick={e => this.closeWebsocket(index)}
                                                >
                                                  <span id='Comments'>
                                                    <i className="fas fa-stop mr-3" /> Disconnect
                                        </span>
                                                </DropdownItem>
                                              </DropdownMenu>
                                            </UncontrolledDropdown>}
                                          {item.wsStatus === "Connected" && <Row className={this.state.disabledAction ? "disableMode" : ""}>
                                            <Col>
                                              <UncontrolledDropdown className="mr-0 float-right mt-3">
                                                <DropdownToggle
                                                  tag="span"
                                                  onClick={e => e.preventDefault()}
                                                >
                                                  <span className="pulseCustom text-green-tool-background"></span>
                                                  <span className="websocketfontStyle">Connected
                                  &nbsp;<i className="fas fa-caret-down" ></i></span>
                                                </DropdownToggle>
                                                <DropdownMenu
                                                  className="dropdown-menu-arrow popoverCard"
                                                  right
                                                >
                                                  <DropdownItem
                                                    className=""
                                                    onClick={e => this.closeWebsocketConfirm(index)}
                                                  >
                                                    <span id='Comments'>
                                                      <i className="fas fa-stop mr-3" /> Stop
                                        </span>
                                                  </DropdownItem>
                                                  <DropdownItem
                                                    onClick={e => this.TerminateModelSpaceConfirmation(item.wsConnectionId, index, item)}
                                                  >
                                                    <span id='Comments'>
                                                      <i className="fas fa-ban mr-3" /> Terminate
                                        </span>
                                                  </DropdownItem>
                                                </DropdownMenu>
                                              </UncontrolledDropdown>
                                            </Col>

                                            <UncontrolledPopover
                                              placement="bottom"
                                              target="showconnectedinfo"
                                              className="popover-primary"
                                              trigger="legacy"
                                            >
                                              <PopoverHeader className="popoverinfoHeader">Connected Info
                            </PopoverHeader>
                                              <PopoverBody>
                                                <div className="textLeft font12">
                                                  <span className="font600">Name &nbsp;&nbsp;&nbsp;&nbsp;  :&nbsp;</span><span title={this.state.openFiles[index].name.split("/").pop()} className="overflowPopover">{this.state.openFiles[index].name.split("/").pop()}</span><br />
                                                  <span className="font600">Cluster &nbsp;&nbsp;:&nbsp;</span><span>{this.state.openFiles[index].clusterName}&nbsp;&nbsp;<Badge color="" className="badge-dot"><i className="bg-success" /></Badge></span><br />
                                                  <span className="font600"> Runtime  :&nbsp; </span><span>{this.state.openFiles[index].runTime}</span>
                                                </div>
                                              </PopoverBody>
                                            </UncontrolledPopover>
                                            <a href={() => false} className="mt-3 pr-3 text-warning" onClick={this.toggleConnectedInfo} id="showconnectedinfo">
                                              <i className="far fa-lightbulb" ></i>
                                            </a>
                                          </Row>}
                                        </Col>
                                        <Col xs="1" className="mt-3 ">
                                          <UncontrolledDropdown className=" mr-2">
                                            <DropdownToggle
                                              tag="span"
                                              id={'storagePick' + 0}
                                              onClick={e => e.preventDefault()}
                                            >
                                              <i className="fas fa-sliders-h fa-lg actionicon"></i>
                                            </DropdownToggle>

                                            <DropdownMenu
                                              persist right
                                              className="dropdown-menu-arrow popoverCard text-primary"
                                            >

                                              <DropdownItem
                                                href=""
                                                onClick={e => this.onOpenModalIntegration()}>
                                                <span className="dropdown_normal">
                                                  <i className="fas fa-link text-appColor" /> Connectors
                                        </span>
                                              </DropdownItem>

                                              <DropdownItem
                                                onClick={e => this.onOpenModalStorage()}>
                                                <span className="dropdown_normal">
                                                  <i className="far fa-hdd text-appColor" /> Additional Mounts
                                          </span>
                                              </DropdownItem>
                                            </DropdownMenu>

                                          </UncontrolledDropdown>
                                        </Col>
                                        <Col xs="1" className="mt-3 ">
                                          <i className={this.state.disableicon === true ? " fas fa-history mt-1 disable-icon" : "fas fa-history green-text  mt-1 pointerclass"} title="Version History" id="Version" onClick={e => { e.preventDefault(); this.setState({ showVersion: !this.state.showVersion }); this.callVersion(this.state.showVersion, this.state.setTabIndex, this.state.presentFilePath, this.state.presentStorageName, this.state.presentrootFolder) }}></i>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                            }
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight - 220}>
                                <SplitCells
                                  cellsData={item.content === undefined ? "" : item.content}
                                  cellIndex={index}
                                  fileProperty={this.state.openFiles}
                                  _getSelectedIndex={this._getSelectedIndex.bind(this)}
                                  ref="splitCell"
                                  socketConnection={item.wsState}
                                  storageName={item.stId}
                                  rootFolder={item.rootFolder}
                                  socketStatus={item.wsStatus}
                                  _getCodeChangeIndex={this._getCodeChangeIndex.bind(this)}
                                  _stateValuesUpdate={this._stateValuesUpdate.bind(this)}
                                />
                              </Scrollbars>

                            </TabPanel>
                          } else if (item.type === "csv") {
                            return <TabPanel>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                {item.type === "csv" && <hr></hr>}
                                {item.type === "csv" && <div>
                                  <Row>
                                    <Col xs={12} sm={5}>
                                    </Col>
                                    <Col xs={12} sm={3} className="choosedelimiter" >
                                      <label>Choose File Delimiter</label>
                                    </Col>
                                    <Col xs={12} sm={4}>
                                      <Select name="delimiterName"
                                        value={delimiteroptions.filter(item => item.value === this.state.delimiter)}
                                        options={delimiteroptions} onChange={e => this.handleChangeSelectDelimiter(e, index)} noValidate />
                                    </Col>
                                  </Row>
                                  <HotTable
                                    licenseKey={HandsonTableKey}
                                    data={this.state.wholeGraphData}
                                    colHeaders={true}
                                    rowHeaders={true}
                                    comments={true}
                                    search={true}
                                    dropdownMenu={true}
                                    settings={this.hotformula}
                                    multiColumnSorting={true}
                                    filters={true}
                                    manualRowMove={true}
                                    stretchH='all'
                                    width='100%'
                                    minHeight='300px'
                                  />
                                </div>
                                }
                              </Scrollbars>
                            </TabPanel>
                          } else if (item.type === "others") {
                            return <TabPanel>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                <p className="othersTab">
                                  {item.content === undefined ? "" : item.content}
                                </p>
                                <pre className="codeStyle">
                                  <code className={`language-${item.type}`}>
                                    {item.content === undefined ? "" : item.content}
                                  </code>
                                </pre>
                              </Scrollbars>
                            </TabPanel>
                          } else if ((item.type === "jpeg" || item.type === "jpg" ||
                            item.type === "png" || item.type === "PNG")) {
                            return <TabPanel>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                <div className="text-center">
                                  <br />
                                  <img src={item.content === undefined ? "" : item.content} alt="NoImage" className="modelimg" />
                                </div>
                              </Scrollbars>
                            </TabPanel>
                          } else if ((item.type === "pdf")) {
                            return <TabPanel>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                <div className="text-center">
                                  {item.content !== undefined &&
                                    <PdfViewer myContent={item.content}></PdfViewer>
                                  }
                                </div>
                              </Scrollbars>
                            </TabPanel>
                          } else if ((item.type === "xlsx") || (item.type === "xls")) {
                            return <TabPanel>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                <div>
                                  <ModalTabs onChange={(tabId) => {
                                    this.setState({
                                      activeTab: tabId,
                                    })
                                  }}>
                                    <div className="proj-search">
                                      <ModalTabList>
                                        <Row>
                                          <div className="col-12 proj-tabs">
                                          <label><code>Sheets :</code></label> 
                                          {this.state.sheetName.map((item, index) => (
                                              <ModalTab tabFor={item} className="adddatatab" onClick={e => this.getTabData(item)}> {item}</ModalTab>
                                            ))
                                            }
                                          </div>
                                        </Row>
                                      </ModalTabList>
                                    </div>
                                    <CardBody>
                                      <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}>
                                        <ModalTabPanel tabId={this.state.activeExcel}>
                                            <HotTable
                                              root="hot"
                                              ref={this.hotTableComponent}
                                              data={this.state.hotSettings}
                                              colHeaders={true}
                                              readOnly={this.state.readonlyTable}
                                              rowHeaders={true}
                                              comments={true}
                                              search={true}
                                              dropdownMenu={this.state.contextMenuTable}
                                              multiColumnSorting={true}
                                              filters={true}
                                              settings={this.hotformula}
                                              manualRowMove={true}
                                              contextMenu={this.state.contextMenuTable}
                                              licenseKey={HandsonTableKey}
                                              stretchH="all"
                                              renderer={this.state.rowheader === true ? this.renderer : ""}
                                            />
                                        </ModalTabPanel>
                                      </Scrollbars>

                                    </CardBody>
                                  </ModalTabs>

                                </div>
                              </Scrollbars>
                            </TabPanel>
                          }


                          else if (item.type === "Home") {
                            return <TabPanel>
                              <div className="text-center">
                                <br />
                                {this.state.homecontent}
                              </div>
                            </TabPanel>
                          } else if (item.type === "py") {
                            this.state.code = item.content === undefined ? "" : item.content
                            return <TabPanel >

                              <Row className="stickyposition"><Col className="text-right" >
                                <span title="Save" className="noteToolbar noborder toolclass" onClick={e => this.savePythonFile(this.state.openFiles, item, index)}><i className="fas fa-save ipynbtoolbar" ></i>&nbsp; <b>Save</b></span>
                              </Col></Row>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                <Editor
                                  className="codeStyle"
                                  value={this.state.code}
                                  onValueChange={code => this.onChangeEditor(code, index)}
                                  highlight={code => highlight(code, languages.py)}
                                  padding={10}
                                />
                              </Scrollbars>
                            </TabPanel>

                          }
                          else if (item.type === "log") {
                            return <TabPanel>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                <div className="Code">
                                  <pre><code className="language-py">
                                    {item.content === undefined ? "" : item.content.split("\n").map((i, key) => {
                                      return <div>{i}</div>;
                                    })}
                                  </code></pre>
                                </div>
                              </Scrollbars>
                            </TabPanel>

                          }
                        }

                        )}
                      </Tabs>}

                    </LoadingOverlay>
                    <Modal isOpen={this.state.open} toggle={this.onCloseModal} backdrop="static">
                      <div className="modal-header" toggle={this.onCloseModal}>
                        <h5 className="modal-title pull-left">Create a New Cluster  </h5>
                        <div className="pull-right">
                          <Link to={{ pathname: '/cluster/Create' }}> <Button color="primary" href="#pablo" size="sm" className="newCluster"> New Cluster</Button> </Link>
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                      <div className="reactmodalbody">
                        <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                          <Card className="shadow">
                            <CardBody>
                              <ReactTable
                                data={this.state.modalclusterdetails}
                                columns={this.state.columns}
                                defaultPageSize={10}
                                showPaginationBottom={true}
                                className="-striped -highlight Providerstable"
                              />
                            </CardBody>
                          </Card>
                        </Scrollbars>

                      </div>
                    </Modal>
                    <Modal className="modal-dialogCorner" isOpen={this.state.openIntegration} onClose={this.onCloseModalIntegration}>
                      <div className="modal-header" toggle={this.onCloseModal}>
                        <h5 className="modal-title pull-left">Connectors</h5>
                        <div className="pull-right">
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModalIntegration}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>

                      </div>
                      <ModalBody className="modal-contentCorner">
                        <Row>
                          <Col>
                            <i className="fas fa-sync-alt" id="refreshConnect" onClick={e => this.GetAllConnectors()} style={{ cursor: "pointer", color: '#388fa5', fontSize: '14px', float: "right", marginRight: 10 }}></i>

                            <ModalTabs
                              defaultTab="one"
                            >
                              <ModalTabList>
                                <ModalTab tabFor="one" className="tabcolor font15">Active</ModalTab>
                                {localStorage.getItem("role") !== "DEVELOPER" && <ModalTab tabFor="two" className="tabcolor font15">Browse Connectors</ModalTab>}
                              </ModalTabList>
                              <ModalTabPanel tabId="one">
                                <section className="">
                                  <Col className="" lg="12" md="12">
                                    <Scrollbars autoHeight autoHeightMin={400} thumbMinSize={30} >

                                      {this.state.connectordetails.map((item, index) => (
                                        <Card className="modelproject editorPadding" key={index}>
                                          <CardBody className="pd-6">

                                            <Row key={index} id="activeConnector" onClick={e => this.onCopyConnectorName(item.name)}>
                                              <Col xs="6" className="overflowStyle activeconnectorstyle">
                                                <b className="connlogotext">
                                                  <img id={"row" + index} src={connectorsTypeLogo(item.type)} className="connlogo" alt="" />
                                                &nbsp;{item.name}</b>
                                              </Col>
                                              <Col xs="6" className="endText">
                                              </Col>
                                            </Row>

                                          </CardBody>
                                        </Card>
                                      ))}
                                    </Scrollbars>
                                  </Col>
                                </section>
                              </ModalTabPanel>
                              <ModalTabPanel tabId="two">
                                <Scrollbars autoHeight autoHeightMin={400} thumbMinSize={30} >

                                  <section className="">

                                    <Col className="" lg="12" md="12">
                                      <Row className="mt-12">
                                        <Col className="mb-12 mb-xl-0" xl="12">
                                          <div className="table-responsive">
                                            <Row className="icon-examples strgcard" >
                                              {this.state.connectorList.map((item, index) => (<Col sm={4} key={index} xs={12} className="" >
                                                <span title={item.name}>
                                                  <Col className="text-center" lg="12" md="12" onClick={e => this.AddConnectorConfig(item.name)}>
                                                    <div className="browse-Connector">
                                                      {item.type === "EnvironmentVariable" && <i className="fas fa-cog iconEnvironment"></i>}
                                                      {item.type !== "EnvironmentVariable" && <img src={connectorsTypeLogo(item.type)} alt="ConnectorImage" />}
                                                    </div>
                                                    <div className="grid-browse">{item.name}</div>

                                                  </Col>
                                                </span>
                                              </Col>))}

                                            </Row>

                                          </div>
                                        </Col>
                                      </Row>

                                    </Col>
                                  </section>
                                </Scrollbars>

                              </ModalTabPanel>
                            </ModalTabs>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
                    <Modal className="modal-dialogCorner" isOpen={this.state.openChooseStorage} onClose={this.onCloseModalIntegration}>
                      <div className="modal-header" toggle={this.onCloseModal}>
                        <h5 className="modal-title pull-left"><i className="far fa-hdd text-appColor" /> Additional Mounts</h5>
                        <div className="pull-right">
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>

                      </div>
                      <Scrollbars autoHeight autoHeightMin={400} thumbMinSize={30} >

                        <ModalBody className="modal-contentCorner">
                          <Card>
                            <CardBody className="edge_borderRadius">
                              <MountBucket
                                storageData={this.state.configArray}
                                wholeStorageData={this.state.configArray}
                                activeIndex={this.state.activeIndex}
                                mountType={modelSpaceMount}
                                closeModal={this.onCloseModal}
                              />
                            </CardBody>
                          </Card>
                        </ModalBody>
                      </Scrollbars>
                    </Modal>
                    {/* For Add Buuton */}
                    <Modal isOpen={this.state.open} toggle={this.onCloseModal} backdrop="static">
                      <div className="modal-header" toggle={this.onCloseModal}>
                        <h5 className="modal-title pull-left">Create a New Cluster  </h5>
                        <div className="pull-right">
                          <Link to={{ pathname: '/cluster/Create' }}> <Button color="primary" href="#pablo" size="sm" style={{ marginRight: '35px', marginTop: '-6px' }}> New Cluster</Button> </Link>
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      </div>
                      <div className="reactmodalbody">
                        <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                          <Card className="shadow">
                            <CardBody>
                              <ReactTable
                                data={this.state.modalclusterdetails}
                                columns={this.state.columns}
                                defaultPageSize={10}
                                showPaginationBottom={true}
                                className="-striped -highlight Providerstable"
                              />
                            </CardBody>
                          </Card>
                        </Scrollbars>

                      </div>
                    </Modal>
                    <Modal isOpen={this.state.Addopen} toggle={this.onCloseModal} backdrop="static">
                      {this.state.modaldatafrom === "EnvironmentVariables" &&
                        <div id="EnvironmentVariables">
                          <div className="modal-header" toggle={this.onCloseModal}>
                            <h5 className="modal-title pull-left"><i className="fas fa-cog"></i> &nbsp;Add Environment variables </h5>
                            <div className="pull-right">
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                          </div>
                          <div className="reactmodalbody">
                            <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                              <p>Add passwords, secrets or tokens into your project as environment variables. Add a name to your set of environment variables to simplify the management and sharing with your team.</p>
                              <Form noValidate>
                                <div className="pl-lg-4">
                                  <Row>
                                    <Col lg="6">
                                      <FormGroup>
                                        <label className="form-control-label">
                                          Key
                            </label>
                                        <Input
                                          className="form-control"
                                          placeholder="Key"
                                          name="Key"
                                          value={this.state.key}
                                          type="text"
                                          onChange={this.handleChange} />
                                      </FormGroup>
                                    </Col>
                                    <Col lg="6">
                                      <FormGroup>
                                        <label className="form-control-label">
                                          Value
                            </label>
                                        <Input
                                          className="form-control"
                                          placeholder="Value"
                                          name="kvalue"
                                          value={this.state.kvalue}
                                          type="text"
                                          onChange={this.handleChange} />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <hr className="my-4" />
                                  <Row>
                                    <Col lg="6">
                                      <FormGroup>
                                        <label className="form-control-label">
                                          Integration name *
                            </label>                            <Input
                                          className="form-control"
                                          placeholder="Integration Name"
                                          name="IntegrationName"
                                          value={this.state.integrationname}
                                          type="text"
                                          onChange={this.handleChange} />
                                      </FormGroup>
                                    </Col>

                                  </Row>


                                </div>
                                <hr className="my-4" />
                                <div className="">
                                  <Row>
                                    <Col lg="1">
                                      <FormGroup>
                                        <Button
                                          color="secondary"
                                          size="sm"
                                          onClick={this.cancelClick}
                                        >
                                          Cancel
                     </Button>
                                      </FormGroup>
                                    </Col>
                                    <Col lg="1">
                                      <FormGroup>
                                        <Button
                                          color="primary"
                                          size="sm"
                                          type="submit"
                                        >
                                          Create
                     </Button>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </div>

                              </Form>
                            </Scrollbars>
                          </div>
                        </div>
                      }
                      {this.state.modaldatafrom === "Snowflake" &&
                        <div id="SharedData">
                          <div className="modal-header" toggle={this.onCloseModal}>
                            <h5 className="modal-title pull-left"><img src={connectorsTypeLogo(this.state.modaldatafrom)} className="connlogo" alt="" /> &nbsp;Configure {this.state.connectiontype} </h5>
                            <div className="pull-right">
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                          </div>
                          <div className="reactmodalbody">
                            <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                              <div className=" col" id="errorDiv">

                                {this.state.errorSubmitted &&
                                  <div style={styles.errorBox}>
                                    <span style={styles.error}>{this.state.errorMessage}</span>
                                  </div>
                                }
                                <code><b>Connection Details</b></code>
                                <br></br>
                                <Card className="card-contributions hoverproject">
                                  <CardBody>
                                    <div className="pl-lg-4">
                                      <Row>
                                        <Col md="6">
                                          <Label md="6">Name *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Name"
                                              name="name"
                                              value={this.state.name}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                        <Col md="6">
                                          <Label md="6">Description *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Description"
                                              name="connectordescription"
                                              value={this.state.connectordescription}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col lg="10">
                                          <Label md="2">
                                            Type *
                            </Label>
                                          <FormGroup>
                                            <div className="imgradio">
                                              <Row>
                                                <div className="filepadding">
                                                  <input type="radio" name="connectiontype" id="Snowflakes" className="input-hidden" checked={this.state.connectiontype} value="Snowflake" onChange={this.handleTypeChange} />
                                                  <label for="Snowflakes">
                                                    <img src={connectorsTypeLogo(this.state.modaldatafrom)} alt="Snowflakes" />
                                                  </label>
                                                  <br></br>
                                                  <p className="font12"><b>Snowflake</b></p>
                                                </div>
              &nbsp; &nbsp;
                                            </Row>



                                            </div>
                                          </FormGroup>
                                        </Col>

                                      </Row>
                                    </div>
                                  </CardBody>
                                </Card>
                                <code><b>Connection Credentials</b></code>
                                <br />
                                <Card className="card-contributions hoverproject">
                                  <CardBody>

                                    <Row className="mt-12 strgdetails" >
                                      <Col className="mb-12 mb-xl-0" xl="12">
                                        <Row className="icon-examples strgcard">
                                          <Col lg="4">
                                            <Label md="5"> Server * </Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Server"
                                                name="server"
                                                value={this.state.server}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="5">Warehouse *</Label>
                                            <FormGroup> <Input
                                              className="form-control"
                                              placeholder="Warehouse"
                                              name="warehouse"
                                              value={this.state.warehouse}
                                              type="text"
                                              onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="4">User *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="User"
                                                name="user"
                                                value={this.state.user}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="5">Password *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Password"
                                                name="password"
                                                value={this.state.password}
                                                type="password"
                                                onChange={this.handleChange}>
                                              </Input>

                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="4">Role </Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Role"
                                                name="role"
                                                value={this.state.role}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <code><b>Connection Features</b></code>
                                <br />
                                <Card className="card-contributions hoverproject">
                                  <CardBody>

                                    <Row className="mt-12 strgdetails" >
                                      <Col className="mb-12 mb-xl-0" xl="12">
                                        <Row className="icon-examples strgcard">
                                          <Col lg="6">
                                            <Label md="6"> Connection Timeout</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Connection Timeout"
                                                name="ConnectionTimeout"
                                                value={this.state.connectiontimeout}
                                                type="number"
                                                min="0"
                                                onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                                onChange={this.handlechangeTimeout} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="6">
                                            <Label md="6">Enable write access</Label>
                                            <FormGroup className="marginL10">
                                              <Switch onChange={(el, state) => this.handleSwitch(el, state)} value={this.state.enableWriteAccess} name='write access' data-on-color="secondary" data-off-color="default" />

                                            </FormGroup>
                                          </Col>

                                        </Row>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>

                                <hr className="my-4" />
                                <Row>
                                  <Col lg="1">
                                    <FormGroup>
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.cancelClick}
                                      >
                                        Cancel
                     </Button>
                                    </FormGroup>
                                  </Col>
                                  <Col lg="3">
                                    <FormGroup>
                                      <Button
                                        color="primary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.CreateNewConnection}
                                      >
                                        {this.state.btnActions}
                                      </Button>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      }
                      {this.state.modaldatafrom === "AmazonS3" &&
                        <div id="AmazonS3">
                          <div className="modal-header" toggle={this.onCloseModal}>
                            <h5 className="modal-title pull-left"><img src={connectorsTypeLogo(this.state.modaldatafrom)} className="connlogo" alt="" /> &nbsp;Configure {this.state.connectiontype} </h5>
                            <div className="pull-right">
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                          </div>
                          <div className="reactmodalbody">
                            <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                              <div className=" col" id="errorDiv">

                                {this.state.errorSubmitted &&
                                  <div style={styles.errorBox}>
                                    <span style={styles.error}>{this.state.errorMessage}</span>
                                  </div>
                                }
                                <code><b>Connection Details</b></code>
                                <br></br>
                                <Card className="card-contributions hoverproject">
                                  <CardBody>
                                    <div className="pl-lg-4">
                                      <Row>
                                        <Col md="6">
                                          <Label md="6">Name *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Name"
                                              name="name"
                                              value={this.state.name}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                        <Col md="6">
                                          <Label md="6">Description *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Description"
                                              name="connectordescription"
                                              value={this.state.connectordescription}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                      </Row>

                                      <Row>

                                        <Col lg="10">
                                          <Label md="2">
                                            Type *
                            </Label>
                                          <FormGroup>
                                            <div className="imgradio">
                                              <Row>
                                                <div className="marginL20">
                                                  <input type="radio" name="connectiontype" id="AmazonS3" className="input-hidden" checked={this.state.connectiontype} value="AmazonS3" onChange={this.handleTypeChange} />
                                                  <label for="AmazonS3">
                                                    <img src={connectorsTypeLogo(this.state.modaldatafrom)} alt="AmazonS3" />
                                                  </label>
                                                  <br></br>
                                                  <p style={{ fontSize: '12px' }}><b>Amazon S3</b></p>
                                                </div>
              &nbsp; &nbsp;
                                            </Row>



                                            </div>
                                          </FormGroup>
                                        </Col>

                                      </Row>
                                    </div>
                                  </CardBody>
                                </Card>
                                <code><b>Connection Credentials</b></code>
                                <br />
                                <Card className="card-contributions hoverproject">
                                  <CardBody>

                                    <Row className="mt-12 strgdetails" >
                                      <Col className="mb-12 mb-xl-0" xl="12">
                                        <Row className="icon-examples strgcard">
                                          <Col>
                                            <Label> Bucket Name * </Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Bucket Name"
                                                name="bucketName"
                                                value={this.state.bucketName}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col>
                                            <Label>Access Key *</Label>
                                            <FormGroup> <Input
                                              className="form-control"
                                              placeholder="Access Key"
                                              name="accessKey"
                                              value={this.state.accessKey}
                                              type="text"
                                              onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col>
                                            <Label>Secret Key *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Secret Key"
                                                name="secretKey"
                                                value={this.state.secretKey}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>

                                <hr className="my-4" />
                                <Row>
                                  <Col lg="1">
                                    <FormGroup>
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.cancelClick}
                                      >
                                        Cancel
                     </Button>
                                    </FormGroup>
                                  </Col>
                                  <Col lg="3">
                                    <FormGroup>
                                      <Button
                                        color="primary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.CreateNewConnection}
                                      >
                                        {this.state.btnActions}
                                      </Button>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      }
                      {this.state.modaldatafrom === "MongoDB" &&
                        <div id="MongoDB">
                          <div className="modal-header" toggle={this.onCloseModal}>
                            <h5 className="modal-title pull-left"><img src={connectorsTypeLogo(this.state.modaldatafrom)} className="connlogo" alt="" /> &nbsp;Configure {this.state.connectiontype} </h5>
                            <div className="pull-right">
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                          </div>
                          <div className="reactmodalbody">
                            <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                              <div className=" col" id="errorDiv">

                                {this.state.errorSubmitted &&
                                  <div style={styles.errorBox}>
                                    <span style={styles.error}>{this.state.errorMessage}</span>
                                  </div>
                                }
                                <code><b>Connection Details</b></code>
                                <br></br>
                                <Card className="card-contributions hoverproject">
                                  <CardBody>
                                    <div className="pl-lg-4">
                                      <Row>
                                        <Col md="6">
                                          <Label md="6">Name *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Name"
                                              name="name"
                                              value={this.state.name}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                        <Col md="6">
                                          <Label md="6">Description *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Description"
                                              name="connectordescription"
                                              value={this.state.connectordescription}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col lg="10">
                                          <Label md="2">
                                            Type *
                            </Label>
                                          <FormGroup>
                                            <div className="imgradio">
                                              <Row>
                                                <div className="marginL20">
                                                  <input type="radio" name="connectiontype" id="MongoDB" className="input-hidden" checked={this.state.connectiontype} value="MongoDB" onChange={this.handleTypeChange} />
                                                  <label for="MongoDB">
                                                    <img src={connectorsTypeLogo(this.state.modaldatafrom)} alt="MongoDB" />
                                                  </label>
                                                  <br></br>
                                                  <p style={{ fontSize: '12px' }}><b>MongoDB</b></p>
                                                </div>
                                              &nbsp; &nbsp;
                                            </Row>



                                            </div>
                                          </FormGroup>
                                        </Col>

                                      </Row>
                                    </div>
                                  </CardBody>
                                </Card>
                                <code><b>Connection Credentials</b></code>
                                <br />
                                <Card className="card-contributions hoverproject">
                                  <CardBody>

                                    <Row className="mt-12 strgdetails">
                                      <Col className="mb-12 mb-xl-0" xl="12">
                                        <Row className="icon-examples strgcard">
                                          <Col lg="4">
                                            <Label md="5"> Host * </Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Host"
                                                name="host"
                                                value={this.state.host}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="5">Port *</Label>
                                            <FormGroup> <Input
                                              className="form-control"
                                              placeholder="Port"
                                              name="port"
                                              value={this.state.port}
                                              type="text"
                                              onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="4">User *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="User"
                                                name="user"
                                                value={this.state.user}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="5">Password *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Password"
                                                name="password"
                                                value={this.state.password}
                                                type="password"
                                                onChange={this.handleChange}>
                                              </Input>

                                            </FormGroup>
                                          </Col>
                                          <Col lg="5">
                                            <Label md="5">Database *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Database"
                                                name="database"
                                                value={this.state.database}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>

                                <hr className="my-4" />
                                <Row>
                                  <Col lg="1">
                                    <FormGroup>
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.cancelClick}
                                      >
                                        Cancel
                     </Button>
                                    </FormGroup>
                                  </Col>
                                  <Col lg="3">
                                    <FormGroup>
                                      <Button
                                        color="primary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.CreateNewConnection}
                                      >
                                        {this.state.btnActions}
                                      </Button>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      }
                      {this.state.modaldatafrom === "DataLake" &&
                        <div id="SharedData">
                          <div className="modal-header" toggle={this.onCloseModal}>
                            <h5 className="modal-title pull-left"><img src={connectorsTypeLogo(this.state.modaldatafrom)} className="connlogo" alt="" /> &nbsp;Configure {this.state.connectiontype} </h5>
                            <div className="pull-right">
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                          </div>
                          <div className="reactmodalbody">
                            <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                              <div className=" col" id="errorDiv">

                                {this.state.errorSubmitted &&
                                  <div style={styles.errorBox}>
                                    <span style={styles.error}>{this.state.errorMessage}</span>
                                  </div>
                                }
                                <code><b>Connection Details</b></code>
                                <br></br>
                                <Card className="card-contributions hoverproject">
                                  <CardBody>
                                    <div className="pl-lg-4">
                                      <Row>
                                        <Col md="6">
                                          <Label md="6">Name *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Name"
                                              name="name"
                                              value={this.state.name}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                        <Col md="6">
                                          <Label md="6">Description *</Label>
                                          <FormGroup>
                                            <Input
                                              className="form-control"
                                              placeholder="Description"
                                              name="connectordescription"
                                              value={this.state.connectordescription}
                                              type="text"
                                              onChange={this.handleChange} />
                                          </FormGroup>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col lg="10">
                                          <Label md="2">Type *</Label>
                                          <FormGroup>
                                            <div className="imgradio">
                                              <Row>
                                                <div className="marginL20">
                                                  <input type="radio" name="connectiontype" id="Snowflakes" className="input-hidden" checked={this.state.connectiontype} value="Snowflake" onChange={this.handleTypeChange} />
                                                  <label for="Snowflakes">
                                                    <img src={connectorsTypeLogo(this.state.modaldatafrom)} alt="Snowflakes" />
                                                  </label>
                                                  <br></br>
                                                  <p style={{ fontSize: '12px' }}><b>DataLake</b></p>
                                                </div>
              &nbsp; &nbsp;
                                            </Row>



                                            </div>
                                          </FormGroup>
                                        </Col>

                                      </Row>
                                    </div>
                                  </CardBody>
                                </Card>
                                <code><b>Connection Credentials</b></code>
                                <br />
                                <Card className="card-contributions hoverproject">
                                  <CardBody>
                                    <Row className="mt-12" style={{ paddingRight: 10 }}>
                                      <Col className="mb-12 mb-xl-0" xl="12">
                                        <Row className="icon-examples" style={{ marginTop: 10 }}>
                                          <Col lg="4">
                                            <Label md="5"> Blob Name * </Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Blob Name"
                                                name="dataLake_blobName"
                                                value={this.state.dataLake_blobName}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="6">Account Key *</Label>
                                            <FormGroup> <Input
                                              className="form-control"
                                              placeholder="Account Key"
                                              name="dataLake_accountKey"
                                              value={this.state.dataLake_accountKey}
                                              type="text"
                                              onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="5">Sas Key *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Sas Key"
                                                name="dataLake_sasKey"
                                                value={this.state.dataLake_sasKey}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="5">Schema *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Schema"
                                                name="dataLakeSchema"
                                                value={this.state.dataLakeSchema}
                                                type="text"
                                                onChange={this.handleChange}>
                                              </Input>

                                            </FormGroup>
                                          </Col>
                                          <Col lg="4">
                                            <Label md="5">Url *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Url"
                                                name="dataLake_url"
                                                value={this.state.dataLake_url}
                                                type="text"
                                                onChange={this.handleChange} />
                                            </FormGroup>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <hr className="my-4" />
                                <Row>
                                  <Col lg="1">
                                    <FormGroup>
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.cancelClick}
                                      >
                                        Cancel
                     </Button>
                                    </FormGroup>
                                  </Col>
                                  <Col lg="3">
                                    <FormGroup>
                                      <Button
                                        color="primary"
                                        size="sm"
                                        type="submit"
                                        onClick={this.CreateNewConnection}
                                      >
                                        {this.state.btnActions}
                                      </Button>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>
                            </Scrollbars>
                          </div>
                        </div>
                      }
                      {this.state.modaldatafrom === "GoogleDrive" &&
                        <div id="GoogleDrive">
                          <div className="modal-header" toggle={this.onCloseModal}>
                            <h5 className="modal-title pull-left"><i className="fas fa-cog"></i> &nbsp;Connect to Google Drive </h5>
                            <div className="pull-right">
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                          </div>
                          <div className="reactmodalbody">
                            <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                              <p>To connect Google Drive, first you need to authorize your Google Drive <account className="mq">  </account></p>
                              <Form noValidate>
                                <div className="pl-lg-4">
                                  <Row>
                                    <Col lg="6">
                                      <FormGroup>
                                        <Button
                                          color="primary"
                                          size="sm"
                                        >
                                          Authorize Google Drive
                      </Button>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <hr className="my-4" />
                                  <Row>
                                    <Col lg="6">
                                      <FormGroup>
                                        <label className="form-control-label">
                                          Integration name *
                            </label>
                                        <Input
                                          className="form-control"
                                          placeholder="Integration Name"
                                          name="IntegrationName"
                                          value={this.state.integrationname}
                                          type="text"
                                          onChange={this.handleChange} />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </div>
                                <hr className="my-4" />
                                <div className="pull-right">
                                  <Row>
                                    <Col lg="2">
                                      <FormGroup>
                                        <Button
                                          color="primary"
                                          size="sm"
                                          type="submit"
                                        >
                                          Create
                     </Button>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </div>
                              </Form>
                            </Scrollbars>
                          </div>
                        </div>
                      }
                    </Modal>
                    {/* Delete Modal */}
                    <Modal isOpen={this.state.deleteopen} toggle={this.CloseDeleteConnectorModal} className="delete-modal"
                      backdrop="static">
                      <div className="modal-header" toggle={this.CloseDeleteConnectorModal}>
                        <h5 className="modal-title pull-left">Delete Connector </h5>
                      </div>
                      <div className="reactmodalbody">
                        <p> Are you sure to delete this connector? - <b>{this.state.deletename}</b></p>
                        <hr className="my-1" />
                        <Row style={{ maxHeight: '30px' }}>
                          <Col lg="2">
                            <FormGroup>
                              <Button
                                color="primary"
                                size="sm"
                                type="submit"
                                onClick={e => this.DeleteConnector(this.state.deleteid)}
                              >
                                Delete
                     </Button>
                            </FormGroup>
                          </Col>
                          <Col lg="2">
                            <FormGroup>
                              <Button
                                color="secondary"
                                size="sm"
                                type="submit"
                                onClick={this.CloseDeleteConnectorModal}
                              >
                                Cancel
                     </Button>
                            </FormGroup>

                          </Col>
                        </Row>

                      </div>
                    </Modal>
                    <Modal
                      centered
                      className="upload-modal"
                      isOpen={this.state.showFilesModal}
                      toggle={this.toggleShowFiles}
                      backdrop="static"
                      returnFocusAfterClose={false}
                    >
                      <ModalHeader toggle={this.toggleShowFiles}>Select Folder</ModalHeader>
                      <ModalBody>
                        <Col xs={12} md="12">
                          <Row>
                            <div className="col">
                              <div className="logo-and-nav-wrap">
                                <div className="site-nav-wrap">
                                  <div className="navss">
                                    {this.state.storageNavigations}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Row>
                          <Row className="border-top">
                            <Col sm={12} md={3} xl={3} lg={3} style={{ borderRight: "1px solid #d3d3d3" }}>
                              <div>
                                 {this.state.configArray.map((item, index) => (item.storageStatus === "ENABLED" && <div key={index} className="card-plain">
                                  <CardHeader key={index} role="tab"
                                    className={item.name === this.state.activeConfigPath ? "activeStorageConfig" : ""}>
                                    <a
                                      aria-expanded={this.state.openedCollapses.includes(
                                        "collapseModelspace_Popup" + index
                                      )}
                                      href="#pablo"
                                      data-parent="#accordion"
                                      data-toggle="collapse"
                                      onClick={e => {
                                        e.preventDefault();
                                        this.collapsesToggle("collapseModelspace_Popup" + index);
                                      }}
                                    >
                                      <Row>
                                        <Col xs={item.name === default_StorageName ? "12" : "8"}>
                                          <span title={item.name} className="overflowStyle" style={{ fontSize: 14, color: "#525f7f" }} onClick={e => { this.onBucketNameClick_Popup(item, item.name) }}>
                                            {item.name === default_StorageName && <img src={provisionerTypeLogo(undefined)} className="imgStorageList" alt="aws" />}
                                            {item.name !== default_StorageName && <img src={provisionerTypeLogo(item.provisionerType)} className="imgStorageList" alt="aws" />}
                                &nbsp;{item.name === default_StorageName ? default_LabelStorageName : item.name}
                                          </span>
                                        </Col>
                                        {item.name !== default_StorageName && <Col xs="2">
                                          <i className="now-ui-icons arrows-1_minimal-down" style={{
                                            marginTop: 3, marginLeft: "-14px"
                                          }} />
                                        </Col>}


                                      </Row>
                                    </a>
                                  </CardHeader>
                                  <Collapse
                                    role="tabpanel"
                                    isOpen={this.state.openedCollapses.includes(
                                      "collapseModelspace_Popup" + index
                                    )}
                                  >
                                    {item.storageConfig !== null && item.storageConfig.bucketStorages.map((cItem, index) => (<CardBody className="p-2" key={index}>
                                      <Row>
                                        <Col lg="12">
                                          <span style={{ marginLeft: 17 }} className={this.state.selectedStorage === cItem.bucketName ? "activeBucket" : ""} onClick={e => { this.onBucketNameClick_Popup(item, cItem) }}>
                                            <img src={awsbucket} className="imgBucket" alt="aws" /><span title={cItem.bucketName} className="bucketListView">{cItem.bucketName}</span></span>

                                        </Col>
                                      </Row>
                                    </CardBody>))}
                                  </Collapse>


                                </div>))}
                                {/* </Scrollbars>    */}
                              </div>
                            </Col>
                            <Col sm={12} md={9} xl={9} lg={9}>
                              <Scrollbars autoHeight autoHeightMin={this.state.sheight - 220} onScroll={this.handleScroll}>
                                <AddStorageItems
                                  folders={this.state.folders}
                                  files={this.state.files}
                                  showFilesModal={this.state.showFilesModal}
                                  fetchStorageItems={this.fetchStorageItems}
                                  loadmoreFlag={this.state.loadmoreFlag}
                                  nextPageToken={this.state.nextPageToken}
                                  previewFile={this.previewFile}
                                  loadflagStorage={this.state.loadflagStorage}
                                  currFolder={this.state.currFolder}
                                  pasteFolder={this.pasteFolder}
                                  selectMoveFile={this.selectMoveFile}
                                  selectCopyFile={this.selectCopyFile}
                                  renameFile={this.renameFile}
                                  refreshstorage={this.refreshstorage}
                                  fetchProgress={this.fetchProgress}
                                  sourceStorageId={this.state.sourceStorageId}
                                  sourceRootFolder={this.state.sourceRootFolder}
                                  configArray={this.state.configArray}
                                  progressmsg={this.state.progressmsg}
                                />
                              </Scrollbars>
                            </Col>
                          </Row>
                        </Col>
                      </ModalBody>
                      <ModalFooter>
                        <br></br>
                        <Col xs={12} md="12">
                          <Row>
                            <div className="col text-left">
                              {this.state.showbutton === "Move" &&
                                <Col className="movepopHint">
                                  <span className="notepopHint">Note: </span><span>Update reference of 'Moved' folder/file in Project</span>
                                </Col>
                              }&nbsp;
              </div>
                            <div className="col text-right">
                              <Button color="secondary" onClick={e => this.cancelMove()}>Cancel</Button>{' '}
                              {this.state.showbutton === "Move" &&
                                <Button color="primary" onClick={e => this.moveFolder()} >Move</Button>
                              }&nbsp;
                  {this.state.showbutton === "Copy" &&
                                <Button color="primary" onClick={e => this.copyFolder()} >Copy</Button>
                              }&nbsp;

              </div>
                          </Row>
                        </Col>
                      </ModalFooter>
                    </Modal>
                    <Modal
                      centered
                      style={{ width: "18%" }}
                      isOpen={this.state.codeChangeShowModal}
                      toggle={this.togglecodeChangeShowModal}
                      backdrop="static"
                      returnFocusAfterClose={false}
                    >
                      <ModalHeader toggle={this.togglecodeChangeShowModal}>Save Changes&nbsp;<i className="fas fa-exclamation"></i></ModalHeader>
                      <ModalBody>
                        <Row xs="12">
                          <Col lg="12" className="text-center">
                            <span className="font-weight-bold">Do you want to save the changes you made to  <i>{this.state.codeChangeFileName} ?</i></span><br />
                            <span> Your changes will be lost if you don't save notebook.</span>
                          </Col>
                        </Row>
                        <Row>
                          <Col xl="12">
                            <FormGroup>
                              <Button
                                className="df-btn-primary btn-block"
                                size="sm"
                                type="submit"
                                onClick={e => this.onSaveContent()}
                              >
                                <i className="fas fa-save"></i>&nbsp; Save
                        </Button>
                            </FormGroup>
                          </Col>

                          <Col xl="12" >
                            <FormGroup>
                              <Button
                                className="df-btn-danger btn-block"
                                size="sm"
                                type="submit"
                                onClick={e => this.onClickDontSave()}
                              >
                                Discard
                        </Button>
                            </FormGroup>
                          </Col>

                          <Col xl="12">
                            <FormGroup>
                              <Button
                                className="df-btn-secondary btn-block"
                                size="sm"
                                type="submit"
                                onClick={this.togglecodeChangeShowModal}
                              >
                                Cancel
                        </Button>
                            </FormGroup>
                          </Col>
                        </Row>

                      </ModalBody>
                    </Modal>
                    <Modal
                      centered
                      className=""
                      style={{ width: "31%" }}
                      isOpen={this.state.showConfirmationCopyMove}
                      toggle={this.toggleConfirmationCopyMove}
                      backdrop="static"
                      returnFocusAfterClose={false}
                    >
                      <ModalHeader toggle={this.toggleConfirmationCopyMove}>Already exists&nbsp;<i className="fas fa-exclamation"></i></ModalHeader>
                      <ModalBody>
                        <Col xs={12} md="12">
                          <Row xs="12">
                            <Col lg="12">
                              <span>Do you want to  <b><i>{this.state.modeTransfer.toLowerCase()}</i></b> with <b><i>new name?</i></b></span>
                            </Col>
                          </Row>

                          <Row xs="12">
                            <Col lg="12">
                              <Input
                                placeholder="New Name"
                                name="renameNewValue"
                                className="inputRenameDesign"
                                value={this.state.renameNewValue}
                                onChange={this.handleChange}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col lg="6">
                              <FormGroup>
                                <Button
                                  color="secondary"
                                  size="sm"
                                  type="submit"
                                  onClick={this.toggleConfirmationCopyMove}
                                >
                                  Cancel
                        </Button>
                              </FormGroup>
                            </Col>

                            <Col lg="6" style={{ textAlign: "end", justifyContent: "end" }}>
                              <FormGroup>
                                <Button
                                  color="primary"
                                  size="sm"
                                  type="submit"
                                  onClick={e => this.renameCopyMoveUpdate(e)}
                                >
                                  {this.state.modeTransfer === 'Copy'
                                    ? <i className="fas fa-copy"></i>
                                    : <i className="fas fa-file-export"></i>
                                  }&nbsp;{this.state.modeTransfer}
                                </Button>
                              </FormGroup>
                            </Col>
                          </Row>

                        </Col>
                      </ModalBody>
                    </Modal>
                    <Modal
                      centered
                      className="rename-modal"
                      isOpen={this.state.showCopyMoveActionModal}
                      toggle={this.toggleRenameCopyMoveAction}
                      backdrop="static"
                      returnFocusAfterClose={false}>
                      <ModalHeader toggle={this.toggleRenameCopyMoveAction}>New Name</ModalHeader>
                      <ModalBody>
                        <Input
                          placeholder="New Name"
                          name="renameNewValue"
                          className="inputRename"
                          value={this.state.renameNewValue}
                          onChange={this.handleChange}
                        />
                        <Row>
                          <Col sm="12" className="renamepopHint">
                            <span className="notepopHint">Note: </span><span> Update reference of 'Renamed' folder/file in Project</span>
                          </Col>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <FormGroup>
                              <Button
                                className="df-btn-primary btn-block"
                                size="sm"
                                type="submit"
                                onClick={e => this.renameCopyMoveUpdate(e)}
                              >
                                Ok
                      </Button>
                            </FormGroup>
                          </Col>
                        </Row>

                      </ModalBody>
                    </Modal>
                    <Modal size="xl" className="add-storage-item-modal ModalWidth" isOpen={this.state.showUploadModal}
                      toggle={this.toggleUploadModal} backdrop="static" returnFocusAfterClose={false}>
                      <Card className="shadow">
                        <CardBody>
                          <ModalTabs defaultTab="Upload" onChange={(tabId) => { }}>
                            <ModalTabList>
                              <Row>
                                <div className="col">
                                  <ModalTab tabFor="Upload" className="adddatatab"><i className="fas fa-file-upload"></i>&nbsp; Upload</ModalTab>
                                  <ModalTab tabFor="Github" className="adddatatab" disabled><i className="fab fa-github"></i>&nbsp; Github</ModalTab>
                                  <ModalTab tabFor="Examples" className="adddatatab" disabled><i className="fab fa-wpforms"></i>&nbsp; Examples</ModalTab>

                                </div>
                                <div className="col text-right">
                                  <span className="actionicon" onClick={e => this.cancelUploadModal()}>
                                    <i className="fas fa-times text-red mr-3"></i>
                                  </span>
                                </div>
                              </Row>
                            </ModalTabList>
                            <ModalTabPanel tabId="Upload">
                              <ModalBody>
                                <Scrollbars autoHeight autoHeightMin={400}>
                                  <CardBody>
                                    <div className="clearfix">
                                      <Row>
                                        <Col md="12" xs="12">
                                          <br></br>
                                          <br></br>
                                          <input type="file" accept=".ipynb" onChange={this.handleipynbfile} />
                                          <br></br>
                                          <br></br>
                                          <br></br>
                                          <br></br>
                                          <Progress completed={this.state.progress} />
                                        </Col>
                                      </Row>
                                    </div>
                                  </CardBody>
                                </Scrollbars>
                              </ModalBody>
                            </ModalTabPanel>
                            <ModalTabPanel tabId="Recents">
                              <p>Github</p>
                            </ModalTabPanel>
                            <ModalTabPanel tabId="Examples">
                              <br></br>
                              <p>Examples</p>
                            </ModalTabPanel>
                          </ModalTabs>
                        </CardBody>
                      </Card>
                    </Modal>
                    <Modal
                      centered
                      className="rename-modal"
                      isOpen={this.state.showSaveModal}
                      toggle={this.toggleSaveModal}
                      backdrop="static"
                      returnFocusAfterClose={false}>
                      <ModalHeader toggle={this.toggleSaveModal}>Comments to Save</ModalHeader>
                      <ModalBody>
                        <div>
                          <Input
                            type="textarea"
                            placeholder="Comments to Save"
                            name="commentstosave"
                            className="inputRename"
                            maxLength="100"
                            value={this.state.savecomments}
                            onChange={this.saveCommentschange}
                          />
                          <Row>
                            <Col sm={12} lg={12} xl={12}>
                              <span className="notepopHint">Note: </span><span className="notetxt"> <code>Comments should be more than 4 characters and less than 100 characters</code></span>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12} lg={12} xl={12}>
                              {this.state.showSavebutton === true &&
                                <Button
                                  size="sm"
                                  color="primary"
                                  className="storage-folder-btn renameBtn"
                                  onClick={e => this.SaveFileForVersion()}
                                >
                                  Save
                                </Button>
                              }
                            </Col>
                          </Row>
                        </div>
                      </ModalBody>
                    </Modal>

                  </Col>
                  {this.state.showVersion === true && this.state.presentType === "ipynb" &&
                    <Col xs={12} sm={this.state.showVersion === true ? 2 : 7} className="versionborder">
                      <ul className="list-group">
                        <li className="list-group-item">
                          <Row>
                            <Col xs={12}>
                              <span> <i className="fa fa-angle-double-right mr-2 text-right pointerclass" onClick={e => { this.setState({ showVersion: !this.state.showVersion }); this.callVersion(this.state.showVersion, this.state.setTabIndex, this.state.presentFilePath, this.state.presentStorageName, this.state.presentrootFolder); }}></i>
                                <b className="pl-1">Version History</b></span>
                            </Col>
                          </Row>
                        </li>
                      </ul>
                      <ul className="list-group">
                        <li className={this.state.showOriginal === true ? "list-group-item active" : "list-group-item"}>
                          <span className="storage-file" onClick={e => { this.renderOriginal(); this.showOriginal() }}><b><i className="fas fa-caret-right"></i> &nbsp;View Latest File</b></span>
                        </li>
                      </ul>
                      <Versioning update={this.updateState} versionValue={this.state.versionValue} listversion={this.state.listversion} fileName={this.state.presentFilePath} storageId={this.state.presentStorageName} rootFolder={this.state.presentrootFolder} parentCallback={this.callVersion} ></Versioning>


                    </Col>
                  }

                </Row>
              </div>
            </CardBody>
          </Card>
        </div>
      </>
      // </LoadingOverlay>
    );
  }
}

export default NewModel;
